// MATCHES
// Support für IE 9+, Edge und Android bis Version 4.4.4
// -------------------------------------------------------------------------------------------------

(function() {
    if (!Element.prototype.matches) {
        var matches = function(selector) {
          return (this.matchesSelector || this.msMatchesSelector || this.webkitMatchesSelector).call(this, selector);
        };

        Element.prototype.matches = matches;
    }
})();


// SVG4EVERYBODY
// SVG-Support für alle IE-Versionen
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    /* jshint nocomma: false */

    function embed(svg, g) {
        if (g) {
            var viewBox  = !svg.getAttribute('viewBox') && g.getAttribute('viewBox'),
                fragment = document.createDocumentFragment(), clone = g.cloneNode(!0);

            for (viewBox && svg.setAttribute('viewBox', viewBox); clone.childNodes.length;) {
                fragment.appendChild(clone.firstChild);
            }

            svg.appendChild(fragment);
        }
    }

    function loadreadystatechange(xhr) {
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                var x = document.createElement('x');

                x.innerHTML = xhr.responseText, xhr.s.splice(0).map(function(array) {
                    embed(array[0], x.querySelector('#' + array[1].replace(/(\W)/g, '\\$1')));
                });
            }
        }, xhr.onreadystatechange();
    }

    function svg4everybody() {
        var $uses                 = document.getElementsByTagName('use'),
            polyfill              = /\bFirefox\b|\bEdge\b|\bTrident\/[567]\b|\bVersion\/7.0 Safari\b/.test(navigator.userAgent) || (navigator.userAgent.match(/AppleWebKit\/(\d+)/) || [])[1] < 537,
            requestAnimationFrame = window.requestAnimationFrame || setTimeout,
            $svgCache             = {};

        function oninterval() {
            for (var use, svg, i = 0; i < $uses.length;) {
                if (use = $uses[i], svg = use.parentNode, svg && /svg/i.test(svg.nodeName)) {
                    var src      = use.getAttribute('xlink:href'),
                        $url     = src.split('#'),
                        url_root = $url[0],
                        url_hash = $url[1];

                    if (svg.removeChild(use), url_root.length) {
                        var xhr = $svgCache[url_root] = $svgCache[url_root] || new XMLHttpRequest();
                        xhr.s || (xhr.s = [], xhr.open('GET', url_root), xhr.send()), xhr.s.push([ svg, url_hash ]),
                        loadreadystatechange(xhr);
                    }
                    else {
                        embed(svg, document.getElementById(url_hash));
                    }
                } else {
                    i += 1;
                }
            }
            requestAnimationFrame(oninterval, 17);
        }

        if (polyfill) {
            oninterval();
        }
    }

    svg4everybody();
}(document, window));

// HELPERS
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var $helpers,
        $$;

    // Interne Funktion

    function _is_document($node) {
        return $node !== null && $node.nodeType === $node.DOCUMENT_NODE;
    }

    function _is_window($node) {
        return $node !== null && $node === window;
    }

    function _is_array($obj) {
        return Object.prototype.toString.call($obj) === '[object Array]';
    }

    function _is_input($node) {
        return $node.tagName === 'INPUT' ||
               $node.tagName === 'SELECT' ||
               $node.tagName === 'TEXTAREA';
    }

    function _query(selector, context) {
        var simpleRe = /^(#?[\w-]+|\.[\w-.]+)$/,
            periodRe = /\./g,
            slice    = [].slice,
            $nodes;

        if (simpleRe.test(selector)) {
            switch(selector[0]) {
                case '#':
                    $nodes = context.getElementById(selector.substr(1));
                    break;
                case '.':
                    $nodes = slice.call(context.getElementsByClassName(selector.substr(1).replace(periodRe, ' ')));
                    break;
                default:
                    $nodes = slice.call(context.getElementsByTagName(selector));
            }
        }
        else {
            $nodes = slice.call(context.querySelectorAll(selector));
        }

        return $nodes ? (_is_array($nodes) ? $nodes : [$nodes]) : [];
    }

    function _get_filtered_nodes($nodes, selector) {
        var $filtered_nodes = [];

        for (var i = 0, len = $nodes.length; $nodes !== null && (i < len); i++) {
            if ($nodes[i].nodeType === 1) {
                if (typeof selector === 'undefined') {
                    $filtered_nodes.push($nodes[i]);
                }
                else if($nodes[i].tagName.toLowerCase() === selector) {
                    $filtered_nodes.push($nodes[i]);
                }
            }
        }

        return $filtered_nodes;
    }

    function _create_element(html) {
        var $div = document.createElement('div');

        $div.innerHTML = html.trim(); // textContent/nodeValue funktionieren hier nicht,
                                      // Bug bei Popups: http://stackoverflow.com/a/25896886

        return _get_filtered_nodes($div.childNodes);
    }

    function _get_scroll_offset($node) {
        var top,
            left;

        if (_is_window($node)) {
            if (window.pageXOffset !== null) {
                top  = window.pageYOffset;
                left = window.pageXOffset;
            }
        }
        else {
            top  = $node.scrollTop;
            left = $node.scrollLeft;
        }

        return {
            top  : top,
            left : left
        };
    }

    function _get_vendor_property(property) {
        var css_prefixes = ['Moz', 'ms', 'Webkit'],
            $div         = document.createElement('div');

        if (property in $div) {
            return property;
        }

        var cap_name  = property.charAt(0).toUpperCase() + property.slice(1),
            orig_name = property;

        for (var i = css_prefixes.length; i > 0; i--) {
            property = css_prefixes[i] + cap_name;

            if (property in $div.style) {
                return property;
            }
        }

        return orig_name;
    }

    function _camel_case_property(property) {
        return property.replace(/-([\da-z])/gi, function(all, letter) {
            return letter.toUpperCase();
        });
    }

    function _get_prefixed_event(type, $types) {
        var $div      = document.createElement('div').style,
            $prefixes = ['', 'Moz', 'ms', 'Webkit'],
            prefix;

        for (var i = 0, len = $prefixes.length; i < len; i++) {
            prefix = $prefixes[i] + type.charAt(0).toUpperCase() + type.substr(1, type.length - 4);

            if (prefix in $div) {
                return $types[prefix];
            }
        }

        return type;
    }

    function _get_event_type_wheel(type) {
        return type === 'wheel' ? 'onwheel' in document || document.documentMode >= 9 ? 'wheel' : 'mousewheel' : type;
    }

    function _get_event_type_animatedend(type) {
        return _get_prefixed_event(type, {
            'animation'       : 'animationend',
            'MozAnimation'    : 'animationend',
            'WebkitAnimation' : 'webkitAnimationEnd',
            'msAnimation'     : 'MSAnimationEnd'
        });
    }

    function _get_event_type_transitionend(type) {
        return _get_prefixed_event(type, {
            'transition'       : 'transitionend',
            'MozTransition'    : 'transitionend',
            'WebkitTransition' : 'webkitTransitionEnd',
            'msTransition'     : 'MSTransitionEnd'
        });
    }

    function _get_event_type(type) {
        type = _get_event_type_animatedend(type) || _get_event_type_transitionend(type);
        type = _get_event_type_wheel(type);

        return type;
    }

    // Erstellt Helpers Object

    $$ = function(selector, context) {
        context = context || document;
        return new $helpers(selector, context);
    };

    $helpers = function(selector, context) {
        var _this  = this,
            $nodes = [];

        if (selector) {
            if (typeof selector === 'string') {
                selector = selector.trim();

                if (/<[a-z][\s\S]*>/i.test(selector)) {
                    $nodes = _create_element(selector);
                }
                else {
                    $nodes = _query(selector, context);
                }
            }
            else if (_is_array(selector)) {
                $nodes = selector;
            }
            else {
                $nodes = [selector];
            }
        }

        for (var i = 0, len = $nodes.length; i < len; i++) {
            _this[i] = $nodes[i];
        }

        _this.length = $nodes.length;

        return _this;
    };

    // Helpers API

    $helpers.prototype = {
        is_helper: true,

        find: function(selector) {
            var $this  = this,
                $nodes = [],
                context;

            if ($this.length !== 0) {
                if ($this.length === 1) {
                    $nodes = _query(selector, $this[0]);
                }
                else {
                    for (var i = 0, len = $this.length; i < len; i++) {
                        $nodes = $nodes.concat(
                            _query(selector, $this[i])
                        );
                    }

                    $nodes = $nodes.reduce(function(a, b) {
                        if (a.indexOf(b) < 0) {
                            a.push(b);
                        }

                        return a;
                    }, []);
                }
            }

            return $$($nodes, context);
        },

        children: function(selector) {
            var $this                 = this,
                $filtered_child_nodes = [],
                $child_node;

            for (var i = 0, len = $this.length; i < len; i++) {
                $child_node = this[i].firstChild;

                while ($child_node) {
                    if ($child_node.nodeType === 1 && $child_node.matches(selector)) {
                        $filtered_child_nodes.push($child_node);
                    }

                    $child_node = $child_node.nextSibling;
                }
            }

            return $$($filtered_child_nodes);
        },

        get_parent: function(selector) {
            var $this = this,
                maybe_class,
                name_only,
                tag_name,
                class_name,
                $obj;

            if ($this.length === 1) {
                $obj = $this[0];

                if (typeof selector !== 'undefined') {
                    maybe_class = selector[0] === '.';
                    name_only   = maybe_class ? selector.slice(1) : selector;
                    tag_name    = name_only.toUpperCase();
                }

                do {
                    $obj       = $obj.parentNode;
                    class_name = (' ' + $obj.className + ' ').replace(/[\t\r\n\f]/g, ' ');

                    if ((typeof selector === 'undefined' && $obj.nodeType === 1) ||
                        (maybe_class && class_name.indexOf(' ' + name_only + ' ') > -1) ||
                        $obj.tagName === tag_name) {

                        return $$($obj);
                    }
                }
                while ($obj && $obj.nodeType !== 9);
            }
        },

        append: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].appendChild($obj[j]);
                }
            }
        },

        prepend: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].insertBefore($obj[j], $this[i].childNodes[0]);
                }
            }
        },

        before: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].parentNode.insertBefore($obj[j], $this[i]);
                }
            }
        },

        after: function($obj) {
            var $this = this;

            if (typeof $obj === 'string') {
                $obj = _create_element($obj);
            }

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, obj_len = $obj.length; j < obj_len; j++) {
                    $this[i].parentNode.insertBefore($obj[j], $this[i].nextSibling);
                }
            }
        },

        remove: function() {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                $this[i].parentNode.removeChild($this[i]);
            }
        },

        remove_children: function() {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                while ($this[i].firstChild) {
                    $this[i].removeChild($this[i].firstChild);
                }
            }
        },

        empty: function() {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                while ($this[i].firstChild) {
                    $this[i].removeChild($this[i].firstChild);
                }
            }
        },

        clone: function() {
            var $this  = this;

            if ($this.length === 1) {
                return $$($this[0].cloneNode(true));
            }
        },

        next_sibling: function() {
            var $this = this;

            if ($this.length === 1) {
                var $obj = $this[0];

                do {
                    $obj = $obj.nextSibling;
                }
                while ($obj && $obj.nodeType !== 1);

                return $$($obj);
            }
        },

        prev_sibling: function() {
            var $this = this;

            if ($this.length === 1) {
                var $obj = $this[0];

                do {
                    $obj = $obj.previousSibling;
                }
                while ($obj && $obj.nodeType !== 1);

                return $$($obj);
            }
        },

        get_siblings: function() {
            var $this     = this,
                $siblings = [];

            if ($this.length === 1) {
                var $obj      = $this[0],
                    $children = $obj.parentNode.children;

                for (var i = 0, len = $children.length; i < len; i++) {
                    if ($children[i].nodeType === 1 && $children[i] !== $obj) {
                        $siblings.push($children[i]);
                    }
                }
            }

            return $$($siblings);
        },

        get_attribute: function(attribute) {
            var $this = this,
                value = null;

            if ($this.length === 1) {
                if (_is_input($this[0]) && attribute === 'value') {
                    value = $this[0][attribute];
                }
                else {
                    value = $this[0].getAttribute(attribute);
                }
            }

            return value === null ? '' : value;
        },

        set_attribute: function(attribute, value) {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                if (_is_input($this[i]) && attribute === 'value') {
                    $this[i][attribute] = value;
                }
                else if (value) {
                    $this[i].setAttribute(attribute, value);
                }
                else {
                    $this[i].removeAttribute(attribute);
                }
            }
        },

        set_text: function(text) {
            var $this = this;

            if ($this.length === 1) {
                $this[0].textContent = text.toString().trim();
            }
        },

        get_text: function() {
            var $this = this,
                text  = '';

            if ($this.length === 1) {
                text = $this[0].textContent.trim();
            }

            return text;
        },

        insert_html: function(html, outer) {
            var $this = this;

            if ($this.length === 1) {
                if (outer === true) {
                    $this[0].outerHTML = html;
                }
                else {
                    $this[0].innerHTML = html;
                }
            }
        },

        get_html: function(outer) {
            var $this = this,
                html  = '';

            if ($this.length === 1) {
                if (outer === true) {
                    html = $this[0].outerHTML;
                }
                else {
                    html = $this[0].innerHTML;
                }
            }

            return html.trim();
        },

        get_file: function() {
            var $this    = this,
                filename = '',
                filetype = '',
                filesize = 0,
                $file;

            if ($this.length === 1) {
                $file = $this[0].files;

                if ($file.length) {
                    filename = $file[0].name;
                    filesize = $file[0].size;
                    filetype = $file[0].type;
                }
            }

            return {
                'filename' : filename,
                'filesize' : filesize,
                'filetype' : filetype
            };
        },

        is_tag: function(tagname) {
            var $this  = this,
                is_tag = false;

            if ($this.length === 1) {
                is_tag = $this[0].tagName.toLowerCase() === tagname;
            }

            return is_tag;
        },

        is_visible: function() {
            var $this      = this,
                is_visible = false,
                $styles,
                $obj;

            if ($this.length === 1) {
                $obj       = $this[0];
                is_visible = true;

                while ($obj && $obj.nodeType !== 9) {
                    $styles = window.getComputedStyle($obj, null);

                    if ($obj.offsetWidth === 0 &&
                        $obj.offsetHeight === 0 &&
                        $styles.display === 'none') {

                        is_visible = false;
                        break;
                    }

                    $obj = $obj.parentElement;
                }
            }

            return is_visible;
        },

        index: function(element) {
            var $this = this;

            if (typeof element === 'object') {
                for (var i = 0, len = $this.length; i < len; i++) {
                    if ($this[i] === element) {
                        return i;
                    }
                }
            }
            else if (typeof element === 'number') {
                if (element === -1) {
                    element = $this.length - 1;
                }

                return $$($this[element]);
            }
        },

        for_each: function(callback) {
            var $this = this;

            for (var i = 0, len = $this.length; i < len; i++) {
                callback.call($this[i], i);
            }
        },

        is_checked: function() {
            var $this      = this,
                is_checked = false;

            if ($this.length === 1) {
                is_checked = $this[0].checked;
            }

            return is_checked;
        },

        add_class: function(selector) {
            var $this     = this,
                $selector = selector.split(' '),
                updated   = false,
                trimmed_classes,
                classes;

            for (var i = 0, len = $this.length; i < len; i++) {
                trimmed_classes = String.prototype.trim.call($this[i].getAttribute('class') || '');
                classes         = trimmed_classes ? trimmed_classes.split(/\s+/) : [];

                for (var j = 0, selector_len = $selector.length; j < selector_len; j++) {
                    if (classes.indexOf($selector[j]) === -1) {
                        classes.push($selector[j]);
                        updated = true;
                    }
                }

                if (updated) {
                    $this[i].setAttribute('class', classes.sort().join(' '));
                    updated = false;
                }
            }
        },

        remove_class: function(selector) {
            var $this     = this,
                $selector = selector.split(' '),
                updated   = false,
                trimmed_classes,
                classes,
                index;

            for (var i = 0, len = $this.length; i < len; i++) {
                trimmed_classes = String.prototype.trim.call($this[i].getAttribute('class') || '');
                classes         = trimmed_classes ? trimmed_classes.split(/\s+/) : [];

                for (var j = 0, selector_len = $selector.length; j < selector_len; j++) {
                    index = classes.indexOf($selector[j]);

                    if (index > -1) {
                        classes.splice(index, 1);
                        updated = true;
                    }
                }

                if (updated) {
                    if (classes.length) {
                        $this[i].setAttribute('class', classes.sort().join(' '));
                    }
                    else {
                        $this[i].removeAttribute('class');
                    }
                    updated = false;
                }
            }
        },

        has_class: function(selector) {
            var $this     = this,
                has_class = false;

            if ($this.length === 1) {
                has_class = $this[0].classList.contains(selector);
            }

            return has_class;
        },

        focus: function() {
            var $this = this;

            if ($this.length) {
                $this[0].focus();
            }
        },

        click: function() {
            var $this = this;

            if ($this.length) {
                $this[0].click();
            }
        },

        set_style: function($styles) {
            var $this = this,
                property_camel_case,
                property_vendor;

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var property in $styles) {
                    if ($styles.hasOwnProperty(property)) {
                        property_camel_case = _camel_case_property(property);
                        property_vendor     = _get_vendor_property(property_camel_case);

                        $this[i].style[property_vendor] = $styles[property];
                    }
                }
            }
        },

        get_style: function(property) {
            var $this = this,
                style = '',
                $styles;

            if ($this.length === 1) {
                $styles = window.getComputedStyle($this[0], null);
                style   = $styles.getPropertyValue(property);
            }

            return style;
        },

        set_data: function(key, value) {
            var $this = this;

            if ($this.length === 1) {
                $this[0][key] = value;
            }
        },

        get_data: function(key) {
            var $this = this;

            if ($this.length === 1) {
                return $this[0][key];
            }
        },

        get_width: function() {
            var $this = this,
                width = 0;

            if ($this.length === 1) {
                if (_is_window($this[0])) {
                    width = document.documentElement.clientWidth;
                }
                else if (_is_document($this[0])) {
                    width = Math.max(
                        document.body.scrollWidth,
                        document.body.offsetWidth
                    );
                }
                else {
                    width = this[0].offsetWidth;
                }
            }

            return width;
        },

        get_height: function() {
            var $this  = this,
                height = 0;

            if ($this.length === 1) {
                if (_is_window($this[0])) {
                    height = document.documentElement.clientHeight;
                }
                else if (_is_document($this[0])) {
                    height = Math.max(
                        document.body.scrollHeight,
                        document.body.offsetHeight
                    );
                }
                else {
                    height = this[0].offsetHeight;
                }
            }

            return height;
        },

        get_offset_top: function() {
            var $this = this,
                top   = 0,
                $obj;

            if ($this.length === 1) {
                $obj = $this[0];
                top   = $obj.offsetTop;

                while ($obj = $obj.offsetParent) {
                    top += $obj.offsetTop;
                }
            }

            return top;
        },

        get_offset_left: function() {
            var $this = this,
                left  = 0,
                $obj;

            if ($this.length === 1) {
                $obj = $this[0];
                left = $obj.offsetLeft;

                while ($obj = $obj.offsetParent) {
                    left += $obj.offsetLeft;
                }
            }

            return left;
        },

        get_scroll_top: function() {
            var $this      = this,
                scroll_top = 0;

            if ($this.length === 1) {
                scroll_top = _get_scroll_offset($this[0]).top;
            }

            return scroll_top;
        },

        get_scroll_left: function() {
            var $this       = this,
                scroll_left = 0;

            if ($this.length === 1) {
                scroll_left = _get_scroll_offset($this[0]).left;
            }

            return scroll_left;
        },

        set_value: function(value) {
            return this.set_attribute('value', value);
        },

        get_value: function() {
            return this.get_attribute('value');
        },

        add_event: function(type, listener) {
            var $this  = this,
                $types = type.split(','),
                event_listener;

            event_listener = function(event) {
                listener.call(this, event);
            };

            for (var i = 0, len = $this.length; i < len; i++) {
                for (var j = 0, types_len = $types.length; j < types_len; j++) {
                    type = _get_event_type($types[j].trim());

                    $this[i].addEventListener(type, event_listener, false);
                }
            }
        },
    };

    // Ladet JavaScript-Code nach

    $$.load_script = function(url, callback) {
        var $head   = document.getElementsByTagName('head')[0],
            $script = document.createElement('script');

        $script.src = (navigator.userAgent.indexOf('MSIE ') > 0) ? url + '?' + Math.random() : url;

        if (callback && typeof(callback) === 'function') {
            $script.onload = callback;
        }

        $head.appendChild($script);
    };

    // Ajax

    $$.get = function(url, callback) {
        if (window.XMLHttpRequest) {
            var $ajax = new XMLHttpRequest();

            $ajax.open('GET', url, true);

            $ajax.onload = function() {
                if (this.status === 200) {
                    callback.call(this, this.responseText);
                }
            };

            $ajax.send();
        }
    };

    // Setzt hash

    $$.set_hash = function(hash) {
        if (window.history && window.history.replaceState) { // IE 10+
            hash = hash || window.location.pathname;
            window.history.replaceState(null, document.title, hash);
        }
    };

    // Verbindet zwei Objekte

    $$.merge_objects = function($obj1, $obj2) {
        for (var key in $obj2) {
            if ($obj2[key].constructor === Object) {
                $obj2[key] = $$.merge_objects($obj1[key], $obj2[key]);
            }
            else {
                $obj1[key] = $obj2[key];
            }
        }

        return $obj1;
    };

    // Scrollt zu

    $$.scroll_to = function(to, duration, callback) {
        var diff = to - $$(window).get_scroll_top(),
            step = diff / duration * 10;

        setTimeout(function() {
            window.scrollBy(0, step);

            if (Math.abs(diff) <= Math.abs(step)) {

                if (typeof callback === 'function') {
                    callback();
                }

                return;
            }

            $$.scroll_to(to, duration - 10, callback);
        }, 10);
    };


    // Gibt die Touch-Richtung zurück

    $$.get_touch_range = function(dist_x, dist_y) {
        var theta = Math.atan2(-dist_x, dist_y),
            degrees;

        if (theta < 0) {
            theta += 2 * Math.PI;
        }

        degrees = Math.floor(theta * (180 / Math.PI) - 180);

        if (degrees < 0 && degrees > -180) {
            degrees = 360 - Math.abs(degrees);
        }

        return {
            is_top    : degrees <= 40 || degrees >= 320,
            is_right  : degrees >= 50 && degrees <= 130,
            is_bottom : degrees >= 140 && degrees <= 220,
            is_left   : degrees >= 230 && degrees <= 310
        };
    };

    window.$$ = $$;
}(document, window));

// DEVICE
// -------------------------------------------------------------------------------------------------

(function(document, navigator, window) {
    var $html = document.querySelector('html');

    function _find(needle) {
        return navigator.userAgent.toLowerCase().indexOf(needle) !== -1;
    }

    window.device = {};

    device.iphone         = _find('iphone');
    device.ipod           = _find('ipod');
    device.ipad           = _find('ipad');
    device.ios            = device.iphone || device.ipod || device.ipad;
    device.android        = _find('android');
    device.android_phone  = device.android && _find('mobile');
    device.android_tablet = device.android && !_find('mobile');
    device.windows        = _find('windows');
    device.windows_phone  = device.windows && _find('phone');
    device.windows_tablet = device.windows && _find('touch');
    device.mobile         = device.android_phone || device.iphone || device.ipod || device.windows_phone;
    device.tablet         = device.ipad || device.android_tablet || device.windows_tablet;

    if (device.ios) {
        if (device.ipad) {
            $html.classList.add('ios', 'ipad', 'tablet');
        }
        else if (device.iphone || device.ipod) {
            $html.classList.add('ios', 'iphone', 'mobile');
        }
    }
    else if (device.android) {
        if (device.android_tablet) {
            $html.classList.add('android', 'tablet');
        }
        else {
            $html.classList.add('android', 'mobile');
        }
    }
    else if (device.windows) {
        if (device.windows_tablet) {
            $html.classList.add('windows', 'tablet');
        }
        else if (device.windows_phone) {
            $html.classList.add('windows', 'mobile');
        }
        else {
            $html.classList.add('desktop');
        }
    }
    else {
        $html.classList.add('desktop');
    }
}(document, navigator, window));

// BROWSER SUPPORT
// -------------------------------------------------------------------------------------------------

(function(document, navigator, window) {
    var $html  = document.querySelector('html'),
        $div   = document.createElement('div');

    // Überprüft die Browser-Unterstützung für CSS-Attribute wie z. B. transition

    function _has_css_property(property) {
        var css_property_found = false,
            prefixes           = ['Moz', 'Webkit'];

        if (property in $div.style) {
            css_property_found = true;
        }
        else {
            property = property.charAt(0).toUpperCase() + property.substr(1);

            for (var i = 0, len = prefixes.length; i < len; i++) {
                if (typeof $div.style[prefixes[i] + property] !== 'undefined') {
                    css_property_found = true;
                    break;
                }
            }
        }

        return css_property_found;
    }

    window.support = {
        touch      : window.navigator.msMaxTouchPoints || 'ontouchstart' in document.documentElement,
        transition : _has_css_property('transition') && 'TransitionEvent' in window   // TransitionEvent wird benötigt für Android 4.1.x (https://bugs.dojotoolkit.org/ticket/17164#comment:13)
    };

    // Setzt Klassen auf den HTML-Tag

    $html.classList.remove('no_js');
    $html.classList.add(support.touch ? 'touch' : 'no_touch');
    $html.classList.add(support.transition ? 'csstransitions' : 'no_csstransitions');
}(document, navigator, window));

// PREFETCH
// -------------------------------------------------------------------------------------------------

(function(document) {
    var Prefetch = function($prefetch_link) {
        var _this = this;

        _this._$prefetch_link = $prefetch_link;
        _this._$options       = _this._$prefetch_link.getAttribute('data-performance');
    };

    Prefetch.prototype = {
        init: function() {
            var _this = this;

            if (_this._$options.indexOf('prefetch') > -1) {
                _this._prefetch();
            }

            if (_this._$options.indexOf('prerender') > -1) {
                _this._prerender();
            }
        },

        _prefetch: function() {
            var _this = this,
                $link = document.createElement('link');

            $link.setAttribute('rel', 'prefetch');
            $link.setAttribute('href', _this._$prefetch_link.getAttribute('href'));

            document.querySelector('head').appendChild($link);
        },

        _prerender: function() {
            var _this = this,
                $link = document.createElement('link');

            $link.setAttribute('rel', 'prerender');
            $link.setAttribute('href', _this._$prefetch_link.getAttribute('href'));

            document.querySelector('head').appendChild($link);
        }
    };

    var $prefetch_links = document.querySelectorAll('[data-performance]');

    for (var i = 0, len = $prefetch_links.length; i < len; i++) {
        new Prefetch($prefetch_links[i]).init();
    }
})(document);

// BARRIEREFREIHEIT
// Wird gebraucht für alle Projekte

// EXTERNER LINK
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $links = document.querySelectorAll('[href*=http]');

    for (var i = 0, $link; $link = $links[i]; i++) {
        var target = $link.getAttribute('target'),
            title  = $link.getAttribute('title');

        if (title && target === '_blank') {
            $link.setAttribute('title', title + ' (Neues Fenster)');
        }
    }
})(document);


// TASTATURSTEUERUNG FÜR ELEMENTE MIT ROLE BUTTON
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $buttons = document.querySelectorAll('[role="button"]');

    for (var i = 0, $button; $button = $buttons[i]; i++) {
         $button.addEventListener('keyup', function(event) {
             if (event.keyCode === 13 && this.tagName !== 'A' || event.keyCode === 32) {
                 this.click();
             }
         });
     }
})(document);


// ERKENNUNG DER FOKUSMETHODE FÜR LINKS
// Wird verwendet für verbesserten Fokus auf Links (siehe default.less)
// -------------------------------------------------------------------------------------------------

(function(document) {
    var FocusMethod = function($link) {
        var _this = this;

        _this.$link = $link;

        _this.focus_method      = false;
        _this.last_focus_method = false;
    };

    FocusMethod.prototype = {
        init: function() {
            var _this = this;

            _this.$link.addEventListener('keydown',
                _this._on_key_down.bind(this), {
                    'passive' : true
                }
            );

            _this.$link.addEventListener('mousedown',
                _this._on_mouse_down.bind(this), {
                    'passive' : true
                }
            );

            _this.$link.addEventListener('touchstart',
                _this._on_touch_start.bind(this), {
                    'passive' : true
                }
            );

            _this.$link.addEventListener('focus', _this._on_focus.bind(this));
            _this.$link.addEventListener('blur', _this._on_blur.bind(this));

            window.addEventListener('blur', this._on_window_blur.bind(this));
        },

        _on_key_down: function() {
            var _this = this;

            _this.focus_method = 'key';
        },

        _on_mouse_down: function() {
            var _this = this;

            if (_this.focus_method === 'touch') {
                return;
            }

            _this.focus_method = 'mouse';
        },

        _on_touch_start: function() {
            var _this = this;

            _this.focus_method = 'touch';
        },

        _on_focus: function() {
            var _this = this;

            if (!_this.focus_method) {
                _this.focus_method = _this.last_focus_method;
            }

            _this.$link.setAttribute('data-focus-method', _this.focus_method);

            this.last_focus_method = this.focus_method;
            this.focus_method      = false;
        },

        _on_blur: function() {
            var _this = this;

            _this.$link.removeAttribute('data-focus-method');
        },

        _on_window_blur: function() {
            var _this = this;

            _this.focus_method = false;
        }
    };

    var $links = document.querySelectorAll('a, [tabindex="0"]');

    for (var i = 0, $link; $link = $links[i]; i++) {
        new FocusMethod($link).init();
    }
})(document);

// COOKIE-HINWEIS
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $cookie_banner = document.querySelector('#cookie_banner'),
        $body          = document.querySelector('body');

    if (!$cookie_banner) {
        return;
    }

    var $close  = $cookie_banner.querySelector('.close'),
        now     = new Date().getTime(),
        storage = localStorage.getItem(domain + '_cookie_banner');

    if (storage === null || now > storage) {
        $cookie_banner.classList.remove('hideme');
        $body.classList.add('cb_visible');
    }

    $close.addEventListener('click', function(event) {
        event.preventDefault();

        localStorage.setItem(domain + '_cookie_banner', now + 31536000);
        $cookie_banner.classList.add('hideme');
        $body.classList.remove('cb_visible');
    });
}(document));

// COOKIE-HINWEIS FUSSZEILE VERLÄNGERN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $cookie_banner  = document.querySelector('#cookie_banner'),
        $footer         = document.querySelector('footer'),
        $close          = $cookie_banner.querySelector('.close'),
        $cookie_spacing;

    if (!$cookie_banner) {
        return;
    }

    $close.addEventListener('click', function() {
        if ($footer) {
            $footer.removeChild($cookie_spacing);
        }
    });

    if ($footer) {
        $cookie_spacing = document.createElement('div');
        $footer.appendChild($cookie_spacing);
        $cookie_spacing.style.paddingBottom = $cookie_banner.clientHeight + 'px';
        window.addEventListener('resize', function() {
            $cookie_spacing.style.paddingBottom = $cookie_banner.clientHeight + 'px';
        }, false);
    }

}(document));

// TOOLTIP
// Wird gebraucht für: google_maps,newsletter_quick_subscribe, formular
// -------------------------------------------------------------------------------------------------

(function(document) {
    var Tooltip = function($tooltip_wrapper) {
        var _this = this;

        _this.$tooltip_wrapper = $tooltip_wrapper;
        _this.$tooltip         = $tooltip_wrapper.querySelector('[role="tooltip"]');

        _this._temp_disabled = false;
        _this._perm_disabled = false;
        _this._focused       = false;

        var tooltip_id = _this.$tooltip.getAttribute('id');

        _this.$tooltip_trigger = $tooltip_wrapper.querySelector('[aria-describedby="' + tooltip_id + '"]');
    };

    Tooltip.prototype = {
        init: function() {
            var _this = this;

            _this.$tooltip_trigger.addEventListener('keyup', _this._check_tooltip.bind(_this));
            _this.$tooltip_trigger.addEventListener('focus', _this._check_tooltip.bind(_this));
            _this.$tooltip_trigger.addEventListener('blur', _this._hide_tooltip.bind(_this));

            if (!support.touch) {
                _this.$tooltip.addEventListener('mouseenter', _this._check_tooltip.bind(_this));
                _this.$tooltip.addEventListener('mouseleave', _this._hide_tooltip.bind(_this));
                _this.$tooltip_trigger.addEventListener('mouseenter', _this._check_tooltip.bind(_this));
                _this.$tooltip_trigger.addEventListener('mouseleave', _this._hide_tooltip.bind(_this));
            }

            _this._keyboard_nav();
        },

        _check_tooltip: function(event) {
            var _this = this;

            if (_this.$tooltip_trigger.getAttribute('aria-invalid') === 'true') {
                _this._perm_disabled = false;
                _this._show_tooltip(event);
            }
            else {
                _this._perm_disabled = true;
                _this._hide_tooltip(event);
            }
        },

        _show_tooltip: function(event) {
            var _this = this;

            if (_this.disabled) {
                return;
            }

            if (event.type === 'keyup' || event.type === 'focus') {
                _this._focused = true;
            }

            if (!_this._temp_disabled && !_this._perm_disabled ||
                event.type === 'mouseenter' && !_this._perm_disabled) {
                _this.$tooltip.setAttribute('aria-hidden', 'false');
            }
        },

        _hide_tooltip: function(event) {
            var _this = this;

            if (event.type === 'blur') {
                _this._temp_disabled = false;
                _this._focused = false;
            }

            if (!_this._focused || _this._perm_disabled || _this._temp_disabled) {
                _this.$tooltip.setAttribute('aria-hidden', 'true');
            }
        },

        _keyboard_nav: function() {
            var _this = this;

            _this.$tooltip_trigger.addEventListener('keydown', function(event) {
                if (event.keyCode === 27 && _this.$tooltip.getAttribute('aria-hidden') === 'false') {
                    event.stopPropagation();

                    _this._temp_disabled = true;
                    _this._hide_tooltip(event);
                }
            });
        }
    };

    var $tooltip_wrappers = document.querySelectorAll('.tooltip_wrapper');

    for (var i = 0, len = $tooltip_wrappers.length; i < len; i++) {
        new Tooltip($tooltip_wrappers[i]).init();
    }

    window.Tooltip = Tooltip;
})(document);

// SANFTES SCROLLEN
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var SmoothScroll = function($link) {
        var _this = this;

        _this.$link = $link;
        _this.has_animationend_event = false;
    },
    offset_top = 20;

    function _get_offset_top($target) {
        var $obj         = $target,
            top_position = $obj.offsetTop;

        while ($obj = $obj.offsetParent) {
            top_position += $obj.offsetTop;
        }
        return top_position;
    }

    function _remove_highlight_class($highlighted_target) {
        if ($highlighted_target.has_animationend_event) {
            return;
        }

        $highlighted_target.addEventListener('animationend', function(event) {
            if (event.target !== this) {
                return;
            }

            $highlighted_target.has_animationend_event = true;
            $highlighted_target.classList.remove('highlighted');
        });
    }

    function _scroll_to($target, offset, $callback) {
        var top_position = _get_offset_top($target) - offset,
            duration     = 300,
            $highlighted_target,
            interval;

        if ($target.getAttribute('id')) {
            $highlighted_target = $target.parentElement;
        }
        else {
            $highlighted_target = $target;
        }

        interval = setInterval(function() {
            var diff = top_position - window.pageYOffset,
                step = diff / duration * 10;

            if (Math.abs(diff) <= Math.abs(step)) {
                clearInterval(interval);
                //$highlighted_target.classList.add('highlighted');

                if (typeof $callback === 'function') {
                    $callback();
                }
            }

            window.scrollBy(0, step);
            duration -= 10;
        }, 10);

        _remove_highlight_class($highlighted_target);
    }

    function _auto_scroll() {
        var hash      = location.hash,
            parameter = location.search,
            $target;

        if (hash.length <= 1) {
            return;
        }

        $target = document.querySelector(hash) || document.querySelector('a[id="' + hash.slice(1) + '"]');

        if (!$target || $target.classList.contains('no_smooth_scroll')) {
            return;
        }

        location.hash = ''; // IE und Edge Bug - Scroll beginnt nicht am Seitenanfang
        window.history.replaceState(null, document.title, location.pathname + parameter);

        setTimeout(function() { // Firefox Bug - Scroll beginnt nicht am Seitenanfang
            window.scrollTo(0, 0);

            _scroll_to($target, offset_top, function() {
                $target.focus();
                window.history.replaceState(null, document.title, parameter + hash);
            });
        }, 10);
    }

    SmoothScroll.prototype = {
        init: function() {
            var _this = this;

            if (_this.$link.classList.contains('no_smooth_scroll')) {
                return;
            }

            if (_this.$link.tagName === 'A' || _this.$link.tagName === 'a') {
                _this._click_link();
            }
            else {
                _this._change_select();
            }
        },

        _click_link: function() {
            var _this = this;

            _this.$link.addEventListener('click', function(event) {
                var hash = this.getAttribute('href') || this.getAttribute('xlink:href'),
                    parameter,
                    $parameter,
                    $hash,
                    $target;

                if (hash.length === 1) {
                    return;
                }

                $hash      = hash.split('#');
                $parameter = $hash[0].split('?');
                parameter  = $parameter.length === 2 ? '?' + $parameter[1] : '';
                hash       = $hash[1];
                $target    = document.querySelector('#' + hash) || document.querySelector('a[id="' + hash + '"]');

                if (!$target) {
                    return;
                }

                event.preventDefault();

                _scroll_to($target, offset_top, function() {
                    $target.focus();
                    window.history.replaceState(null, document.title, parameter + '#' + hash);
                });
            });
        },

        _change_select: function() {
            var _this = this;

            _this.$link.addEventListener('change', function(event) {
                var hash = this.options[this.selectedIndex].value,
                    $target;

                if (hash.length === 1) {
                    return;
                }

                hash    = hash.split('#')[1];
                $target = document.querySelector('#' + hash) || document.querySelector('a[id="' + hash + '"]');

                if (!$target) {
                    return;
                }

                event.preventDefault();

                _scroll_to($target, offset_top, function() {
                    $target.focus();
                    window.history.replaceState(null, document.title, hash);
                });
            });
        }
    };

    var $links = document.querySelectorAll('a[*|href*="#"], select');

    for (var i = 0, len = $links.length; i < len; i++) {
        new SmoothScroll($links[i]).init();
    }

    _auto_scroll();
})(document, window);

// DROPDOWN MENU
// -------------------------------------------------------------------------------------------------

(function(document) {
    var DropdownMenu = function($dropdown_menu) {
        var _this = this,
            id    = $dropdown_menu.getAttribute('id');

        _this.$dropdown_menu                = $dropdown_menu;
        _this.$main_menuitems               = $dropdown_menu.querySelectorAll('#' + id + ' > ul > li > a');
        _this.$sub_menuitems                = $dropdown_menu.querySelectorAll('#' + id + ' > ul > li li > a');
        _this.$main_menuitems_with_sub_menu = $dropdown_menu.querySelectorAll('[href^="#"]');
         _this.main_menu_index              = 0;
        _this.event_type                    = false;

        _this.$key = {
            'tab'         : 9,
            'enter'       : 13,
            'escape'      : 27,
            'space'       : 32,
            'arrow_left'  : 37,
            'arrow_up'    : 38,
            'arrow_right' : 39,
            'arrow_down'  : 40
        };
    };

    DropdownMenu.prototype = {
        init: function() {
            var _this = this;

            _this._init_accessibility();
            _this._init_keyboard();

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems[i]; i++) {
                var $li = $main_menuitem.parentElement;

                $li.addEventListener('mouseenter',
                    _this._on_mouseenter_main_menuitem.bind(_this, $main_menuitem)
                );

                $li.addEventListener('mouseover',
                    _this._on_mouseover_main_menuitem.bind(_this, $main_menuitem)
                );

                $li.addEventListener('mouseout',
                    _this._on_mouseout_main_menuitem.bind(_this)
                );

                $main_menuitem.addEventListener('focus',
                    _this._on_focus_main_menuitem.bind(_this, $main_menuitem)
                );
            }
        },

        _init_accessibility: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                $main_menuitem.setAttribute('aria-expanded', 'false');

                $main_menuitem.addEventListener('click', function(event) {
                    event.preventDefault();
                });
            }
        },

        _init_keyboard: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems[i]; i++) {
                $main_menuitem.addEventListener('keydown',
                    _this._on_keydown_main_menuitem.bind(_this, $main_menuitem)
                );
            }

            for (var j = 0, $sub_menuitem; $sub_menuitem = _this.$sub_menuitems[j]; j++) {
                $sub_menuitem.addEventListener('keydown',
                    _this._on_keydown_sub_menuitem.bind(_this)
                );
            }
        },

        _on_keydown_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            _this.event_type      = event.type;
            _this.main_menu_index = _this._get_main_menuitem_index();
            _this.$main_menuitem  = $main_menuitem;
            _this.$sub_menu       = $main_menuitem.nextElementSibling;

            switch(event.keyCode) {
                case _this.$key.tab:
                    if (event.shiftKey) {
                        _this.main_menu_index -= 1;
                    }
                    else {
                        _this.main_menu_index += 1;
                    }

                    break;

                case _this.$key.enter:
                    if (_this.$sub_menu) {
                        event.preventDefault();
                        _this._close_sub_menus();
                        this._open_sub_menu(false);
                    }

                    break;

                case _this.$key.escape:
                    event.preventDefault();

                    if (_this.sub_menu_is_open) {
                        event.stopPropagation();
                    }

                    _this._close_sub_menu();

                    break;

                case _this.$key.arrow_left:
                    event.preventDefault();

                    _this._focus_prev_main_menuitem();

                    break;

                case _this.$key.arrow_up:
                    event.preventDefault();

                    if (_this.sub_menu_is_open) {
                        _this._focus_prev_menuitem();
                    }

                    break;

                case _this.$key.arrow_right:
                    event.preventDefault();

                    _this._focus_next_main_menuitem();

                    break;

                case _this.$key.arrow_down:
                    event.preventDefault();

                    if (_this.$sub_menu) {
                        this._open_sub_menu(false);
                    }
                    else {
                        _this._focus_next_main_menuitem();
                    }

                    break;
            }
        },

        _get_main_menuitem_index: function() {
            var _this = this;

            return Array.prototype.indexOf.call(_this.$main_menuitems, document.activeElement);
        },

        _focus_prev_menuitem: function() {
            var _this = this;

            _this.main_menu_index -= 1;

            if (_this.main_menu_index < 0) {
                _this.main_menu_index = 0;

                return;
            }

            _this.$main_menuitem = _this.$main_menuitems[_this.main_menu_index];
            _this.$sub_menu      = _this.$main_menuitem.nextElementSibling;

            if (_this.$sub_menu && _this.sub_menu_is_open) {
                this._open_sub_menu(true);
            }
            else {
                _this.$main_menuitem.focus();
            }
        },

        _focus_prev_main_menuitem: function() {
            var _this = this;

            _this.main_menu_index -= 1;

            if (_this.main_menu_index < 0) {
                _this.main_menu_index = 0;

                return;
            }

            _this.$main_menuitem = _this.$main_menuitems[_this.main_menu_index];

            _this.$main_menuitem.focus();
        },

        _focus_next_main_menuitem: function() {
            var _this = this;

            _this.main_menu_index += 1;

            if (_this.main_menu_index === _this.$main_menuitems.length) {
                _this.main_menu_index = _this.$main_menuitems.length - 1;

                return;
            }

            _this.$main_menuitem = _this.$main_menuitems[_this.main_menu_index];

            _this.$main_menuitem.focus();
        },

        _on_mouseenter_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            _this.event_type     = event.type;
            _this.$main_menuitem = $main_menuitem;
            _this.$sub_menu      = $main_menuitem.nextElementSibling;

            _this._close_sub_menus();

            if (_this.$sub_menu) {
                _this._open_sub_menu(false);
            }
        },

        _on_mouseover_main_menuitem: function() {
            var _this = this;

            clearTimeout(_this.close_sub_menu_timeout);
        },

        _on_mouseout_main_menuitem: function() {
            var _this = this;

            _this.close_sub_menu_timeout = setTimeout(function() {
                _this._close_sub_menus();
            }, 1000);
        },

        _on_focus_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            _this.event_type = event.type;

            if (_this.sub_menu_is_open) {
                _this.$main_menuitem = $main_menuitem;
                _this.$sub_menu      = $main_menuitem.nextElementSibling;

                _this._close_sub_menus();

                if (_this.$sub_menu) {
                    _this._open_sub_menu();
                }
            }
        },

        _on_keydown_sub_menuitem: function(event) {
            var _this = this;

            switch(event.keyCode) {
                case _this.$key.tab:

                    if (event.shiftKey) {
                        _this.sub_menu_index -= 1;
                    }
                    else {
                        _this.sub_menu_index += 1;
                    }

                    break;

                case _this.$key.escape:
                    event.preventDefault();
                    event.stopPropagation();

                    _this._close_sub_menu();

                    break;

                case _this.$key.arrow_left:
                    event.preventDefault();

                    _this.sub_menu_index = 0;
                    _this._focus_prev_sub_menuitem();

                    break;

                case _this.$key.arrow_up:
                    event.preventDefault();

                    _this._focus_prev_sub_menuitem();

                    break;

                case _this.$key.arrow_right:
                    event.preventDefault();

                    _this.sub_menu_index = 0;
                    _this._focus_prev_sub_menuitem();

                    break;

                case _this.$key.arrow_down:
                    event.preventDefault();

                    _this._focus_next_sub_menuitem();

                    break;
            }
        },

        _focus_prev_sub_menuitem: function() {
            var _this          = this,
                $sub_menuitems = _this.$main_menuitem.nextElementSibling.querySelectorAll('a'),
                $sub_menuitem,
                $main_menuitem;

            _this.sub_menu_index -= 1;

            $sub_menuitem = $sub_menuitems[_this.sub_menu_index];

            if (_this.sub_menu_index < 0) {
                $main_menuitem = _this.$main_menuitems[_this.main_menu_index];

                if ($main_menuitem) {
                    $main_menuitem.focus();
                }
            }
            else if ($sub_menuitem) {
                $sub_menuitem.focus();
            }
        },

        _focus_next_sub_menuitem: function() {
            var _this          = this,
                $sub_menuitems = _this.$main_menuitem.nextElementSibling.querySelectorAll('a'),
                $sub_menuitem,
                $main_menuitem;

            _this.sub_menu_index += 1;

            $sub_menuitem = $sub_menuitems[_this.sub_menu_index];

            if (_this.sub_menu_index === $sub_menuitems.length) {
                _this.main_menu_index += 1;

                $main_menuitem = _this.$main_menuitems[_this.main_menu_index];

                if ($main_menuitem) {
                    $main_menuitem.focus();
                }
                else {
                    _this.main_menu_index -= 1;
                    _this.sub_menu_index  -= 1;
                }
            }
            else {
                $sub_menuitem.focus();
            }
        },

        _open_sub_menu: function(focus_last_sub_menuitem) {
            var _this = this,
                $sub_menuitems;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                var is_current_menuitem = _this.$main_menuitem === $main_menuitem;

                if (is_current_menuitem) {
                    $main_menuitem.parentElement.classList.add('hover');
                }
                else {
                    $main_menuitem.parentElement.classList.remove('hover');
                }

                $main_menuitem.setAttribute('aria-expanded', is_current_menuitem);
            }

            _this.sub_menu_index = 0;

            if (_this.event_type === 'keydown') {
                $sub_menuitems = _this.$sub_menu.querySelectorAll('a');

                if (focus_last_sub_menuitem) {
                    _this.sub_menu_index = $sub_menuitems.length - 1;
                }

                $sub_menuitems[_this.sub_menu_index].focus();

                _this.event_type = false;
            }

            _this.sub_menu_is_open = true;
        },

        _close_sub_menu: function() {
            var _this = this;

            _this.$main_menuitem.parentElement.classList.remove('hover');
            _this.$main_menuitem.setAttribute('aria-expanded', 'false');

            _this.sub_menu_is_open = false;

            _this.$main_menuitem.focus();
        },

        _close_sub_menus: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                $main_menuitem.parentElement.classList.remove('hover');
                $main_menuitem.setAttribute('aria-expanded', 'false');
            }
        }
    };

    var $dropdown_menu = document.getElementsByClassName('dropdown_menu');

    for (var i = 0, len = $dropdown_menu.length; i < len; i++) {
        new DropdownMenu($dropdown_menu[i]).init();
    }
})(document);

// OFFCANVAS MENU ACORDION
// MUSS VOR DEM EIGENTLICHEN ACORDION GELADEN WERDEN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var OffCanvasMenuAccordion = function($toggle_offcanvas_menu) {
        var _this = this,
            controls;

        controls = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu').getAttribute('aria-controls');

        _this.$main_menuitems_with_sub_menu = document.getElementById(controls).querySelectorAll('[href^="#"]');
    };

    OffCanvasMenuAccordion.prototype = {
        init: function() {
            var _this = this;

            _this._init_accessibility();

            for (var j = 0, $main_menuitem_with_sub_menu; $main_menuitem_with_sub_menu = _this.$main_menuitems_with_sub_menu[j]; j++) {
                $main_menuitem_with_sub_menu.addEventListener('click',
                    _this._on_click_main_menuitem.bind(_this, $main_menuitem_with_sub_menu)
                );
            }

            window.addEventListener('resize',
                _this._window_size_changed.bind(_this, $main_menuitem_with_sub_menu)
            );

        },

        _init_accessibility: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                if ($main_menuitem.classList.contains('active')) {
                    $element = $main_menuitem.parentElement.querySelector('ul');
                    $element.style.height = $element.scrollHeight + 'px';
                }
            }
        },

        _window_size_changed: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                if ($main_menuitem.getAttribute('aria-expanded') === 'true') {
                    var $element = $main_menuitem.parentElement.querySelector('ul');
                    // reset height font.size manipulates height of element
                    $element.style.height = 'auto';
                    $element.style.height = $element.scrollHeight + 'px';
                }
            }
        },

        _on_click_main_menuitem: function($main_menuitem_selected) {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                var $element = $main_menuitem.parentElement.querySelector('ul');

                if ($main_menuitem_selected === $main_menuitem) {
                    $element.style.height = '0px';
                    if ($main_menuitem.getAttribute('aria-expanded') === 'false') {
                        $element.style.height = $element.scrollHeight + 'px';
                    } else {
                        $element.style.height = '0px';
                    }
                }
                else {
                    $element.style.height = '0px';
                }
            }
        }
    };

    // init OffCanvasMenu only once
    new OffCanvasMenuAccordion(document.getElementsByClassName('toggle_offcanvas_menu')[0]).init();
    var $toggle_offcanvas_menu = document.getElementsByClassName('toggle_offcanvas_menu');

    // create an Opener for each button
    for (var i = 0, len = $toggle_offcanvas_menu.length; i < len; i++) {
        new OffCanvasMenuAccordion($toggle_offcanvas_menu[i]).init();
    }

})(document);

// OFFCANVAS MENU
// -------------------------------------------------------------------------------------------------

(function(document) {
    var OffCanvasMenu = function($toggle_offcanvas_menu) {
        var _this = this,
            controls;

        controls = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu').getAttribute('aria-controls');

        _this.$offcanvas_menu               = document.getElementById(controls);
        _this.$main_menuitems_with_sub_menu = _this.$offcanvas_menu.querySelectorAll('[href^="#"]');
        // _this.$offcanvas_menu_content       = _this.$offcanvas_menu.querySelector('.offcanvas_menu_content');
        _this.$focus_elements               = _this.$offcanvas_menu.querySelectorAll('a');
        _this.focus_element                 = false;
        _this.$offcanvas_menu_state         = false;

        _this.$key = {
            'tab'    : 9,
        };
    };

    OffCanvasMenu.prototype = {
        init: function() {
            var _this = this;

            _this._init_accessibility();
            _this._init_keyboard();

            for (var j = 0, $main_menuitem_with_sub_menu; $main_menuitem_with_sub_menu = _this.$main_menuitems_with_sub_menu[j]; j++) {
                $main_menuitem_with_sub_menu.addEventListener('click',
                    _this._on_click_main_menuitem.bind(_this, $main_menuitem_with_sub_menu)
                );
            }
        },

        _init_accessibility: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                $main_menuitem.setAttribute('aria-expanded', $main_menuitem.classList.contains('active'));
            }
        },

        _init_keyboard: function() {
            var _this = this;

            document.addEventListener('keydown', function(event) {
                if (!_this.$offcanvas_menu_state.checked) {
                    return;
                }

                if (event.keyCode === _this.$key.tab) {
                    event.preventDefault();

                    if (event.shiftKey) {
                        _this._focus_element_with_shift_tab_key(event);
                    }
                    else {
                        _this._focus_element_with_tab_key(event);
                    }
                }
            });
        },

        _focus_element_with_shift_tab_key: function() {
            var _this = this;

            _this.tab_index -= 1;

            if (_this.tab_index < 0) {
                _this.tab_index = _this.$focus_elements.length - 1;
            }

            for (var i = _this.tab_index, $focus_element; $focus_element = _this.$focus_elements[i]; i--) {
                if ($focus_element.offsetParent === null || $focus_element.offsetWidth === 0) {
                    _this.tab_index -= 1;
                    continue;
                }

                _this.$focus_elements[_this.tab_index].focus();
                break;
            }
        },

        _focus_element_with_tab_key: function() {
            var _this = this;

            if (_this.tab_index === _this.$focus_elements.length - 1) {
                _this.tab_index = 0;
            }
            else {
                _this.tab_index += 1;
            }

            for (var i = _this.tab_index, $focus_element; $focus_element = _this.$focus_elements[i]; i++) {
                if ($focus_element.offsetParent === null || $focus_element.offsetWidth === 0) {
                    _this.tab_index += 1;

                    if (_this.tab_index > _this.$focus_elements.length - 1) {
                        _this.tab_index = 0;
                    }
                    else {
                        continue;
                    }
                }

                _this.$focus_elements[_this.tab_index].focus();
                break;
            }
        },

        _on_click_main_menuitem: function($main_menuitem, event) {
            var _this = this;

            event.preventDefault();

            _this.$main_menuitem = $main_menuitem;

            _this._toggle_sub_menus();
        },

        _toggle_sub_menus: function() {
            var _this = this;

            for (var i = 0, $main_menuitem; $main_menuitem = _this.$main_menuitems_with_sub_menu[i]; i++) {
                var is_active_menuitem = _this.$main_menuitem === $main_menuitem,
                    $parent_menuitems  = _this._get_parent_menu_elements();

                if (is_active_menuitem) {
                    _this.sub_menu_is_open = $main_menuitem.getAttribute('aria-expanded') === 'false';

                    $main_menuitem.parentElement.classList.toggle('expanded', _this.sub_menu_is_open);
                    $main_menuitem.setAttribute('aria-expanded', _this.sub_menu_is_open);
                }
                else if ($parent_menuitems.indexOf($main_menuitem) !== -1) { // Check parents
                    $main_menuitem.parentElement.classList.toggle('expanded', 'true');
                    $main_menuitem.setAttribute('aria-expanded', 'true');
                }
                else {
                    $main_menuitem.parentElement.classList.remove('expanded');
                    $main_menuitem.setAttribute('aria-expanded', 'false');
                }
            }
        },

        _get_parent_menu_elements: function() {
            var _this = this.$main_menuitem,
                $findings = [];

            while (_this.parentNode) {
                _this = _this.parentNode;

                if (_this.nodeName.toLowerCase() === 'li') {
                    $findings.push(_this.querySelector('a'));
                }
            }

            return $findings || False;
        }
    };

    var OffCanvasMenuOpener = function($toggle_offcanvas_menu) {
        var _this = this;
        var  controls = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu').getAttribute('aria-controls');

        _this.$toggle_offcanvas_menu = $toggle_offcanvas_menu.querySelector('label');
        _this.$open_offcanvas_menu   = $toggle_offcanvas_menu.querySelector('.open_offcanvas_menu');
        _this.$close_offcanvas_menu  = $toggle_offcanvas_menu.querySelector('.close_offcanvas_menu');
        _this.$offcanvas_menu_state  = document.querySelector('#' + _this.$toggle_offcanvas_menu.getAttribute('for'));
        _this.$offcanvas_menu        = document.getElementById(controls);
        _this.$focus_elements        = _this.$offcanvas_menu.querySelectorAll('a');

        _this.$key = {
            'enter'  : 13,
            'escape' : 27,
            'space'  : 32
        };
    };

    OffCanvasMenuOpener.prototype = {
        init: function() {
            var _this = this;

            _this._init_keyboard();

            _this.$toggle_offcanvas_menu.addEventListener('click', _this._toggle_menu.bind(_this));
            _this.$open_offcanvas_menu.addEventListener('click', _this._open_menu.bind(_this));
            _this.$close_offcanvas_menu.addEventListener('click', _this._close_menu.bind(_this));

            _this.$offcanvas_menu.addEventListener('transitionend', function(event) {

                // var _this = this;
                if (event.target !== this) {
                    return;
                }

                if (_this.$offcanvas_menu_state.checked) {
                    if (_this.focus_element) {
                        _this.focus_element = false;
                        _this.$focus_elements[0].focus();
                    }
                }
                else if (_this.focus_element) {
                    _this.focus_element = false;
                    _this.$open_offcanvas_menu.focus();
                }
            });
        },

        _init_keyboard: function() {
            var _this = this;

            _this.$open_offcanvas_menu.addEventListener('keydown', function(event) {
                if (event.keyCode === _this.$key.space || event.keyCode === _this.$key.enter) {
                    _this.focus_element = true;
                }

                if (event.keyCode === _this.$key.space) {
                    event.preventDefault();
                }
            });

            _this.$close_offcanvas_menu.addEventListener('keydown', function(event) {
                if (event.keyCode === _this.$key.space) {
                    event.preventDefault();
                }
            });

            document.addEventListener('keydown', function(event) {
                if (!_this.$offcanvas_menu_state.checked) {
                    return;
                }

                if (event.keyCode === _this.$key.escape) {
                    _this.focus_element = true;
                    _this._close_menu(event);
                }
            });
        },

        _scroll_to_top: function() {
            var _this = this;

            setTimeout(function() {
                var duration = 300,
                    interval;

                interval = setInterval(function() {
                    var diff = -window.pageYOffset,
                        step = diff / duration * 10;

                    if (Math.abs(diff) <= Math.abs(step)) {
                        if (_this.$anchor) {
                            _this.$anchor.focus();
                        }

                        clearInterval(interval);
                    }

                    window.scrollBy(0, step);
                    duration -= 10;
                }, 10);
            }, 300);
        },

        _toggle_menu: function(event) {
            var _this = this;

            if (_this.$offcanvas_menu_state.checked) {
                _this._close_menu(event);
            }
            else {
                _this._open_menu(event);
            }
        },

        _open_menu: function(event) {
            var _this = this;

            event.preventDefault();

            _this.$offcanvas_menu_state.checked = true;
            _this.tab_index = 0;

            _this._scroll_to_top();
        },

        _close_menu: function(event) {
            var _this = this;

            event.preventDefault();

            _this.$offcanvas_menu_state.checked = false;
            _this.tab_index = 0;
        }
    };

    var $offcanvas_menu = document.getElementsByClassName('toggle_offcanvas_menu');

    if ($offcanvas_menu.length) {
        new OffCanvasMenu($offcanvas_menu[0]).init(); // init once

        // create an opener for each button
        for (var i = 0, len = $offcanvas_menu.length; i < len; i++) {
            new OffCanvasMenuOpener($offcanvas_menu[i]).init();
        }
    }
})(document);

// FORMULARE
// -------------------------------------------------------------------------------------------------

(function() {
    var FormHelpers = function(element) {
        var _this = this;

        _this.$el = $$(element);
    };

    FormHelpers.prototype = {
        init: function() {
            var _this = this;

            _this._file_upload();
            _this._select();
        },

        _file_upload: function() {
            var _this = this;

            if (_this.$el.get_attribute('type') !== 'file') {
                return;
            }

            var $file_name   = _this.$el.get_parent().children('.file_name'),
                $file_button = _this.$el.get_parent().children('.file_button');

            _this.$el.add_event('focus', function() {
                $file_button.add_class('focus');
            });

            _this.$el.add_event('blur', function() {
                $file_button.remove_class('focus');
            });

            _this.$el.add_event('change', function() {
                $file_name.set_text(_this.$el.get_file().filename);
            });
        },

        _select: function() {
            var _this = this;

            if (!_this.$el.is_tag('select')) {
                return;
            }

            _this.$el.add_event('focus', function() {
                _this.$el.get_parent('.select').add_class('focus');
            });

            _this.$el.add_event('blur', function() {
                _this.$el.get_parent('.select').remove_class('focus');
            });
        }
    };

    $$('input, select, textarea').for_each(function() {
        new FormHelpers(this).init();
    });
})();

// FORM VALIDIERUNG
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var FormValidation = function($form) {
        var _this = this;

        _this._$form             = $form;
        _this._$inputs           = _this._$form.querySelectorAll('input.validate, textarea.validate');
        _this._$inputs_checkbox  = _this._$form.querySelectorAll('input[type=checkbox][required]');
        _this._$selects          = _this._$form.querySelectorAll('select[required]');
        _this._$button           = _this._$form.querySelector('[type="submit"]');
        _this._$error_msg_button = _this._$form.querySelector('.error_msg_button');
    };

    FormValidation.prototype = {
        init: function() {
            var _this = this;

            for (var j = 0, inputs_len = _this._$inputs.length; j < inputs_len; j++) {
                var $input = this._$inputs[j];

                $input.addEventListener('keyup', _this._input_keyup.bind(_this, $input));
                $input.addEventListener('blur', _this._input_blur.bind(_this, $input));
            }

            for (var i = 0, inputs_checkbox_len = _this._$inputs_checkbox.length; i < inputs_checkbox_len; i++) {
                var $input_checkbox = this._$inputs_checkbox[i];

                $input_checkbox.addEventListener('click', _this._input_checkbox_click.bind(_this, $input_checkbox));
                $input_checkbox.addEventListener('keyup', _this._input_checkbox_keyup.bind(_this, $input_checkbox));
                $input_checkbox.addEventListener('blur', _this._input_checkbox_blur.bind(_this, $input_checkbox));
            }

            for (var x = 0, selects_len = _this._$selects.length; x < selects_len; x++) {
                var $select = this._$selects[x];

                $select.addEventListener('change', _this._select_change.bind(_this, $select));
                $select.addEventListener('blur', _this._select_blur.bind(_this, $select));
            }

            _this._$form.addEventListener('submit', _this._submit.bind(_this));

            _this._check_submit_status();
        },

        _input_keyup: function($input, event) {
            if (event.keyCode === 9 || event.keyCode === 27) {
                // No validation on TAB or ESC
                return;
            }

            this._validate_input($input, event);
        },

        _input_blur: function($input, event) {
            this._validate_input($input, event);
        },

        _validate_input: function($input, event) {
            var _this          = this,
                id             = $input.getAttribute('id'),
                $error_warning = document.querySelector('[for="' + id + '"] .error_warning'),
                min            = parseInt($input.getAttribute('min')),
                pattern        = $input.getAttribute('pattern'),
                regexp         = new RegExp(pattern),
                value          = $input.value;

            if ($input.type === 'file') {
                _this._validate_input_file($input);
            }
            else if (value) {
                if (pattern && value.match(regexp) || value >= min || !pattern && $input.required) {
                    $input.setAttribute('aria-invalid', 'false');

                    if (!event || event.type === 'blur') {
                        $input.classList.remove('error');

                        if ($error_warning) {
                            $error_warning.classList.remove('show');
                        }
                    }
                }
                else {
                    $input.setAttribute('aria-invalid', 'true');

                    if (!event || event.type === 'blur') {
                        $input.classList.add('error');

                        if ($error_warning) {
                            $error_warning.classList.add('show');
                        }
                    }
                }
            }
            else if ($input.required) {
                $input.setAttribute('aria-invalid', 'true');

                if (!event || event.type === 'blur') {
                    $input.classList.add('error');

                    if ($error_warning) {
                        $error_warning.classList.add('show');
                    }
                }
            }
            else {
                $input.setAttribute('aria-invalid', 'false');

                if (!event || event.type === 'blur') {
                    $input.classList.remove('error');

                    if ($error_warning) {
                        $error_warning.classList.remove('show');
                    }
                }
            }
            _this._check_submit_status();
        },

        _validate_input_file: function($input) {
            var _this           = this,
                id              = $input.getAttribute('id'),
                $error_warning  = document.querySelector('[for="' + id + '"] .error_warning'),
                value           = $input.value;

            while ($input && $input.nodeType !== 9) {
                $input = $input.parentNode;

                if ($input.classList.contains('file')) {
                    break;
                }
            }

            if (value) {
                $input.classList.remove('error');
                if ($error_warning) {
                    $error_warning.classList.remove('show');
                }
            }
            else {
                $input.classList.add('error');
                if ($error_warning) {
                    $error_warning.classList.add('show');
                }
            }

            _this._check_submit_status();
        },

        _input_checkbox_click: function($input_checkbox, event) {
            this._validate_input_checkbox($input_checkbox, event);
        },

        _input_checkbox_keyup: function($input_checkbox, event) {
            if (event.keyCode === 32) { // SPACE
                this._validate_input_checkbox($input_checkbox, event);
            }
        },

        _input_checkbox_blur: function($input_checkbox, event) {
            this._validate_input_checkbox($input_checkbox, event);
        },

        _validate_input_checkbox: function($input_checkbox, event) {
            var _this          = this,
                id             = $input_checkbox.getAttribute('id'),
                $error_warning = document.querySelector('#label_' + id + ' .error_warning');

            if ($input_checkbox.checked && !event ||
                $input_checkbox.checked && event && event.type !== 'keyup' ||
                !$input_checkbox.checked && event && event.type === 'keyup') {
                $input_checkbox.setAttribute('aria-invalid', 'false');
                $input_checkbox.classList.remove('error');
                $error_warning.classList.remove('show');
            }
            else {
                $input_checkbox.setAttribute('aria-invalid', 'true');
                $input_checkbox.classList.add('error');
                $error_warning.classList.add('show');
            }

            _this._check_submit_status();
        },

        _select_change: function($select, event) {
            this._validate_select($select, event);
        },

        _select_blur: function($select, event) {
            this._validate_select($select, event);
        },

        _validate_select: function($select, event) {
            var _this          = this,
                id             = $select.getAttribute('id'),
                $wrapper       = $select,
                $error_warning = document.querySelector('#label_' + id + ' .error_warning'),
                value          = $select.value;

            while ($wrapper && $wrapper.nodeType !== 9) {
                $wrapper = $wrapper.parentNode;

                if ($wrapper.classList.contains('select')) {
                    break;
                }
            }

            if (value) {
                $select.setAttribute('aria-invalid', 'false');

                if (!event || event.type === 'blur') {
                    $wrapper.classList.remove('error');
                    $error_warning.classList.remove('show');
                }
            }
            else {
                $select.setAttribute('aria-invalid', 'true');

                if (!event || event.type === 'blur') {
                    $wrapper.classList.add('error');
                    $error_warning.classList.add('show');
                }
            }

            _this._check_submit_status();
        },

        _check_submit_status: function() {
            var _this                = this,
                error_msg_button_id  = _this._$error_msg_button.getAttribute('id'),
                enable_submit_button = true;

            for (var j = 0, inputs_len = _this._$inputs.length; j < inputs_len; j++) {
                if (_this._$inputs[j].getAttribute('aria-invalid') === 'true' ||
                    _this._$inputs[j].required && !_this._$inputs[j].value) {
                    enable_submit_button = false;
                    break;
                }
            }

            for (var i = 0, inputs_checkbox_len = _this._$inputs_checkbox.length; i < inputs_checkbox_len; i++) {
                if (!_this._$inputs_checkbox[i].checked) {
                    enable_submit_button = false;
                    break;
                }
            }

            for (var x = 0, selects_len = _this._$selects.length; x < selects_len; x++) {
                if (!_this._$selects[x].value) {
                    enable_submit_button = false;
                    break;
                }
            }

            if (enable_submit_button) {
                _this._$button.classList.remove('disabled');
                _this._$button.removeAttribute('aria-describedby');
            }
            else {
                _this._$button.classList.add('disabled');
                _this._$button.setAttribute('aria-describedby', error_msg_button_id);
            }
        },

        _show_first_error: function() {
            var _this              = this,
                $first_input_error = _this._$form.querySelector('[aria-invalid="true"]'),
                top_position       = 0,
                offset_top         = 60,
                duration           = 300,
                interval,
                $obj;

            if ($first_input_error) {
                $obj         = $first_input_error;
                top_position = $obj.offsetTop - offset_top;

                while ($obj = $obj.offsetParent) {
                    top_position += $obj.offsetTop;
                }

                if (window.pageYOffset < top_position) {
                    $first_input_error.focus();
                    return;
                }

                interval = setInterval(function() {
                    var diff = top_position - window.pageYOffset,
                        step = diff / duration * 10;

                    if (Math.abs(diff) <= Math.abs(step)) {
                        $first_input_error.focus();
                        clearInterval(interval);
                    }

                    window.scrollBy(0, step);
                    duration -= 10;
                }, 10);
            }
        },

        _submit: function(event) {
            var _this = this;

            _this._check_submit_status();

            if (_this._$button.classList.contains('disabled')) {
                event.preventDefault();

                for (var j = 0, inputs_len = _this._$inputs.length; j < inputs_len; j++) {
                    _this._validate_input(this._$inputs[j]);
                }

                for (var i = 0, inputs_checkbox_len = _this._$inputs_checkbox.length; i < inputs_checkbox_len; i++) {
                    _this._validate_input_checkbox(this._$inputs_checkbox[i]);
                }

                for (var x = 0, selects_len = _this._$selects.length; x < selects_len; x++) {
                    _this._validate_select(this._$selects[x]);
                }

                _this._show_first_error();
            }
        }
    };

    var $forms = document.querySelectorAll('[data-form*="validate"]');

    for (var i = 0, len = $forms.length; i < len; i++) {
        new FormValidation($forms[i]).init();
    }
})(document, window);

// FORMULARE: STANDORT AUSWAHL
// Wird verwendet für: formular
// -------------------------------------------------------------------------------------------------

(function(document) {
    var $secure_targets = document.querySelectorAll('[name="secure_target"]');

    if (!$secure_targets.length) {
        return;
    }

    for (var i = 0, $secure_target; $secure_target = $secure_targets[i]; i++) {
        $secure_target.addEventListener('change', function() {
            var id = this.options[this.selectedIndex].getAttribute('id');

            if (id) {
                var $locations_data = document.querySelectorAll('[data-forms-location=' + id + '] span');

                for (var j = 0, $location_data; $location_data = $locations_data[j]; j++) {
                    var title  = $location_data.getAttribute('title'),
                        $input = document.querySelector('input[name="to_' + title + '"]');

                    $input.value = $location_data.textContent.trim();
                }
            }
        });
    }
})(document);

// FORMULARE: EINGABE ZWISCHENSPEICHERN
// Wird verwendet für: formular
// -------------------------------------------------------------------------------------------------

(function(document) {
    var FormCache = function($form) {
        var _this = this;

        _this._$form     = $form;
        _this._form_name = _this._$form.getAttribute('data-form-cache');
        _this._$inputs   = _this._$form.querySelectorAll('input, select, textarea');
        _this._$cache    = {};
    };

    FormCache.prototype = {
        init: function() {
            var _this = this;

            _this._init_events();
            _this._restore_cache();
        },

        _init_events: function() {
            var _this = this,
                $input,
                type,
                event_listener;

            for (var i = 0, len = _this._$inputs.length; i < len; i++) {
                $input = _this._$inputs[i];
                type    = $input.type;

                if (type === 'checkbox') {
                    event_listener = 'click';
                }
                else if (type === 'select-one') {
                    event_listener = 'change';
                }
                else {
                    event_listener = 'input';
                }

                $input.addEventListener(event_listener, _this._save_cache.bind(_this, $input), false);
            }

            _this._$form.addEventListener('submit', _this._reset_cache.bind(_this), false);
        },

        _save_cache: function($input) {
            var _this = this,
                name  = $input.getAttribute('name'),
                type  = $input.type;

            if (type === 'checkbox') {
                _this._$cache[name] = $input.checked;
            }
            else if (type === 'select-one') {
                _this._$cache[name] = $input.selectedIndex;
            }
            else {
                _this._$cache[name] = $input.value;
            }

            localStorage.setItem(domain + '_form_cache_' + _this._form_name, JSON.stringify(_this._$cache));
        },

        _restore_cache: function() {
            var _this  = this,
                $cache = localStorage.getItem(domain + '_form_cache_' + _this._form_name),
                $input,
                type;

            if (!$cache) {
                return;
            }

            _this._$cache = JSON.parse($cache);

            for (var key in _this._$cache) {
                if (_this._$cache.hasOwnProperty(key)) {
                    $input = _this._$form.querySelector('[name="' + key + '"]');
                    type   = $input.type;

                    if (type === 'checkbox') {
                        $input.checked = _this._$cache[key];
                    }
                    else if (type === 'select-one') {
                        $input.selectedIndex = _this._$cache[key];
                    }
                    else {
                        $input.value = _this._$cache[key];
                    }
                }
            }
        },

        _reset_cache: function() {
            var _this    = this,
                is_valid = true;

            for (var i = 0, len = _this._$inputs.length; i < len; i++) {
                if (_this._$inputs[i].getAttribute('aria-invalid') === 'true') {
                    is_valid = false;
                    break;
                }
            }

            if (is_valid) {
                localStorage.removeItem(domain + '_form_cache_' + _this._form_name);
            }
        }
    };

    var $forms = document.querySelectorAll('[data-form-cache]');

    for (var i = 0, len = $forms.length; i < len; i++) {
        new FormCache($forms[i]).init();
    }
})(document);

// FORMULARE: TEXTAREA AUTOGROW
// Wird gebraucht für alle <textarea>
// -------------------------------------------------------------------------------------------------

(function(document) {
    function _camel_case_property(property) {
        return property.replace(/-([\da-z])/gi, function(all, letter) {
            return letter.toUpperCase();
        });
    }

    function _get_style($element, property) {
        var $styles = window.getComputedStyle($element, null),
            style   = $styles.getPropertyValue(property);

        return style;
    }

    function _set_style($element, $styles) {
        for (var property in $styles) {
            if ($styles.hasOwnProperty(property)) {
                $element.style[_camel_case_property(property)] = $styles[property];
            }
        }
    }

    var FormTextareaAutogrow = function($textarea) {
        var _this = this;

        _this.$textarea      = $textarea;
        _this.default_height = $textarea.offsetHeight;
        _this.line_height    = parseInt(_get_style($textarea, 'line-height'));
        _this.padding_bottom = parseInt(_get_style($textarea, 'padding-bottom'));
        _this.padding_top    = parseInt(_get_style($textarea, 'padding-top'));
    };

    FormTextareaAutogrow.prototype = {
        init: function() {
            var _this = this;

            _this.$textarea.addEventListener('blur', _this._set_textarea_height.bind(_this));
            _this.$textarea.addEventListener('focus', _this._set_textarea_height.bind(_this));
            _this.$textarea.addEventListener('keyup', _this._set_textarea_height.bind(_this));

            _this._set_textarea_height();
        },

        _set_textarea_height: function() {
            var _this = this,
                $lines = _this.$textarea.value.split('\n'),
                length = $lines.length,
                height = (length + 2) * _this.line_height + _this.padding_bottom + _this.padding_top;

            _set_style(_this.$textarea, {
                'height' : height >= _this.default_height ? height / 16 + 'rem' : _this.default_height / 16 + 'rem'
            });
        }
    };

    var $textareas = document.getElementsByTagName('textarea');

    for (var i = 0, $textarea; $textarea = $textareas[i]; i++) {
        new FormTextareaAutogrow($textarea).init();
    }
})(document);

// FORMULARE: ÜBERNIMMT URL-PARAMETER FÜR DIE INPUTS
// Wird gebraucht für: formular
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var FormUrlParameters = function($form) {
        var _this = this;

        _this._$form = $form;
    };

    FormUrlParameters.prototype = {
        init: function() {
            var _this = this,
                href  = window.location.href;

            if (href.indexOf('?') > -1) {
                _this._get_url_parameters(href);
            }
        },

        _get_url_parameters: function(href) {
            var _this       = this,
                $parameters = href.split('?')[1].split('&');

            _this._set_inputs_value($parameters);
        },

        _set_inputs_value: function($parameters) {
            var _this = this,
                $inputs,
                $pair,
                key,
                value,
                tagname,
                type;

            for (var i = 0, $parameter; $parameter = $parameters[i]; i++) {
                $pair   = $parameter.split('=');
                key     = $pair[0];
                value   = decodeURIComponent($pair[1].replace(/\+/g,' '));
                $inputs = _this._$form.querySelectorAll('[name=' + key + ']');

                if (!value || !$inputs.length) {
                    continue;
                }

                tagname = $inputs[0].tagName;

                if (tagname === 'SELECT') {
                    _this.selected_select($inputs[0], value);
                }
                else if (tagname === 'INPUT' || tagname === 'TEXTAREA') {
                    type = $inputs[0].type;

                    if (type === 'radio') {
                        _this._checked_input_radio($inputs, value);
                    }
                    else if (type === 'checkbox') {
                        $inputs[0].defaultChecked = value;
                    }
                    else {
                        $inputs[0].defaultValue = value;
                    }
                }
            }
        },

        selected_select: function($select, value) {
            var $options = $select.querySelectorAll('option');

            for (var j = 0, $option; $option = $options[j]; j++) {
                if ($option.getAttribute('value') === value) {
                    $option.defaultSelected = true;
                }
                else {
                    $option.defaultSelected = false;
                }
            }
        },

        _checked_input_radio: function($inputs, value) {
            for (var j = 0, $input; $input = $inputs[j]; j++) {
                if ($input.getAttribute('value') === value) {
                    $input.defaultChecked = true;
                }
                else {
                    $input.defaultChecked = false;
                }
            }
        }
    };

    var $forms = document.querySelectorAll('[data-form*="url-parameters"]');

    for (var i = 0, $form; $form = $forms[i]; i++) {
        new FormUrlParameters($form).init();
    }
})(document, window);

// STEUERNEWS SEO - ALLE AUSGABEN
// -------------------------------------------------------------------------------------------------

(function(document) {
    var SteuernewsIssues = function(issues_select) {
        var _this = this;

        _this.$issues_select    = issues_select;
        _this.$select           = issues_select.querySelector('select');
        _this.$button           = issues_select.querySelector('.button');
        _this.$active_option    = _this.$select.querySelector('option:checked');
    };

    SteuernewsIssues.prototype = {
        init: function() {
            var _this = this;

            _this.$select.addEventListener('change', function() {
                this.querySelectorAll('option')[this.selectedIndex];
                href = this.querySelectorAll('option')[this.selectedIndex].value;
                _this.$button.href = href;
            });
        },
    };

    var $steuernews_issues_select = document.querySelectorAll('.steuernews_issues_select');

    for (var i = 0; i < $steuernews_issues_select.length; i++) {
        new SteuernewsIssues($steuernews_issues_select[i]).init();
    }

})(document);

// BILDER-GALERIE
// Wird gebraucht in: image_gallery_overview
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var ImageGallery = function($images) {
        var _this = this;

        _this.$images   = $images;
        _this.$overlay  = document.querySelector('#image_gallery_overlay');
        _this.$slider   = _this.$overlay.querySelector('.slider');
        _this.$previous = _this.$overlay.querySelector('.previous');
        _this.$next     = _this.$overlay.querySelector('.next');
        _this.$close    = _this.$overlay.querySelector('.close');

        _this._current_index = 0;
        _this._touch_flag    = false;
    };

    ImageGallery.prototype = {
        init: function() {
            var _this = this;

            _this._init_animations();
            _this._init_mouse();
            _this._init_keyboard();
            _this._init_touch();
        },

        _init_animations: function() {
            var _this = this;

            _this.$overlay.addEventListener('transitionend', _this._overlay_transtion_end.bind(_this));
            _this.$slider.addEventListener('animationend', _this._bounce_animation_end.bind(_this));
        },

        _init_mouse: function() {
            var _this = this;

            for (var i = 0, len = _this.$images.length; i < len; i++) {
                var $image = _this.$images[i];

                $image.addEventListener('click', _this._open.bind(_this, i));
            }

            if (window.navigator.msMaxTouchPoints || 'ontouchstart' in document.documentElement) {
                _this.$previous.classList.add('hideme');
                _this.$next.classList.add('hideme');
            }
            else {
                _this.$previous.addEventListener('click', function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    _this._show_previous_image();
                });

                _this.$next.addEventListener('click', function(event) {
                    event.stopPropagation();
                    event.preventDefault();
                    _this._show_next_image();
                });
            }

            _this.$close.addEventListener('click', _this._close.bind(_this));
            _this.$overlay.addEventListener('click', _this._close.bind(_this));
        },

        _init_keyboard: function() {
            var _this = this,
                $key  = {
                            'escape'      : 27,
                            'arrow_left'  : 37,
                            'arrow_right' : 39
                        };

            document.addEventListener('keydown', function(event) {
                if (!_this.$overlay.classList.contains('show')) {
                    return;
                }

                if (event.keyCode === $key.escape) {
                    _this._hide_overlay();
                }
                else if (event.keyCode === $key.arrow_left) {
                    _this._show_previous_image();
                }
                else if (event.keyCode === $key.arrow_right) {
                    _this._show_next_image();
                }
            });
        },

        _init_touch: function() {
            var _this = this;

            _this.$overlay.addEventListener('touchstart', function(event) {
                _this._touch_start_x = event.changedTouches[0].pageX;
                _this._touch_start_y = event.changedTouches[0].pageY;
            }, {
                'passive' : true
            });

            _this.$overlay.addEventListener('touchmove', function(event) {
                if (_this._touch_flag) {
                    return;
                }

                var touch   = event.touches[0] || event.changedTouches[0],
                    touch_x = touch.pageX,
                    touch_y = touch.pageY;

                event.preventDefault();

                if (touch_x - _this._touch_start_x > 40) {
                    _this._touch_flag = true;
                    _this._show_previous_image();
                }
                else if (touch_x - _this._touch_start_x < -40) {
                    _this._touch_flag = true;
                    _this._show_next_image();
                }
                else if (_this._touch_start_y - touch_y > 100) {
                    _this._hide_overlay();
                }
            });

            _this.$overlay.addEventListener('touchend', function() {
                _this._touch_flag = false;
            });
        },

        _open: function(index, event) {
            var _this = this;

            event.preventDefault();

            _this._prepare_overlay(index);
            _this._show_overlay(index);
        },

        _close: function(event) {
            var _this = this;

            event.preventDefault();
            event.stopPropagation();

            if (event.target.tagName !== 'IMG') {
                _this._hide_overlay();
            }
        },

        _overlay_transtion_end: function(event) {
            var _this = this;

            if (event.target !== _this.$overlay) {
                return;
            }

            if (!_this.$overlay.classList.contains('show')) {
                _this.$overlay.classList.add('hideme');
            }
        },

        _bounce_animation_end: function() {
            var _this = this;

            _this.$slider.classList.remove('bounce_from_left');
            _this.$slider.classList.remove('bounce_from_right');
        },

        _prepare_overlay: function(index) {
            var _this   = this,
                gallery = _this.$images[index].getAttribute('data-image-gallery');

            if (_this._current_gallery === gallery) {
                return;
            }

            _this.$full_images    = [];
            _this.$current_images = document.querySelectorAll('[data-image-gallery="' + gallery + '"]');
            _this._current_gallery = gallery;

            while (_this.$slider.firstChild) {
                _this.$slider.removeChild(_this.$slider.firstChild);
            }

            for (var i = 0, $full_image; i < _this.$current_images.length; i++) {
                $full_image = document.createElement('div');
                $full_image.className = 'full_image';

                _this.$full_images.push($full_image);

                _this.$slider.setAttribute('data-image-group', gallery);
                _this.$slider.appendChild($full_image);
            }
        },

        _show_overlay: function(index) {
            var _this = this;

            index = Array.prototype.indexOf.call(_this.$current_images, _this.$images[index]);

            _this._current_index = index;

            _this.$overlay.classList.remove('hideme');

            setTimeout(function() {
                _this.$overlay.classList.add('show');
            }, 50);

            _this._load_image(_this._current_index, function() {
                _this._preload_previous_image(_this._current_index);
                _this._preload_next_image(_this._current_index);
            });

            _this._update_offset();
        },

        _hide_overlay: function() {
            var _this = this;

            _this.$overlay.classList.remove('show');
        },

        _update_offset: function() {
            var _this  = this,
                offset = -_this._current_index * 100 + '%';

            _this.$slider.style.transform       = 'translate3d(' + offset + ', 0, 0)';
            _this.$slider.style.webkitTransform = 'translate3d(' + offset + ', 0, 0)'; // Für iOS8
        },

        _show_previous_image: function() {
            var _this = this;

            if (_this._current_index >= 1) {
                _this._current_index--;
                _this._preload_previous_image(_this._current_index);
                _this._update_offset();
            }
            else {
                _this.$slider.classList.add('bounce_from_left');
            }
        },

        _show_next_image: function() {
            var _this = this;

            if (_this._current_index <= _this.$full_images.length - 2) {
                _this._current_index++;
                _this._preload_next_image(_this._current_index);
                _this._update_offset();
            }
            else {
                _this.$slider.classList.add('bounce_from_right');
            }
        },

        _preload_previous_image: function(index) {
            var _this = this;

            if (_this._current_index - index >= 2) {
                return;
            }

            _this._load_image(index - 1, function() {
                _this._preload_previous_image(index - 1);
            });
        },

        _preload_next_image: function(index) {
            var _this = this;

            if (index - _this._current_index >= 2) {
                return;
            }

            _this._load_image(index + 1, function() {
                _this._preload_next_image(index + 1);
            });
        },

        _load_image: function(index, callback) {
            var _this       = this,
                $full_image = _this.$full_images[index];

            if (typeof $full_image === 'undefined') {
                return;
            }

            if ($full_image.querySelector('img')) {
                if (callback) {
                    callback();
                }

                return;
            }

            var $figure           = document.createElement('figure'),
                $image            = document.createElement('img'),
                image_source      = _this.$current_images[index].getAttribute('href'),
                image_description = _this.$current_images[index].getAttribute('data-image-description');

            $figure.innerHTML = '<div class="spinner">' +
                                '<div class="bounce bounce_1"></div>' +
                                '<div class="bounce bounce_2"></div>' +
                                '<div class="bounce bounce_3"></div>' +
                                '</div>';

            $image.setAttribute('src', image_source);

            $image.addEventListener('load', function() {
                var $spinner = $figure.querySelector('.spinner');

                $image.classList.add('show');
                $figure.removeChild($spinner);

                if (callback) {
                    callback();
                }
            });

            $figure.appendChild($image);

            if (image_description) {
                var $figcaption = document.createElement('figcaption');

                $figcaption.innerHTML = image_description;
                $figure.appendChild($figcaption);
            }

            $full_image.appendChild($figure);
        }
    };

    var $images = document.querySelectorAll('[data-image-gallery]');

    if ($images.length) {
        new ImageGallery($images).init();
    }
})(document, window);

// ANIMATION HELPERS
// Wird standardmaeßig in keinem Template gebraucht.
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var AnimationHelpers = function($animated_element) {
        var _this = this;

        _this._$animated_element = $animated_element;
        _this._offset            = _this._$animated_element.getAttribute('data-animation-offset');
    };

    AnimationHelpers.prototype = {
        init: function() {
            var _this = this;

            _this.$show_animation = this._is_in_viewport.bind(_this);

            window.addEventListener('load', _this.$show_animation, true);
            window.addEventListener('scroll', _this.$show_animation, true);
        },

        _offset_top: function() {
            var _this  = this,
                $node = _this._$animated_element,
                top   = $node.offsetTop;

            while ($node = $node.offsetParent) {
                top += $node.offsetTop;
            }

            return top;
        },

        _is_in_viewport: function() {
            var _this      = this,
                scroll_top = window.pageYOffset + document.documentElement.clientHeight,
                offset_top = _this._offset_top() + _this._$animated_element.offsetHeight;

            if (_this._offset) {
                offset_top = offset_top - _this._offset;
            }

            if (scroll_top >= offset_top) {
                _this._$animated_element.classList.add('animated');
                _this._remove_scroll_event();
            }
        },

        _remove_scroll_event: function() {
            var _this = this;

            window.removeEventListener('scroll', _this.$show_animation, true);
        }
    };

    var $animated_elements = document.querySelectorAll('[data-animated]');

    for (var i = 0, len = $animated_elements.length; i < len; i++) {
        new AnimationHelpers($animated_elements[i]).init();
    }
}(document, window));

// INFOLISTEN AT: DIAGRAMM (LINE CHART)
// Wird verwendet für Verbraucherpreisindizes (infolist_list_content)
// -------------------------------------------------------------------------------------------------

(function(document) {
    var VpiDiagram = function($vpi_diagram) {

        var _this = this;
        _this.$vpi_diagram          = $vpi_diagram;
        _this.$grid                 = _this.$vpi_diagram.querySelector('.vpi_diagram_grid');
        _this.$grid_text            = _this.$grid.querySelectorAll('text');
        _this.$grid_points          = _this.$vpi_diagram.querySelector('.vpi_diagram_points');
        _this.$months               = _this.$vpi_diagram.querySelector('.vpi_diagram_months');
        _this.$legend               = _this.$vpi_diagram.querySelector('.vpi_diagram_legend');
        _this.$year_label           = _this.$vpi_diagram.querySelector('.vpi_diagram_year_label');
        _this.$select_year          = document.querySelector('.select_year');
        _this.$switch_view          = document.querySelector('.switch_view');
        _this.$infolist_section     = document.querySelectorAll('.infolist_section');
        _this.$output               = document.querySelector('.vpi_diagram_output');
        _this.svg_namespace         = 'http://www.w3.org/2000/svg';
        _this.$months_and_values;
        _this.$legend_text;
        _this.bounds;
        _this.timer;
    };

    VpiDiagram.prototype = {
        init: function() {
            var _this = this;

            _this._get_data_for_year(_this.$select_year.value);
            _this._year_changed();

            _this.$select_year.addEventListener('change', function(event) {
                _this._year_selected_by_user(event);
            });

            _this.$switch_view.addEventListener('click', function(event) {
                event.preventDefault();
                _this._switch_view();
            });

            window.addEventListener('resize', function() {
                _this._display_months_two_row();
            });
        },

        _display_months_two_row: function() {
            var _this   = this,
                $months = _this.$months.querySelectorAll('text'),
                width   = 0;

            // Die Breite aller Monate
            var i = 0;

            for (i = 0; i < $months.length; i++) {
                width += $months[i].getBBox().width;
            }

            if (width > _this.$months.clientWidth - 20 * $months.length) {
                for (i = 0; i < $months.length; i++) {
                    if (i % 2 === 0) {
                        $months[i].setAttributeNS(null, 'y' , '25%');
                    } else {
                        $months[i].setAttributeNS(null, 'y' , '75%');
                    }
                }
            } else {
                for (i = 0; i < $months.length; i++) {
                    $months[i].setAttributeNS(null, 'y' , '50%');
                }
            }
        },

        _year_selected_by_user: function(event) {
            var _this = this;

            _this._get_data_for_year(event.target.value);
            _this._year_changed();
        },

        _year_changed: function() {
            var _this = this;

            _this._calc_grid_bounds();
            _this._change_grid();
            _this._change_months_label();
            _this._change_lines();
            _this._change_points();
            _this._display_months_two_row();
            _this._change_legend();
            _this._change_year_label();
            _this._change_table_view();
        },


        _get_data_for_year: function(year) {
            var _this = this;

            _this.$months_and_values = [];

            $table = document.querySelector(year).querySelector('table').querySelectorAll('tr');

            for (var i = 0; i < $table.length; i++) {

                // Table Header = Monatsname

                if (i === 0) {
                    _this.$legend_text = $table[i].querySelectorAll('th', 'td')[1].innerText;
                }

                // i[0] => Überschriften
                // i[1] => Beschreibungstexte
                // i[n] => Tabellenwerte (Wert der Inflation)

                else if (i > 1 && i <= 13) {
                    var month = $table[i].querySelectorAll('td')[0].innerText;
                    var value = $table[i].querySelectorAll('td')[1].innerText.replace(',', '.');
                    _this.$months_and_values.push([month, value]);
                }
            }
        },

        // Berechnung der Wert-Grenzen innerhalb eines Jahres (vertikale Tabellenbeschriftung)

        _calc_grid_bounds: function() {
            var _this   = this,
                min     = parseFloat(_this.$months_and_values[0][1]),
                max     = parseFloat(_this.$months_and_values[0][1]);

            for (var i = 1; i < _this.$months_and_values.length; i++) {
                if (_this.$months_and_values[i][1] > max) {
                    max = parseFloat(_this.$months_and_values[i][1]);
                }
                if (_this.$months_and_values[i][1] < min) {
                    min = parseFloat(_this.$months_and_values[i][1]);
                }
            }

            // 10 sorgt für die Kommastellenrundung

            min = min * 10;
            max = max * 10;

            var avg     = (min + max) / 2;
            var middle  = ((max + avg) / 2) - avg;

            middle = middle / 10;
            avg = avg / 10;

            if (middle === 0) {
                middle = avg;
            }

            max = (middle * 2 + avg);
            min = (-middle * 2 + avg);

            _this.bounds = {
                'min': min,
                'max': max,
                'middle': middle
            };
        },

        _calc_x_coordinate: function(array_position) {
            var _this   = this;

            // + 1 wegen dem Abstand links und rechts
            return ((array_position + 1) / (_this.$months_and_values.length + 1) * 100) + '%';
        },

        _calc_y_coordinate: function(array_position) {
            var _this   = this;

            return (88 - (_this.$months_and_values[array_position][1] - _this.bounds['min']) / (_this.bounds['max'] - _this.bounds['min']) * 88) + 6 + '%';
        },

        _change_grid: function() {
            var _this   = this;

            for (var i = 0; i < _this.$grid_text.length; i++) {
                _this.$grid_text[i].textContent = ((_this.bounds['max'] - _this.bounds['middle'] * i)).toFixed(2);
            }
        },

        _change_months_label: function() {
            var _this       = this,
                $old_texts    = _this.$months.querySelectorAll('text');

            // Alte Monatsbeschriftungen löschen

            for (var j = 0; j < $old_texts.length; j++) {
                _this.$months.removeChild($old_texts[j]); // IE11 Bug: .remove() funktioniert nicht
            }

            // Neue Elemente erzeugen

            for (var i = 0; i < _this.$months_and_values.length; i++) {
                var $svg_text = document.createElementNS(_this.svg_namespace, 'text');
                $svg_text.setAttributeNS(null, 'x' , _this._calc_x_coordinate(i));
                $svg_text.setAttributeNS(null, 'y' , '50%');

                // Text einfügen

                $svg_text.appendChild(document.createTextNode(_this.$months_and_values[i][0].substr(0, 3)));
                _this.$months.appendChild($svg_text);
            }
        },

        _change_points: function() {
            var _this           = this,
                $old_circles    = _this.$grid_points.querySelectorAll('circle');

            // Alte Punkte/Werte löschen

            for (var j = 0; j < $old_circles.length; j++) {
                _this.$grid_points.removeChild($old_circles[j]); // IE11 Bug: .remove() funktioniert nicht
            }

            // Neue Elemente erzeugen

            for (var i = 0; i < _this.$months_and_values.length; i++) {
                var $svg_circle = document.createElementNS(_this.svg_namespace, 'circle');
                var x = _this._calc_x_coordinate(i);
                var y = _this._calc_y_coordinate(i);
                $svg_circle.setAttributeNS(null, 'cx', x);
                $svg_circle.setAttributeNS(null, 'cy', y);
                $svg_circle.setAttributeNS(null, 'r', '5');
                _this.$grid_points.appendChild($svg_circle);

                // Vergrößerung für den klickbaren Bereich

                $svg_circle = document.createElementNS(_this.svg_namespace, 'circle');
                $svg_circle.setAttributeNS(null, 'cx', x);
                $svg_circle.setAttributeNS(null, 'cy', y);
                $svg_circle.setAttributeNS(null, 'r', '12');
                $svg_circle.setAttributeNS(null, 'opacity', '0');

                // Ausgabe der Punkte

                $svg_circle.x_coordinate = x;
                $svg_circle.y_coordinate = y;
                $svg_circle.month = _this.$months_and_values[i][0];
                $svg_circle.value = _this.$legend_text + ': ' + _this.$months_and_values[i][1];

                $svg_circle.addEventListener('mouseenter', function(event) {
                    _this._change_output(event);
                });

                $svg_circle.addEventListener('mouseleave', function() {
                    _this.$output.classList.remove('show');
                });

                $svg_circle.addEventListener('touchstart', function(event) {
                    _this._change_output(event);
                });

                $svg_circle.addEventListener('touchend', function() {
                    if (_this.timer) {
                        clearTimeout(_this.timer)
                    }
                    _this.timer = setTimeout(function() {
                         _this.$output.classList.remove('show');
                    }, 3000);
                });

                _this.$grid_points.appendChild($svg_circle);
            }
        },

        _change_lines: function() {
            var _this       = this,
                $old_lines  = _this.$grid_points.querySelectorAll('line');

            // Alte Linien löschen

            for (var j = 0; j < $old_lines.length; j++) {
                _this.$grid_points.removeChild($old_lines[j]); // IE11 Bug: .remove() funktioniert nicht
            }

            // Neue Linien erzeugen

            for (var i = 0; i < _this.$months_and_values.length - 1; i++) {
                var $svg_line = document.createElementNS(_this.svg_namespace, 'line');
                $svg_line.setAttributeNS(null, 'x1', _this._calc_x_coordinate(i));
                $svg_line.setAttributeNS(null, 'y1', _this._calc_y_coordinate(i));
                $svg_line.setAttributeNS(null, 'x2', _this._calc_x_coordinate(i + 1));
                $svg_line.setAttributeNS(null, 'y2', _this._calc_y_coordinate(i + 1));
                _this.$grid_points.appendChild($svg_line);
            }
        },

        _change_legend: function() {
            var _this   = this,
                $label  = _this.$legend.querySelector('text');

            $label.textContent = _this.$legend_text;
        },

        _change_year_label: function() {
            var _this   = this;

            _this.$year_label.innerText = _this.$select_year[_this.$select_year.selectedIndex].text;
        },

        // Ansicht umschalten

        _switch_view: function() {
            var _this   = this;

            if (_this.$switch_view.classList.contains('data')) {
                _this.$vpi_diagram.parentNode.classList.remove('hideme');

                for (var i = 0; i < _this.$infolist_section.length; i++) {
                    _this.$infolist_section[i].classList.add('visible_for_screen_reader');
                }

                _this.$switch_view.classList.remove('data');
                _this.$switch_view.querySelector('.text').innerHTML = 'zur Tabellenansicht';
            }
            else {
                _this.$vpi_diagram.parentNode.classList.add('hideme');
                document.querySelector([_this.$select_year.value]).classList.remove('visible_for_screen_reader');
                _this.$switch_view.classList.add('data');
                _this.$switch_view.querySelector('.text').innerHTML = 'zur grafischen Ansicht';
            }
        },

        _change_table_view: function() {
            var _this   = this;

            if (_this.$switch_view.classList.contains('data')) {
                for (var i = 0; i < _this.$infolist_section.length; i++) {
                    _this.$infolist_section[i].classList.add('visible_for_screen_reader');
                }

                document.querySelector([_this.$select_year.value]).classList.remove('visible_for_screen_reader');
            }
        },

        // Koordinatenberechnung vom Ausgabefeld

        _change_output: function(event) {
            var _this   = this;

            _this.$output.classList.add('show');
            _this.$output.querySelector('.month').innerText = event.target.month;
            _this.$output.querySelector('.value').innerText = event.target.value;

            _this.$output.style.top = event.target.y_coordinate;
            _this.$output.style.left = event.target.x_coordinate;

            if (_this.$vpi_diagram.getBoundingClientRect().width + _this.$vpi_diagram.getBoundingClientRect().x <
                event.target.getBoundingClientRect().x + _this.$output.getBoundingClientRect().width / 2 + 12) {
                _this.$output.classList.add('right');
            } else {
                _this.$output.classList.remove('right');
            }
        }
    };

    var $vpi_diagram  = document.querySelector('.vpi_diagram');

    if ($vpi_diagram) {
        new VpiDiagram($vpi_diagram).init();
    }

})(document);

// INFOLISTEN AT: DIAGRAMM (MAP CHART)
// Wird verwendet für Reisekosten (infolist_list_content)
// -------------------------------------------------------------------------------------------------

// Datensammlung

(function(document) {
    var MapChartData = function($map_chart) {
        this.$map_chart  = $map_chart;
    };

    MapChartData.prototype = {
        init: function() {
            var $countries    = this.$map_chart.querySelectorAll('path');
            var country_codes = {
                'AC': 'Ascension',
                'AD': 'Andorra',
                'AE': 'Vereinigte Arabische Emirate',
                'AF': 'Afghanistan',
                'AG': 'Antigua und Barbuda',
                'AI': 'Anguilla',
                'AL': 'Albanien',
                'AM': 'Armenien',
                'AN': 'Niederländische Antillen',
                'AO': 'Angola',
                'AQ': 'Antarktika',
                'AR': 'Argentinien',
                'AS': 'Amerikanisch-Samoa',
                'AT': 'Österreich',
                'AU': 'Australien',
                'AW': 'Aruba',
                'AX': 'Åland',
                'AZ': 'Aserbaidschan',
                'BA': 'Bosnien - Herzegowina',
                'BB': 'Barbados',
                'BD': 'Bangladesch',
                'BE': 'Belgien',
                'BF': 'Burkina Faso',
                'BG': 'Bulgarien',
                'BH': 'Bahrain',
                'BI': 'Burundi',
                'BJ': 'Benin',
                'BL': 'Saint-Barthélemy',
                'BM': 'Bermuda',
                'BN': 'Brunei',
                'BO': 'Bolivien',
                'BQ': 'Bonaire, Sint Eustatius und Saba(Niederlande)',
                'BR': 'Brasilien',
                'BS': 'Bahamas',
                'BT': 'Bhutan',
                'BU': 'Burma (Myanmar)',
                'BV': 'Bouvetinsel',
                'BW': 'Botswana',
                'BY': 'Belarus',
                'BZ': 'Belize',
                'CA': 'Kanada',
                'CC': 'Kokosinseln',
                'CD': 'Demokrat. Republik Kongo',
                'CE': 'Europäische Gemeinschaft',
                'CF': 'Zentralafrikanische Republik',
                'CG': 'Republik Kongo',
                'CH': 'Schweiz',
                'CI': 'Côte d`lvoire',
                'CK': 'Cookinseln',
                'CL': 'Chile',
                'CM': 'Kamerun',
                'CN': 'China',
                'CO': 'Kolumbien',
                'CP': 'Clipperton',
                'CR': 'Costa Rica',
                'CS': 'Tschechoslowakei (ehemalig)',
                'CU': 'Kuba',
                'CV': 'Kap Verde',
                'CW': 'Curaçao',
                'CX': 'Weihnachtsinsel',
                'CY': 'Zypern',
                'CZ': 'Tschechien',
                'DE': 'Deutschland und österreichische Zollausschlussgebiete',
                'DG': 'Diego Garcia',
                'DJ': 'Dschibuti',
                'DK': 'Dänemark',
                'DM': 'Dominica',
                'DO': 'Dominikanische Republik',
                'DZ': 'Algerien',
                'EA': 'Ceuta, Melilla',
                'EC': 'Ecuador',
                'EE': 'Estland',
                'EG': 'Ägypten',
                'EH': 'Westsahara',
                'ER': 'Eritrea',
                'ES': 'Spanien',
                'ET': 'Äthiopien',
                'EU': 'Europäische Union',
                'FI': 'Finnland',
                'FJ': 'Fidschi',
                'FK': 'Falklandinseln',
                'FM': 'Mikronesien',
                'FO': 'Färöer',
                'FR': 'Frankreich',
                'FX': 'Frankreich, France métropolitaine',
                'GA': 'Gabun',
                'GB': 'Großbritannien und Nordirland',
                'GD': 'Grenada',
                'GE': 'Georgien',
                'GF': 'Französisch-Guayana',
                'GG': 'Guernsey (Kanalinsel)',
                'GH': 'Ghana',
                'GI': 'Gibraltar',
                'GL': 'Grönland',
                'GM': 'Gambia',
                'GN': 'Guinea',
                'GP': 'Guadeloupe',
                'GQ': 'Äquatorialguinea',
                'GR': 'Griechenland',
                'GS': 'Südgeorgien und die Südlichen Sandwichinseln',
                'GT': 'Guatemala',
                'GU': 'Guam',
                'GW': 'Guinea-Bissau',
                'GY': 'Guyana',
                'HK': 'Hongkong',
                'HM': 'Heard und McDonaldinseln',
                'HN': 'Honduras',
                'HR': 'Kroatien',
                'HT': 'Haiti',
                'HU': 'Ungarn',
                'IC': 'Kanarische Inseln',
                'ID': 'Indonesien',
                'IE': 'Irland',
                'IL': 'Israel',
                'IM': 'Insel Man',
                'IN': 'Indien',
                'IO': 'Britisches Territorium im Indischen Ozean',
                'IQ': 'Irak',
                'IR': 'Iran',
                'IS': 'Island',
                'IT': 'Italien',
                'JE': 'Jersey (Kanalinsel)',
                'JM': 'Jamaika',
                'JO': 'Jordanien',
                'JP': 'Japan',
                'KE': 'Kenia',
                'KG': 'Kirgisistan',
                'KH': 'Kambodscha',
                'KI': 'Kiribati',
                'KM': 'Komoren',
                'KN': 'St. Kitts und Nevis',
                'KP': 'Korea, Demokratische Volksrepublik',
                'KR': 'Korea, Republik',
                'KW': 'Kuwait',
                'KY': 'Kaimaninseln',
                'KZ': 'Kasachstan',
                'LA': 'Laos',
                'LB': 'Libanon',
                'LC': 'St. Lucia',
                'LI': 'Liechtenstein',
                'LK': 'Sri Lanka',
                'LR': 'Liberia',
                'LS': 'Lesotho',
                'LT': 'Litauen',
                'LU': 'Luxemburg',
                'LV': 'Lettland',
                'LY': 'Libyen',
                'MA': 'Marokko',
                'MC': 'Monaco',
                'MD': 'Moldawien (Republik Moldau)',
                'ME': '"Jugoslawien"',
                'MF': 'Saint-Martin (franz. Teil)',
                'MG': 'Madagaskar',
                'MH': 'Marshallinseln',
                'MK': 'Mazedonien, ehem. jugoslawische Republik',
                'ML': 'Mali',
                'MM': 'Myanmar',
                'MN': 'Mongolei',
                'MO': 'Macao',
                'MP': 'Nördliche Marianen',
                'MQ': 'Martinique',
                'MR': 'Mauretanien',
                'MS': 'Montserrat',
                'MT': 'Malta',
                'MU': 'Mauritius',
                'MV': 'Malediven',
                'MW': 'Malawi',
                'MX': 'Mexiko',
                'MY': 'Malaysia',
                'MZ': 'Mosambik',
                'NA': 'Namibia',
                'NC': 'Neukaledonien',
                'NE': 'Niger',
                'NF': 'Norfolkinsel',
                'NG': 'Nigeria',
                'NI': 'Nicaragua',
                'NL': 'Niederlande',
                'NO': 'Norwegen',
                'NP': 'Nepal',
                'NR': 'Nauru',
                'NT': 'Neutrale Zone',
                'NU': 'Niue',
                'NZ': 'Neuseeland',
                'OM': 'Oman',
                'PA': 'Panama',
                'PE': 'Peru',
                'PF': 'Französisch-Polynesien',
                'PG': 'Papua-Neuguinea',
                'PH': 'Philippinen',
                'PK': 'Pakistan',
                'PL': 'Polen',
                'PM': 'Saint-Pierre und Miquelon',
                'PN': 'Pitcairninseln',
                'PR': 'Puerto Rico',
                'PS': 'Palästinensische Autonomiegebiete',
                'PT': 'Portugal',
                'PW': 'Palau',
                'PY': 'Paraguay',
                'QA': 'Katar',
                'RE': 'Réunion',
                'RO': 'Rumänien',
                'RS': '"Jugoslawien"',
                'RU': 'Russische Föderation',
                'RW': 'Ruanda',
                'SA': 'Saudi-Arabien',
                'SB': 'Salomonen',
                'SC': 'Seychellen',
                'SD': 'Sudan',
                'SE': 'Schweden',
                'SG': 'Singapur',
                'SH': 'St. Helena',
                'SI': 'Slowenien',
                'SJ': 'Svalbard und Jan Mayen',
                'SK': 'Slowakei',
                'SL': 'Sierra Leone',
                'SM': 'San Marino',
                'SN': 'Senegal',
                'SO': 'Somalia',
                'SR': 'Suriname',
                'SS': 'Südsudan',
                'ST': 'São Tomé und Príncipe',
                'SU': 'UdSSR (jetzt: Russische Föderation)',
                'SV': 'El Salvador',
                'SX': 'Sint Maarten (niederl. Teil)',
                'SY': 'Syrien',
                'SZ': 'Swasiland',
                'TA': 'Tristan da Cunha (verwaltet von St. Helena, reserviert für UPU)',
                'TC': 'Turks- und Caicosinseln',
                'TD': 'Tschad',
                'TF': 'Französische Süd- und Antarktisgebiete',
                'TG': 'Togo',
                'TH': 'Thailand',
                'TJ': 'Tadschikistan',
                'TK': 'Tokelau',
                'TL': 'Osttimor (Timor-Leste)',
                'TM': 'Turkmenistan',
                'TN': 'Tunesien',
                'TO': 'Tonga',
                'TR': 'Türkei',
                'TT': 'Trinidad und Tobago',
                'TV': 'Tuvalu',
                'TW': 'Taiwan',
                'TZ': 'Tansania',
                'UA': 'Ukraine',
                'UG': 'Uganda',
                'UM': 'United States Minor Outlying Islands',
                'US': 'USA',
                'UY': 'Uruguay',
                'UZ': 'Usbekistan',
                'VA': 'Vatikanstadt',
                'VC': 'St. Vincent und die Grenadinen',
                'VE': 'Venezuela',
                'VG': 'Britische Jungferninseln',
                'VI': 'Amerikanische Jungferninseln',
                'VN': 'Vietnam',
                'VU': 'Vanuatu',
                'WF': 'Wallis und Futuna',
                'WS': 'Samoa',
                'YE': 'Jemen',
                'YT': 'Mayotte',
                'YU': '"Jugoslawien"',
                'ZA': 'Südafrika',
                'ZM': 'Sambia',
                'ZR': 'Zaire (jetzt Demokratische Republik Kongo)',
                'ZW': 'Simbabwe'
            };

            var $sections             = document.querySelectorAll('.infolist_section table tbody tr'),
                costs_by_country_name = {},
                country_codes_by_name = {},
                parent_country;

            for (var code in country_codes) {
                if (country_codes.hasOwnProperty(code)) {
                    country_codes_by_name[country_codes[code]] = code;
                }
            }

            for (var i = 0; i < $sections.length; i++) {
                var tds     = $sections[i].children,
                    country = '',
                    daily_fee,
                    nightly_fee;


                if (tds.length > 2) { // Tabellenzeile hat 3 Spalten mit Land, Tag- und Nachtgeld
                    country     = tds[0].textContent;
                    daily_fee   = tds[1].textContent;
                    nightly_fee = tds[2].textContent;

                    if (country in country_codes_by_name) {
                        parent_country = country;

                        costs_by_country_name[country] = {
                            'additional_values' : '',
                            'daily_fee'         : daily_fee,
                            'nightly_fee'       : nightly_fee,
                            'total'             : parseInt(parseInt(daily_fee.split('€')[1], 10) + parseInt(nightly_fee.split('€')[1], 10))
                        };
                    }
                    else if (country[0] === '-' && parent_country) {
                        var additional_values = '<br>' + '<strong>' + country + '</strong><br>Tagesgebühr: ' + daily_fee + '<br>Nachtgebühr: ' + nightly_fee;
                        costs_by_country_name[parent_country].additional_values += additional_values;
                    }
                }
            }

            for (var h = 0; h < $countries.length; h++) {
                if (costs_by_country_name[country_codes[$countries[h].getAttribute('id')]]) {
                    $countries[h].country_name = country_codes[$countries[h].getAttribute('id')];
                    $countries[h].costs = costs_by_country_name[$countries[h].country_name];
                }
            }
        }
    };

    var $map_chart  = document.getElementById('map_chart');

    if ($map_chart) {
        new MapChartData($map_chart).init();
    }
})(document);

// User-Interface

(function(document) {
    var MapChart = function($map_chart) {

        var _this = this;
        _this.$map_chart         = $map_chart;
        _this.$map_chart_image   = _this.$map_chart.querySelector('svg');
        _this.$zoom_in           = _this.$map_chart.querySelector('.zoom_in');
        _this.$zoom_out          = _this.$map_chart.querySelector('.zoom_out');
        _this.$drag_area         = _this.$map_chart.querySelector('.drag_area');
        _this.$countries         = _this.$map_chart.querySelectorAll('path');
        _this.$output            = _this.$map_chart.querySelector('.output');
        _this.$touch_info        = _this.$map_chart.querySelector('.touch_info');
        _this.$switch_view       = document.querySelector('.switch_view');
        _this.$infolist_section  = document.querySelectorAll('.infolist_section');
        _this.zoom               = 1.00;
        _this.zoom_increase      = 1.3;
        _this.min_zoom           = 1;
        _this.max_zoom           = 10;
        _this.x_offset           = 0;
        _this.y_offset           = 0;
        _this.start_event;
        _this.old_event;
    };

    MapChart.prototype = {

        init: function() {
            var _this = this;

            _this.$zoom_in.addEventListener('click', function(event) { // Zoom-In-Button: Click
                _this._zoom_in(event);
            });

            _this.$zoom_in.addEventListener('touchstart', function(event) { // Zoom-In-Button: Touch
                _this._zoom_in(event);
            });

            _this.$zoom_out.addEventListener('click', function(event) { // Zoom-Out-Button: Click
                _this._zoom_out(event);
            });

            _this.$zoom_out.addEventListener('touchstart', function(event) { // Zoom-Out-Button: Touch
                _this._zoom_out(event);
            });

            _this.$map_chart.addEventListener('mousedown', function(event) { // Start moving map with mousedown
                event.preventDefault();
                _this.old_event = event;
                _this.$drag_area.classList.add('visible');

                _this.$drag_area.addEventListener('mousemove', function(event) {
                    _this._drag(event, _this);
                });
            }, false);

            document.addEventListener('mouseup', function() { // End moving map (with mouseup)
                _this.$drag_area.classList.remove('visible');

                _this.$drag_area.removeEventListener('mousemove', function(event) {
                    _this._drag(event);
                });
            }, false);

            document.addEventListener('resize', function() {
                _this.$output.classList.remove('show');
            }, false);

            // Scrollen in Karte mittels touch
            _this.$map_chart.addEventListener('touchstart', function(event) { // Start moving map on touch-device
                if (!event.touches || event.touches.length > 1) {
                    event.preventDefault();
                }

                _this.old_event = event;
                _this.start_event = event;
                _this.$drag_area.classList.remove('visible');

                _this.$map_chart.addEventListener('touchmove', function(event) { // Moving map on touch-device
                    _this._drag(event);
                });
            }, false);

            _this.$map_chart.addEventListener('touchend', function() { // End moving map on touch-device
                _this.$touch_info.classList.add('hideme');
            }, false);

            _this.$switch_view.addEventListener('click', function(event) { // Switch between table-view and map-view
                event.preventDefault();
                var i;

                if (this.classList.contains('data')) {
                    _this.$map_chart.classList.remove('hideme');

                    for (i = 0; i < _this.$infolist_section.length; i++) {
                        _this.$infolist_section[i].classList.add('visible_for_screen_reader');
                    }

                    this.classList.remove('data');
                    this.querySelector('.text').innerHTML = 'zur Tabellenansicht';
                }
                else {
                    _this.$map_chart.classList.add('hideme');

                    for (i = 0; i < _this.$infolist_section.length; i++) {
                        _this.$infolist_section[i].classList.remove('visible_for_screen_reader');
                    }

                    this.classList.add('data');
                    this.querySelector('.text').innerHTML = 'zur grafischen Ansicht';
                }
            }, false);

            _this._setup_map_chart();
        },

        _zoom_in: function(event) {
            event.preventDefault();
            var _this = this;

            _this.$map_chart_image.style.transition = 'transform 0.2s';
            _this.$map_chart_image.addEventListener('transitionend', function() {
                this.style.transition = 'none';
            }, false);

            if (_this.zoom <= _this.max_zoom) {
                _this.zoom = _this.zoom * _this.zoom_increase;
                _this._update_map_chart();
            }
        },

        _zoom_out: function(event) {
            event.preventDefault();
            var _this = this;

            _this.$map_chart_image.style.transition = 'transform 0.2s';
            _this.$map_chart_image.addEventListener('transitionend', function() {
                this.style.transition = 'none';
            }, false);

            if (_this.zoom > _this.min_zoom) {
                _this.zoom = _this.zoom / _this.zoom_increase;
                _this._update_map_chart();
            }
        },

        _proof_zoom: function() { // checks zoom-parameters
            var _this = this;

            if (_this.zoom <= _this.min_zoom) {
                _this.zoom = _this.min_zoom;
                _this.$zoom_out.classList.add('disabled');
                _this.x_offset = 0;
                _this.y_offset = 0;
            }
            else {
                _this.$zoom_in.classList.remove('disabled');
            }

            if (_this.zoom >= _this.max_zoom) {
                _this.zoom = _this.max_zoom;
                _this.$zoom_in.classList.add('disabled');
            }
            else if (_this.zoom > _this.min_zoom) {
                _this.$zoom_out.classList.remove('disabled');
            }
        },

        _proof_offest: function() { // Checks, if map is in frame
            var _this = this;

            if (_this.x_offset > 70 * _this.zoom) {
                _this.x_offset = 70 * _this.zoom;
            }

            if (_this.x_offset < -70 * _this.zoom) {
                _this.x_offset = -70 * _this.zoom;
            }

            if (_this.y_offset > 45 * _this.zoom) {
                _this.y_offset = 45 * _this.zoom;
            }

            if (_this.y_offset < -45 * _this.zoom) {
                _this.y_offset = -45 * _this.zoom;
            }
        },

        _update_map_chart: function() {
            var _this = this;

            _this._proof_offest();
            _this._proof_zoom();
            _this.$map_chart_image.style.transform = 'scale(' + _this.zoom + ') translateX(' + _this.x_offset + 'px) translateY(' + _this.y_offset + 'px)';
            _this.$map_chart_image.style.WebkitTransform = 'scale(' + _this.zoom + ') translateX(' + _this.x_offset + 'px) translateY(' + _this.y_offset + 'px)';
            _this.$map_chart_image.style.msTransform = 'scale(' + _this.zoom + ') translateX(' + _this.x_offset + 'px) translateY(' + _this.y_offset + 'px)';
        },

        _convert_event: function(event) {
            var result;

            if (event.changedTouches) {
                result = {
                    x:event.changedTouches[0].pageX,
                    y:event.changedTouches[0].pageY
                };
            } else {
                result = {
                    x:event.pageX,
                    y:event.pageY
                };
            }

            return result;
        },

        _calc_offset_for_drag: function(event) {
            var _this = this;

            _this.x_offset = _this.x_offset + (-_this._convert_event(_this.old_event)['x'] + _this._convert_event(event)['x'])  / _this.zoom;
            _this.y_offset = _this.y_offset + (-_this._convert_event(_this.old_event)['y'] + _this._convert_event(event)['y']) / _this.zoom;
        },

        _drag: function(event) {
            event.preventDefault();
            var _this = this;

            if (event.touches) { // Touch
                if (event.touches.length <= 1) { // 1 Finger
                    _this.$touch_info.classList.remove('hideme');
                    _this.$output.classList.remove('show');
                }
                else { // > 1 Finger
                    _this._manage_touch_interaction(event);
                    _this.$output.classList.remove('show');
                }
            }
            else { // Mouse
                _this._calc_offset_for_drag(event);
            }

            _this._update_map_chart();
            _this.old_event = event;
        },

        _manage_touch_interaction: function(event) {
            var _this            = this,
                hypotenuse_now   = Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) +
                                   Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2)),
                hypotenuse_start = Math.sqrt(Math.pow(_this.start_event.touches[0].pageX -  _this.start_event.touches[1].pageX, 2) +
                                   Math.pow(_this.start_event.touches[0].pageY -  _this.start_event.touches[1].pageY, 2));

            if (hypotenuse_now < 40) {
                _this._calc_offset_for_drag(event);
                return;
            }

            if (hypotenuse_now > hypotenuse_start - 30 && Math.abs(event.touches[0].pageX - event.touches[1].pageX) < Math.abs(_this.start_event.touches[0].pageX - _this.start_event.touches[1].pageX) + 30) {
                _this._calc_offset_for_drag(event);
                return;
            }

            if (hypotenuse_now > hypotenuse_start - 30 && Math.abs(event.touches[0].pageY - event.touches[1].pageY) < Math.abs(_this.start_event.touches[0].pageY - _this.start_event.touches[1].pageY) + 30) {
                _this._calc_offset_for_drag(event);
                return;
            }
            if (hypotenuse_now > 400) {
                hypotenuse_now = 400;
            }

            if (hypotenuse_now < hypotenuse_start) {
                hypotenuse_now = -hypotenuse_now;
            }

            _this.zoom = _this.zoom + hypotenuse_now / 50000;
        },

        _setup_map_chart: function() { // set styling and classes
            var _this = this;

            for (var i = 0; i < _this.$countries.length; i++) {
                var $country = _this.$countries[i];

                $country.style.removeProperty('fill');

                if ($country.costs && $country.costs['total']) {

                    // IE11-Fallback (don't likes classList.add on svgs)
                    $country.setAttribute('class', 'hasData');
                    $country.style.fillOpacity = ($country.costs['total'] - 20) / 100;

                    $country.addEventListener('mousemove', function(event) { // Infobox moves with mouse
                        _this._show_output(event);
                    });

                    $country.addEventListener('mouseleave', function() {
                        this.style.fillOpacity = (this.costs['total'] - 20) / 100;
                    }, false);

                    _this.$map_chart.addEventListener('mouseleave', function() {
                        _this.$output.classList.remove('show');
                    }, false);

                    $country.addEventListener('touchstart', function(event) {
                        _this._show_output(event);
                    }, false);

                }
                else {
                    $country.setAttribute('class', 'noData');
                }
            }
        },

        _show_output: function(event) { // Shows country-information-box
            var _this = this,
                $country = event.target,
                offsetTop = _this.$map_chart.offsetTop + _this.$map_chart.offsetParent.offsetTop,
                offsetLeft = _this.$map_chart.offsetLeft + _this.$map_chart.offsetParent.offsetLeft;

            _this.$output.innerHTML = '<strong>' + $country.country_name + '</strong><br>Tagesgebühr: ' + $country.costs['daily_fee'] + '<br>Nachtgebühr: ' + $country.costs['nightly_fee'] + $country.costs['additional_values'];

            if (_this._convert_event(event)['x'] + _this.$output.offsetWidth > _this.$map_chart.offsetWidth + offsetLeft - 15) {
                _this.$output.style.left = _this.$map_chart.offsetWidth - _this.$output.offsetWidth  - 15 + 'px';
            }
            else {
                _this.$output.style.left = _this._convert_event(event)['x'] - offsetLeft + 15 + 'px';
            }

            _this.$output.style.top = _this._convert_event(event)['y'] - offsetTop  + 15 + 'px';
            _this.$output.classList.add('show');
            $country.style.fillOpacity = ($country.costs['total'] - 20) / 100 + 0.3;

        }
    };

    var $map_chart  = document.getElementById('map_chart');

    if ($map_chart) {
        new MapChart($map_chart).init();
    }
})(document);

// INFOLISTEN: WEITERE WERTE
// Wird verwendet für Wichtige Beträge (show_more_content)
// -------------------------------------------------------------------------------------------------

(function() {
    var $show_more_content = document.querySelectorAll('.show_more_content');

    for (var i = 0, len = $show_more_content.length; i < len; i++) {
        $show_more_content[i].addEventListener('click', function(event) {
            event.preventDefault();

            var _this      = this,
                content_id = _this.getAttribute('aria-controls'),
                $content   = document.querySelector('#' + content_id);

            if (_this.getAttribute('aria-pressed') === 'true') {
                _this.setAttribute('aria-expanded', 'false');
                _this.setAttribute('aria-pressed', 'false');
                $content.setAttribute('aria-hidden', 'true');
                $content.classList.add('hideme');
            }
            else {
                _this.setAttribute('aria-expanded', 'true');
                _this.setAttribute('aria-pressed', 'true');
                $content.setAttribute('aria-hidden', 'false');
                $content.classList.remove('hideme');
            }
        });
    }
}());

// VCARD SWITCHER FÜR DESKTOP/MOBIL
// Wird verwendet für: team_overview, team_entry, address_vcard_button, steuernews_contact_person
// -------------------------------------------------------------------------------------------------

(function(document) {
    if (device.mobile || device.tablet) {
        return;
    }

    var $vcards = document.querySelectorAll('[data-vcard-href]');

    for (var i = 0, len = $vcards.length; i < len; i++) {
        var $vcard = $vcards[i],
            href   = $vcard.getAttribute('data-vcard-href');

        if (href) {
            $vcard.setAttribute('href', href);
            $vcard.removeAttribute('data-vcard-href');
        }
    }
}(document));

// SLIDER HORIZONTAL
// Wird verwendet für: steuernews_article_slider
// -------------------------------------------------------------------------------------------------

(function(document) {
    var Slider = function($slider) {
        var _this = this;

        _this.$slider_wrapper   = $slider;
        _this.$slider           = $slider.querySelector('.slider');
        _this.$slides           = $slider.querySelectorAll('.slide');
        _this.$prev             = $slider.querySelector('.prev_slide');
        _this.$next             = $slider.querySelector('.next_slide');
        _this.index             = 0;
        _this.time              = 4000;
        _this.intervall;
        _this.touch_start_x;

        // Stoppen wenn Maus über Objekt ist
        _this.stop_on_hover     = false;
    };

    Slider.prototype = {
        init: function() {
            var _this = this;

            _this._init_mouse();
            _this._init_touch();

            if (_this.stop_on_hover) {
                _this.$slider.addEventListener('mouseover', function() {
                    clearInterval(_this.intervall);
                });

                _this.$slider.addEventListener('mouseout', function() {
                    _this.intervall = setInterval(_this._next_slide.bind(_this), _this.time);
                });
            }

            // Im Skript vergeben, wenn kein javascript aktiviert ist soll Button ausgeblendet sein
            _this.$next.classList.add('show');
            _this.intervall = setInterval(_this._next_slide.bind(_this), _this.time);

            window.addEventListener('resize', function() {
                _this._set_height();
            });

            window.addEventListener('load', function() {
                _this._set_height();
            });

        },

        _init_mouse: function() {
            var _this = this;

            _this.$prev.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this._prev_slide();
            });

            _this.$next.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this._next_slide();
            });
        },

        _init_touch: function() {
            var _this = this

            _this.$slider.addEventListener('touchstart', function(event) {
                clearInterval(_this.intervall);
                _this.touch_start_x = event.changedTouches[0].pageX;
            });

            _this.$slider.addEventListener('touchmove', function(event) {
                var touch   = event.touches[0] || event.changedTouches[0],
                    touch_x = touch.pageX;

                if ((touch_x - _this.touch_start_x > 50) || (touch_x - _this.touch_start_x < -50)) {
                    event.preventDefault();
                }
            });

            _this.$slider.addEventListener('touchend', function(event) {
                var touch   = event.touches[0] || event.changedTouches[0],
                    touch_x = touch.pageX;

                if (touch_x - _this.touch_start_x > 50) {
                    if (_this.index > 0) {
                        _this._prev_slide();
                    } else {
                        _this.intervall = setInterval(_this._next_slide.bind(_this), _this.time);
                    }
                }
                else if (touch_x - _this.touch_start_x < -50) {
                    if (_this.index < _this.$slides.length - 1) {
                        _this._next_slide();
                    } else {
                        _this.intervall = setInterval(_this._next_slide.bind(_this), _this.time);
                    }
                }
            });
        },

        _prev_slide: function() {
            var _this = this;

            _this.index--;
            if (_this.index < 0) {
                _this.index = _this.$slides.length - 1;
            }

            _this._slide();
        },

        _next_slide: function() {
            var _this = this;

            _this.index++;
            if (_this.index >= _this.$slides.length) {
                _this.index = 0;
            }

            _this._slide();
        },

        _slide: function() {
            var _this = this,
                value = 'translate(-' + _this.index * 100 / _this.$slides.length + '%)';

            clearInterval(_this.intervall);
            _this.$slider.style.transform = value;
            _this.$slider.style.WebkitTransform = value;
            _this.$slider.style.msTransform = value;
            _this.intervall = setInterval(_this._next_slide.bind(_this), _this.time);
            _this._manage_control();
        },

        _manage_control: function() {
            var _this = this;

            if (_this.index >= 0 && _this.index < _this.$slides.length - 1) {
                _this.$next.classList.add('show');
            } else {
                _this.$next.classList.remove('show');
            }

            if (_this.index > 0 && _this.index < _this.$slides.length) {
                _this.$prev.classList.add('show');
            } else {
                _this.$prev.classList.remove('show');
            }
        },

        _set_height: function() {
            var _this   = this,
                highest = 0,
                height = 0;

            // reset height
            _this.$slider_wrapper.style.height = 'auto';
            _this.$slider.style.height = 'auto';

            for (var i = 0; i < _this.$slides.length; i++) {
                height = _this.$slides[i].clientHeight;
                if (height > highest) {
                    highest = height;
                }
            }

            height = height + 10;

            _this.$slider_wrapper.style.height = highest + 'px';
            _this.$slider.style.height = highest + 'px';
        }
    };

    var $sliders = document.querySelectorAll('.steuernews_article_slider');

    for (var i = 0, len = $sliders.length; i < len; i++) {
        new Slider($sliders[i]).init();
    }

})(document);

// GOOGLE MAPS
// -------------------------------------------------------------------------------------------------

(function(navigator, window, document) {
    var GoogleMaps = function(id, $options) {
        var _this = this;

        _this.$el     = document.querySelector(id);
        _this.id      = _this.$el.getAttribute('id');
        _this.data_id = _this.$el.getAttribute('data-id');

        _this.map_is_ready        = false;
        _this._infowindow_is_open = false;
        _this.static_map_urls     = [];

        _this.$options = _extend({
            max_zoom        : 0,
            min_zoom        : 0,
            map_type        : 'ROADMAP',
            direction_color : '#f60'
        }, $options);
    };

    function _extend() {
        var $extended = {},
            deep      = false,
            index     = 0,
            length    = arguments.length;

        if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
            deep = arguments[0];
            index++;
        }

        function merge(obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        $extended[prop] = _extend(true, $extended[prop], obj[prop]);
                    }
                    else {
                        $extended[prop] = obj[prop];
                    }
                }
            }
        }

        for (; index < length; index++) {
            var obj = arguments[index];
            merge(obj);
        }

        return $extended;
    }

    // function _set_marker_visible(_this,_zoom) {
    //     for (var cnt = 0, len = _this.$options.mapdata.length; cnt < len; cnt++) {
    //         if (_this.$options.mapdata[cnt].min_zoom_visible >= _zoom && _this.$options.mapdata[cnt].min_zoom_visible > 1) {
    //             _this.$options.mapdata[cnt].$marker.setVisible(false);
    //         } else {
    //             _this.$options.mapdata[cnt].$marker.setVisible(true);
    //         }
    //     }
    //     return _this;
    // }

    GoogleMaps.prototype = {
        init: function() {
            var _this = this,
                timeout;

            function _latlng_loaded() {
                timeout = setTimeout(function() {
                    for (var i = 0, len = _this.$options.mapdata.length; i < len; i++) {
                        if (_this.$options.mapdata[i].latlng === undefined) {
                            clearTimeout(timeout);
                            _latlng_loaded();
                            return;
                        }
                    }

                    _this._init_map();
                }, 10);
            }

            function _geocoder_response(s) {
                var $mapdata       = _this.$options.mapdata[s],
                    street_address = $mapdata.street_address,
                    postal_code    = $mapdata.postal_code,
                    locality       = $mapdata.locality,
                    country        = $mapdata.country;

                if (country && locality) {
                    _this.$geocoder.geocode({
                        address: street_address + ', ' + postal_code + ' ' + locality + ' ' + country
                    }, function($results, status) {
                        if (status === google.maps.GeocoderStatus.OK) {
                            $mapdata.latlng    = $results[0].geometry.location;
                            $mapdata.latitude  = $mapdata.latlng.lat();
                            $mapdata.longitude = $mapdata.latlng.lng();
                        }
                        else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                            setTimeout(function() {
                                _geocoder_response(s);
                            }, 10);
                        }
                    });
                }
            }

            if (_this.$options.mapdata) {
                _this.$geocoder = new google.maps.Geocoder();

                for (var s = 0, len = _this.$options.mapdata.length; s < len; s++) {
                    var $mapdata  = _this.$options.mapdata[s],
                        latitude  = $mapdata.latitude,
                        longitude = $mapdata.longitude;

                    if (latitude && longitude) {
                        $mapdata.latlng = new google.maps.LatLng(latitude, longitude);
                    }
                    else {
                        _geocoder_response(s);
                    }
                }

                _latlng_loaded();
            }
        },

        _init_map: function() {
            var _this = this;

            if (_this.$options.latitude > 0 && _this.$options.longitude > 0) {
                _this.$options.latlng = new google.maps.LatLng(_this.$options.latitude, _this.$options.longitude);
            }

            _this.$map = new google.maps.Map(document.getElementById(_this.id), {
                'center'                   : _this.$options.latlng || _this.$options.mapdata[0].latlng,
                'mapTypeId'                : google.maps.MapTypeId[_this.$options.map_type],
                'scrollwheel'              : false,
                'zoom'                     : _this.$options.zoom,
                'disableDefaultUI'         : _this.$options.disable_default_ui,
                'styles'                   : _this.$options.map_style,
                'zoomControlOptions'       : {
                    'position' : google.maps.ControlPosition.TOP_RIGHT
                },
                'mapTypeControlOptions'    : {
                    'position' : google.maps.ControlPosition.TOP_LEFT
                },
                'streetViewControlOptions' : {
                    'position' : google.maps.ControlPosition.TOP_RIGHT
                }
            });

            _this.$bounds = new google.maps.LatLngBounds();

            _this._init_infowindow();
            _this._change_travel_mode();
            _this._set_markers();
            _this._init_directions();
            _this._limit_zoomlevel();
            _this._init_autoselect();
            _this._init_static_maps();
            // _this._watch_marker_zoom();

            window.addEventListener('resize', function() {
                _this.map_resize();
            });

            if (_this.$options.debug) {
                google.maps.event.addDomListener(_this.$map, 'drag', function() {
                    console.log('Center: ' + _this.$map.getCenter());
                });
            }

            _this.map_is_ready = true;
        },

        _init_infowindow: function() {
            var _this = this;

            _this._$infowindow = new google.maps.InfoWindow({
                'maxWidth' : 600
            });

            google.maps.event.addListener(_this.$map, 'click', function() {
                _this._infowindow_is_open = false;
                _this._$infowindow.close();
            });
        },

        _change_travel_mode: function() {
            var _this        = this,
                $travel_mode = document.querySelector('[name="travel_mode_' + _this.data_id + '"]');

            // don't do anything if this map has no route planning
            if (!$travel_mode) {
                return;
            }

            $travel_mode.addEventListener('click', function() {
                this.checked = true;
            });
        },

        _set_markers: function() {
            var _this = this,
                marker_href,
                marker_width,
                marker_height,
                latlng,
                infowindow;

             _this._remove_duplicated_markers();

            for (var index = 0, $mapdata; $mapdata = _this.$options.mapdata[index]; index++) {
                if ($mapdata.disabled) {
                    continue;
                }

                marker_href   = $mapdata.marker_href || _this.$options.marker_href;
                marker_width  = $mapdata.marker_width || _this.$options.marker_width;
                marker_height = $mapdata.marker_height || _this.$options.marker_height;
                latlng        = $mapdata.latlng;
                infowindow    = $mapdata.infowindow;

                $mapdata.$marker = new google.maps.Marker({
                    'animation' : google.maps.Animation.DROP,
                    'clickable' : infowindow ? true : false,
                    'icon'      : marker_href ? {
                                    url        : marker_href,
                                    scaledSize : new google.maps.Size(marker_width, marker_height)
                                } : undefined,
                    'map'       : _this.$map,
                    'optimized' : true,
                    'position'  : latlng,
                    'zIndex'    : index
                });

                $mapdata.$marker.index = index;

                if (infowindow) {
                    $mapdata.$marker.addListener('click', function() {
                        _this.open_infowindow(this.getZIndex());
                    });
                }

                _this.$bounds.extend(latlng);
            }

            if (_this.$options.mapdata.length > 1) {
                _this.$map.fitBounds(_this.$bounds);

                google.maps.event.addListenerOnce(_this.$map, 'idle', function() {
                    if (_this.$options.zoom > 0 && _this.$map.getZoom() > _this.$options.zoom) {
                        _this.$map.setZoom(_this.$options.max_zoom);
                    }
                });
            }
        },

        _remove_all_markers: function() {

        },

        _remove_duplicated_markers: function() {
            var _this   = this,
                $latlng = [],
                $original_map_data,
                original_infowindow,
                latlng,
                index;

            for (var i = 0, $mapdata; $mapdata = _this.$options.mapdata[i]; i++) {
                latlng = $mapdata.latitude + ',' + $mapdata.longitude;
                index = $latlng.indexOf(latlng);

                _this.$options.mapdata[i].$duplicates = [];

                if (index > -1) {
                    $original_map_data  = _this.$options.mapdata[index];
                    original_infowindow = $original_map_data.infowindow;

                    original_infowindow += _this.$options.mapdata[i].infowindow;
                    _this.$options.mapdata[index].infowindow = original_infowindow;

                    _this.$options.mapdata[index].$duplicates.push(i);
                    _this.$options.mapdata[i].disabled = true;
                }

                $latlng.push(latlng);
            }
        },

        _clean_map: function() {
            var _this = this;

            for (var i = 0, len = _this.$polylines.length; i < len; i++) {
                _this.$polylines[i].setMap(null);
            }

            _this.$polylines = [];
        },

        _init_static_maps: function() {
            var _this = this;

            _this.$static_maps = document.querySelectorAll('#static_map_' + _this.id + ' .static_map');

            for (var i = 0, len_i = _this.$static_maps.length; i < len_i; i++) {
                _this.static_map_urls.push(_this.$static_maps[i].src);
            }
        },

        _update_static_maps: function(paths, daddr) {
            var _this = this;

            for (var i = 0, len_i = _this.$static_maps.length; i < len_i; i++) {
                if (i === parseInt(daddr) || !daddr) {

                    _this.$static_maps[i].classList.remove('hideme');

                    if (paths) {
                        _this.$static_maps[i].src = _this.static_map_urls[i] + paths;
                    }
                    else {
                        _this.$static_maps[i].src = _this.static_map_urls[i];
                    }
                }
                else {
                    _this.$static_maps[i].classList.add('hideme');
                }
            }
        },

        _init_directions: function() {
            var _this               = this,
                $direction          = document.querySelector('#direction_' + _this.data_id),
                $panel_wrapper      = document.querySelector('#panel_wrapper_' + _this.data_id),
                $panel_title        = document.querySelector('[id="panel_title_' + _this.data_id + '"]'),
                $panel              = document.querySelector('#panel_' + _this.data_id),
                $directions_service = new google.maps.DirectionsService();

            // don't do anything if this map has no route planning
            if (!$direction) {
                return;
            }

            _this.$saddr     = document.querySelector('#saddr_' + _this.data_id);
            _this.$daddr     = document.querySelector('#daddr_' + _this.data_id);
            _this.$polylines = [];

            $direction.addEventListener('submit', function(event) {
                var saddr        = _this.$saddr.value,
                    daddr        = _this.$daddr.value,
                    $travel_mode = document.querySelector('[name="travel_mode_' + _this.data_id + '"]:checked'),
                    travel_mode,
                    directionsmode,
                    destination;

                event.preventDefault();

                $panel_wrapper.classList.add('hideme');

                // Setzt Fehlerklasse wenn Start- oder Ziel-Adresse leer ist

                if (!saddr.length) {
                    _this.$saddr.classList.add('error');
                    _this.$saddr.setAttribute('aria-invalid', 'true');
                }
                else {
                    _this.$saddr.classList.remove('error');
                    _this.$saddr.setAttribute('aria-invalid', 'false');
                }

                if (_this.$daddr.tagName === 'SELECT') {
                    if (!daddr.length) {
                        _this.$daddr.parentElement.classList.add('error');
                        _this.$daddr.setAttribute('aria-invalid', 'true');
                    }
                    else {
                        _this.$daddr.parentElement.classList.remove('error');
                        _this.$daddr.setAttribute('aria-invalid', 'false');
                    }
                }

                var $input_error = $direction.querySelector('.error');

                if ($input_error) {
                    $input_error.focus();
                }

                // Gibt die Route aus wenn Start- oder Ziel-Adresse vorhanden sind

                if (saddr.length && daddr.length) {
                    destination    = _this.$options.mapdata[daddr].latlng;
                    directionsmode = $travel_mode.value;

                    if (directionsmode === 'driving') {
                        travel_mode = google.maps.DirectionsTravelMode.DRIVING;
                    }
                    else if (directionsmode === 'transit') {
                        travel_mode = google.maps.DirectionsTravelMode.TRANSIT;
                    }
                    else if (directionsmode === 'bicycling') {
                        travel_mode = google.maps.DirectionsTravelMode.BICYCLING;
                    }
                    else {
                        travel_mode = google.maps.DirectionsTravelMode.WALKING;
                    }

                    $directions_service.route({
                        origin      : saddr,
                        destination : destination,
                        travelMode  : travel_mode
                    }, function($result, status) {
                        if (status === google.maps.DirectionsStatus.OK) {
                            var $route        = $result.routes[0],
                                $legs         = $route.legs[0],
                                $steps        = $legs.steps,
                                warnings      = $route.warnings,
                                distance_text = _this.$el.getAttribute('data-lang-distance'),
                                duration_text = _this.$el.getAttribute('data-lang-duration'),
                                static_paths  = '',
                                template      = '',
                                $polyline;

                            _this._clean_map();

                            _this.$route_bounds = $route.bounds;
                            _this.$map.fitBounds(_this.$route_bounds);

                            if (warnings.length) {
                                template += '<p class="warnings">' + warnings + '</p>';
                            }

                            template += '<p class="distance_all">' + distance_text + ' ' + $legs.distance.text + ', ' + duration_text + ' ' + $legs.duration.text + '</p>';
                            template += '<ol class="steps">';
                            template += '<li class="step">';
                            template += '<span class="instructions">' + $legs.start_address + '</span>';
                            template += '</li>';

                            for (var i = 0, steps_len = $steps.length; i < steps_len; i++) {
                                template += '<li class="step">';
                                template += '<span class="instructions">' + $steps[i].instructions.replace(/ style=.+"/gi, '').replace('<div>', '<br><small>').replace('</div>', '</small>') + '</span>';
                                template += '<span class="distance"><span class="visible_for_screen_reader">' + distance_text + '</span> ' + $steps[i].distance.text + '</span>';
                                template += '</li>';

                                var lat = $steps[i].start_location.lat(),
                                    lng = $steps[i].start_location.lng();

                                static_paths += '%7C' + lat + ',' + lng;

                                $polyline = new google.maps.Polyline({
                                    path          : $steps[i].path,
                                    strokeColor   : _this.$options.direction_color,
                                    strokeOpacity : 0.8,
                                    strokeWeight  : 5
                                });

                                $polyline.setMap(_this.$map);
                                _this.$polylines.push($polyline);
                            }

                            _this._update_static_maps(static_paths, daddr);

                            template += '<li class="last step">';
                            template += '<span class="instructions">' + _this.$options.mapdata[daddr]['street_address'] + ', ' + _this.$options.mapdata[daddr]['postal_code'] + ' ' + _this.$options.mapdata[daddr]['locality'] + ', ' + $legs.end_address.split(', ')[$legs.end_address.split(', ').length - 1] + '</span>';
                            template += '</li>';
                            template += '</ol>';
                            template += '<p class="copyright"><small>' + $route.copyrights + '</small></p>';

                            if (typeof _this.$start_marker === 'object') {
                                _this.$start_marker.setMap(null);
                            }

                            _this.$start_marker = new google.maps.Marker({
                                clickable : false,
                                icon      : _this.$options.start_marker_href ? {
                                                url        : _this.$options.start_marker_href,
                                                scaledSize : new google.maps.Size(_this.$options.start_marker_width, _this.$options.start_marker_height)
                                            } : undefined,
                                map       : _this.$map,
                                optimized : false,
                                position  : $legs.start_location
                            });

                            for (var j = 0, mapdata_len = _this.$options.mapdata.length; j < mapdata_len; j++) {
                                _this.$options.mapdata[j].$marker.setVisible(false);
                            }

                            _this.$options.mapdata[daddr].$marker.setVisible(true);

                            // Blendet zusätzliche Marker zB Parkplatz in der Routenansicht aus (jc)
                            // _this = _set_marker_visible(_this, '1');

                            if (device.ios) {
                                document.location = 'maps://maps.google.com/maps?saddr=' + saddr + '&daddr=' + destination + '&directionsmode=' + directionsmode;
                            }
                            else if (!device.ios && (device.mobile || device.tablet)) {
                                document.location = 'https://maps.google.com/maps?saddr=' + saddr + '&daddr=' + destination + '&directionsmode=' + directionsmode;
                            }
                            else {
                                $panel_wrapper.classList.remove('hideme');
                                $panel_title.focus();

                                if ($panel.firstChild) {
                                    $panel.removeChild($panel.firstChild);
                                }

                                $panel.innerHTML = template;
                            }
                         }
                    });

                    _this._google_analytics_tracking();
                }
                else if ($panel.firstChild) {
                    $panel.removeChild($panel.firstChild);
                }
            });
        },

        _google_analytics_tracking: function() {
            if (has_google_analytics) {
                ga('send', 'event', 'Google Maps', 'Route berechnet');
            }
        },

        _limit_zoomlevel: function() {
            var _this = this;

            if (_this.$options.max_zoom === 0 && _this.$options.min_zoom === 0 ||
                _this.$options.max_zoom !== 0 && _this.$options.min_zoom !== 0 &&
                _this.$options.max_zoom < _this.$options.min_zoom) {
                return;
            }

            google.maps.event.addDomListener(_this.$map, 'zoom_changed', function() {
                if (_this.$options.min_zoom !== 0 && this.getZoom() < _this.$options.min_zoom) {
                    this.setZoom(_this.$options.min_zoom);
                }

                if (_this.$options.max_zoom !== 0 && this.getZoom() > _this.$options.max_zoom) {
                    this.setZoom(_this.$options.max_zoom);
                }
            });
        },

        _init_autoselect: function() {
            var _this = this;

            // don't do anything if this map has no route planning
            if (!_this.$daddr) {
                return;
            }

            _this.$daddr.addEventListener('change', function() {
                var index = this.options[this.selectedIndex].value;

                _this._clean_map();
                _this.$route_bounds = '';

                if (typeof _this.$start_marker === 'object') {
                    _this.$start_marker.setMap(null);
                }

                for (var i = 0, len = _this.$options.mapdata.length; i < len; i++) {
                    _this.$options.mapdata[i].$marker.setVisible(true);
                }

                _this._update_static_maps(false, index);
                _this.show_marker(index);
            });
        },

        // Blendet zusätzliche Marker, zB Parkplatz, ab einer im CMS-Objekt gegebenen Zoomstufe aus (jc)

        // _watch_marker_zoom: function() {
        //         var _this = this;
        //
        //         google.maps.event.addDomListener(_this.$map, 'zoom_changed', function() {
        //             _this = _set_marker_visible(_this, _this.$map.getZoom());
        //         });
        // },

        _get_current_index: function(index) {
            var _this = this;

            for (var i = 0, $mapdata; $mapdata = _this.$options.mapdata[i]; i++) {
                if ($mapdata.$duplicates.indexOf(parseInt(index)) > -1) {
                    index = i;
                    break;
                }
            }

            return index;
        },

        show_marker: function(index) {
            var _this = this,
                $mapdata;

            if (index) {
                index    = _this._get_current_index(index);
                $mapdata = _this.$options.mapdata[index];

                _this.$map.setZoom(_this.$options.zoom);
                _this.$map.panTo($mapdata.latlng);

                if ($mapdata.infowindow) {
                    _this.open_infowindow(index);
                }
            }
            else {
                _this.$map.fitBounds(_this.$bounds);
            }
        },

        open_infowindow: function(index) {
            var _this = this,
                $mapdata;

            index    = _this._get_current_index(index);
            $mapdata = _this.$options.mapdata[index];

            _this._infowindow_is_open  = true;
            _this._$infowindow_mapdata = $mapdata;

            _this._$infowindow.setContent('<div class="infowindow">' + $mapdata.infowindow + '</div>');
            _this._$infowindow.open(_this.$map, $mapdata.$marker);
        },

        map_resize: function() {
            var _this  = this,
                center = _this.$map.getCenter();

            google.maps.event.trigger(_this.$map, 'resize');

            _this._$infowindow.close();

            if (_this.$route_bounds) {
                _this.$map.setCenter(center);
                _this.$map.fitBounds(_this.$route_bounds);
            }
            else if (_this._infowindow_is_open) {
                _this.$map.panTo(_this._$infowindow_mapdata.latlng);
            }
            else if (_this.$options.mapdata.length > 1) {
                _this.$map.setCenter(center);
                _this.$map.fitBounds(_this.$bounds);
            }
            else {
                _this.$map.panTo(_this.$options.mapdata[0].latlng);
            }
        }
    };

    if (window.$google_maps_data) {
        for (var i = 0, len = window.$google_maps_data.length; i < len; i++) {
            var id       = window.$google_maps_data[i].id,
                $options = window.$google_maps_data[i].options;

            new GoogleMaps('#' + id, $options).init();
        }
    }
})(navigator, window, document);

// ACCORDION
// Wird verwendet für: infolist_list_content, listfoldercontent, u_online_benefits_1
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var Accordion = function($accordion) {
        var _this = this;

        _this.$accordion    = $accordion;
        _this.$tab          = $accordion.querySelectorAll('[role=tab]');
        _this.anchor        = location.hash;

        _this.one_tab_open  = true; // only one Tab open
    }
    Accordion.prototype = {
        init: function() {
            var _this  = this;

            _this._setup_accordion();
            _this._keyboard_nav();

            if (_this.anchor.length > 0) {
                _this._open_tabpanel(_this.$accordion.querySelector(_this.anchor));
            }

            for (var i = 0; i < _this.$tab.length; i++) {
                _this.$tab[i].addEventListener('click', function(event) {
                    event.preventDefault();
                    _this._toggle_tabpanel(this);
                });
            }

            window.addEventListener('resize', function() {
                _this._on_resize();
            });

        },

        _toggle_tabpanel: function($tab) {
            var _this = this;

            if ($tab.getAttribute('aria-expanded') === 'true') {
                _this._close_tabpanel($tab);
            }
            else {
                _this._open_tabpanel($tab);
            }
        },

        _close_tabpanel: function($tab) {
            var _this  = this,
                $tabpanel = _this._get_tabpanel($tab);

            $tab.setAttribute('aria-expanded', 'false');
            $tab.setAttribute('tabindex', '-1');
            $tabpanel.setAttribute('aria-hidden', 'true');
            $tabpanel.style.maxHeight = 0;
            $tabpanel.addEventListener('transitionend', function() {
                if (this.getAttribute('aria-hidden') === 'true') {
                    this.classList.add('hideme');
                }
            }, false);
        },

        _open_tabpanel: function($tab) {
            var _this  = this,
                $tabpanel = _this._get_tabpanel($tab);

            if (_this.one_tab_open) {
                for (var i = 0; i < _this.$tab.length; i++) {
                    if (_this.$tab[i] !== $tab) {
                        _this._close_tabpanel(_this.$tab[i]);
                    }
                }
            }

            $tab.setAttribute('aria-expanded', 'true');
            $tab.setAttribute('tabindex', '0');
            $tabpanel.setAttribute('aria-hidden', 'false');
            $tabpanel.classList.remove('hideme');
            setTimeout(function() {
                $tabpanel.style.maxHeight = $tabpanel.max_height + 'px';
            }, 20);
        },

        _get_tabpanel: function($tab) {
            return document.querySelector('#' +  $tab.getAttribute('aria-controls'));
        },

        _setup_accordion: function() {
            var _this = this,
                $tabpanel;

            for (var i = 0; i < _this.$tab.length; i++) {
                _this.$tab[i].index = i;
                $tabpanel = _this._get_tabpanel(_this.$tab[i]);
                $tabpanel.classList.remove('hideme');
                $tabpanel.max_height = $tabpanel.clientHeight;
                _this._close_tabpanel(_this.$tab[i]);
                $tabpanel.classList.add('animated');
                $tabpanel.classList.add('hideme');
            }
            _this.$tab[0].setAttribute('tabindex', '0');
        },

        _on_resize: function() {
            var _this = this,
                $tabpanel;

            for (var i = 0; i < _this.$tab.length; i++) {
                $tabpanel = _this._get_tabpanel(_this.$tab[i]);
                $tabpanel.removeAttribute('style');
                $tabpanel.classList.remove('animated');
                $tabpanel.classList.remove('hideme');
                $tabpanel.max_height = $tabpanel.clientHeight;

                if (_this.$tab[i].getAttribute('aria-expanded') === 'true') {
                    _this._open_tabpanel(_this.$tab[i]);
                } else {
                    _this._close_tabpanel(_this.$tab[i]);
                }

                $tabpanel.classList.add('animated');
            }
        },

        _keyboard_nav: function() {
            var _this = this,
                $map  = {
                            13 : false, // Eingabe
                            32 : false, // Leertaste
                            35 : false, // Pos1
                            36 : false, // Ende
                            37 : false, // Pfeil nach links
                            38 : false, // Pfeil nach oben
                            39 : false, // Pfeil nach rechts
                            40 : false  // Pfeil nach unten
                        },
                index;

            for (var i = 0; i < _this.$tab.length; i++) {

                _this.$tab[i].addEventListener('keydown', function(event) {
                    index = this.index;
                    if (event.keyCode in $map) {
                        event.preventDefault();
                        $map[event.keyCode] = true;

                        if ($map[13] || $map[32]) {
                            _this._toggle_tabpanel(this);
                        }
                        else if ($map[35]) {
                            _this._change_focused_tab(_this.$tab.length - 1);
                        }
                        else if ($map[36]) {
                            _this._change_focused_tab(0);
                        }
                        else if ($map[37] || $map[38]) {
                            _this._change_focused_tab(index - 1);
                        }
                        else if ($map[39] || $map[40]) {
                            _this._change_focused_tab(index + 1);
                        }
                    }
                });

                _this.$tab[i].addEventListener('keyup', function(event) {
                    if (event.keyCode in $map) {
                        $map[event.keyCode] = false;
                    }
                });
            }
        },

        _change_focused_tab: function(index) {
            var _this = this;

            if (index === _this.$tab.length) {
                index = 0;
            }

            if (index === -1) {
                index = _this.$tab.length - 1;
            }

            $tab = _this.$tab[index];

            for (var i = 0; i < _this.$tab.length; i++) {
                _this.$tab[i].setAttribute('tabindex', '-1');
                _this.$tab[i].setAttribute('aria-selected', 'false');
            }

            $tab.setAttribute('tabindex', '0');
            $tab.setAttribute('aria-selected', 'true');

            $tab.focus();
        }
    };

    var $accordions = document.querySelectorAll('.accordion');

    for (var i = 0; i < $accordions.length; i++) {
        new Accordion($accordions[i]).init();
    }

})(document, window);

// ONLINETOOL POPUP
// Wird verwendet für: download_overview, onlinetools_popup_overview, video_tutorials_overview
// -------------------------------------------------------------------------------------------------

(function(document, window) {
    var OnlinetoolPopup = function($onlinetool) {
        var _this = this;

        _this.$onlinetool = $onlinetool;

        _this.title = $onlinetool.getAttribute('title');
        _this.id    = '#' + $onlinetool.getAttribute('data-popup-id');
        _this.href  = $onlinetool.getAttribute('href');
    },

    $body = document.querySelector('body'),
    $popup,
    $content,
    $close,
    $iframe;

    // Private

    function _create_element(html) {
        var $div            = document.createElement('div'),
            $filtered_nodes = [],
            $nodes;

        $div.innerHTML = html.trim();
        $nodes         = $div.childNodes;

        for (var i = 0, len = $nodes.length; $nodes !== null && i < len; i++) {
            if ($nodes[i].nodeType === 1) {
                $filtered_nodes.push($nodes[i]);
            }
        }

        return $filtered_nodes;
    }

    function _create_popup() {
        var html = '',
            $html;

        html += '<div class="hideme_print popup_overlay">';
        html += '<div class="popup_content">';
        html += '<div class="popup_header">';
        html += '<a class="popup_close" href=""><svg class="icon"><use xlink:href="' + zms_common + 'images/sprite/symbol/svg/sprite.symbol.svg#close"></use></svg></a>';
        html += '</div>';
        html += '<div class="content preloader">';
        html += '<svg class="icon_spin"><use xlink:href="' + zms_common + 'images/sprite/symbol/svg/sprite.symbol.svg#spin"></use></svg>';
        html += '<iframe class="popup_iframe" frameborder="0" src="" title="Onlinetool"></iframe>';
        html += '</div>';
        html += '</div>';
        html += '</div>';

        $html = _create_element(html);

        for (var j = 0, html_len = $html.length; j < html_len; j++) {
            $body.appendChild($html[j]);
        }

        $popup   = document.querySelector('.popup_overlay');
        $content = $popup.querySelector('.popup_content');
        $close   = $popup.querySelector('.popup_close');
        $iframe  = $popup.querySelector('iframe');

        $iframe.addEventListener('load', function() {
            if ($iframe.getAttribute('src').length && $popup.classList.contains('show')) {
                $iframe.classList.add('show');
            }
        });
    }

    function _close_popup() {
        var _close = function() {
            $body.classList.remove('no_scroll');
            $content.classList.remove('show');
            $iframe.classList.remove('show');

            window.history.replaceState(null, document.title, window.location.pathname);
        };

        $close.addEventListener('click', function(event) {
            event.preventDefault();
            _close();
        });

        document.addEventListener('keydown', function(event) {
            if ($popup.classList.contains('show') && event.which === 27) {
                _close();
            }
        });

        $content.addEventListener('transitionend', function() {
            if (!$content.classList.contains('show')) {
                $popup.classList.remove('show');
            }
        });
    }

    _create_popup();
    _close_popup();

    // Public

    OnlinetoolPopup.prototype = {
        init: function() {
            var _this = this;

            _this.$onlinetool.addEventListener('click', function(event) {
                event.preventDefault();
                _this.open();
            });
        },

        open: function() {
            var _this = this;

            $body.classList.add('no_scroll');
            $popup.classList.add('show');
            $content.classList.add('show');
            $iframe.setAttribute('src', _this.href);

            window.history.replaceState(null, document.title, _this.id);
        }
    };

    if (window.device.mobile || window.device.tablet) {
        return;
    }

    var $onlinetools = document.querySelectorAll('[data-popup="true"]'),
        $onlinetool;

    for (var i = 0, len = $onlinetools.length; i < len; i++) {
        $onlinetool = new OnlinetoolPopup($onlinetools[i]);

        $onlinetool.init();

        if ($onlinetool.id === window.location.hash) {
            $onlinetool.open();
        }
    }
})(document, window);

/**
 * Swiper 4.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2018 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 14, 2018
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Swiper = factory());
}(this, (function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.2
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2018, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: September 13, 2018
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    var this$1 = this;

    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this$1[j] !== 'undefined' && typeof this$1[j].classList !== 'undefined') { this$1[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var this$1 = this;

    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this$1[j] !== 'undefined' && typeof this$1[j].classList !== 'undefined') { this$1[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var this$1 = this;

    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this$1[j] !== 'undefined' && typeof this$1[j].classList !== 'undefined') { this$1[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;
    var this$1 = this;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this$1[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this$1[i][attrName] = attrs[attrName];
          this$1[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    var this$1 = this;

    for (var i = 0; i < this.length; i += 1) {
      this$1[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var this$1 = this;

    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this$1[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    var this$1 = this;

    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this$1[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    var this$1 = this;

    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this$1[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var this$1 = this;
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this$1[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var this$1 = this;
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this$1[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var this$1 = this;
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this$1[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var this$1 = this;

    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this$1[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this$1[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    var this$1 = this;

    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this$1[i], i, this$1[i]) === false) {
        // End the loop early
        return this$1;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  // eslint-disable-next-line
  function html(html) {
    var this$1 = this;

    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this$1[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    var this$1 = this;

    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this$1[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var this$1 = this;
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this$1[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this$1[i].appendChild(newChild[j]);
          }
        } else {
          this$1[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var this$1 = this;

    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this$1[i].insertBefore(tempDiv.childNodes[j], this$1[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this$1[i].insertBefore(newChild[j], this$1[i].childNodes[0]);
        }
      } else {
        this$1[i].insertBefore(newChild, this$1[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var this$1 = this;

    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this$1[i].parentNode !== null) {
        if (selector) {
          if ($(this$1[i].parentNode).is(selector)) { parents.push(this$1[i].parentNode); }
        } else {
          parents.push(this$1[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var this$1 = this;

    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this$1[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var this$1 = this;

    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this$1[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var this$1 = this;

    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this$1[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    var this$1 = this;

    for (var i = 0; i < this.length; i += 1) {
      if (this$1[i].parentNode) { this$1[i].parentNode.removeChild(this$1[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    var testDiv = doc.createElement('div');
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!(('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent),
      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

      transition: (function checkTransition() {
        var style = testDiv.style;
        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
      }()),
      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
        var style = testDiv.style;
        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
      }()),

      flexbox: (function checkFlexbox() {
        var style = testDiv.style;
        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
        for (var i = 0; i < styles.length; i += 1) {
          if (styles[i] in style) { return true; }
        }
        return false;
      }()),

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      handler.apply(self, args);
      self.off(events, onceHandler);
    }
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = slidesPerRow - ((params.slidesPerColumn * slidesPerRow) - slidesLength);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - (column * slidesPerColumn);
          if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
            row += 1;
            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide
          .css(
            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
          )
          .attr('data-swiper-column', column)
          .attr('data-swiper-row', row);
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            slideSize = slide[0].getBoundingClientRect().width
              + parseFloat(slideStyles.getPropertyValue('margin-left'))
              + parseFloat(slideStyles.getPropertyValue('margin-right'));
          } else {
            slideSize = slide[0].getBoundingClientRect().height
              + parseFloat(slideStyles.getPropertyValue('margin-top'))
              + parseFloat(slideStyles.getPropertyValue('margin-bottom'));
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (!Support.flexbox || params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size)
                  || (slideAfter > 0 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (!params.virtualTranslate) {
      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    swiper.$wrapperEl.transition(duration);

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }

    if (speed === 0 || !Support.transition) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    if (snapIndex < swiper.snapGrid.length - 1) {
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
        index = swiper.params.slidesPerGroup;
      }
    }

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();


    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      windows: false,
      iphone: false,
      ipod: false,
      ipad: false,
      cordova: win.cordova || win.phonegap,
      phonegap: win.cordova || win.phonegap,
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


    // Windows
    if (windows) {
      device.os = 'windows';
      device.osVersion = windows[2];
      device.windows = true;
    }
    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
      var osVersionArr = device.osVersion.split('.');
      var metaViewport = doc.querySelector('meta[name="viewport"]');
      device.minimalUi = !device.webView
        && (ipod || iphone)
        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$(e).closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($(e.target).is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== e.target
      ) {
        doc.activeElement.blur();
      }
      if (preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        data.clickTimeout = Utils.nextTick(function () {
          if (!swiper || swiper.destroyed) { return; }
          swiper.emit('click', e);
        }, 300);
      }
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        swiper.emit('doubleTap', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    if (params.freeMode) {
      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    {
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.addEventListener('mousedown', swiper.onTouchStart, false);
          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.addEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.removeEventListener('mousedown', swiper.onTouchStart, false);
          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.removeEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);
    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakPointsParams = breakpoint in breakpoints ? breakpoints[breakpoint] : swiper.originalParams;
      var needsReLoop = params.loop && (breakPointsParams.slidesPerView !== params.slidesPerView);

      Utils.extend(swiper.params, breakPointsParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }
      swiper.emit('breakpoint', breakPointsParams);
    }
  }

  function getBreakpoint (breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
        if (point <= win.innerWidth) {
          breakpoint = point;
        }
      } else if (point >= win.innerWidth && !breakpoint) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (!Support.flexbox) {
      suffixes.push('no-flexbox');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }
    // WP8 Touch Events Fix
    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      suffixes.push(("wp8-" + (params.direction)));
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;

    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = (function (SwiperClass$$1) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass$$1.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          } else if (Support.prefixedPointerEvents) {
            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass$$1 ) Swiper.__proto__ = SwiperClass$$1;
    Swiper.prototype = Object.create( SwiperClass$$1 && SwiperClass$$1.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update$$1 () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index')
            .removeAttr('data-swiper-column')
            .removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass$$1;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: false });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return a < b; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slide) {
      var swiper = this;
      swiper.virtual.slides.push(slide);
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slide) {
      var swiper = this;
      swiper.virtual.slides.unshift(slide);
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          newCache[cachedIndex + 1] = cache[cachedIndex];
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideNext(0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        swiper.virtual.update();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40))) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38))) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if ((kc === 39 && !rtl) || (kc === 37 && rtl)) { swiper.slideNext(); }
        if ((kc === 37 && !rtl) || (kc === 39 && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 40) { swiper.slideNext(); }
        if (kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    event: (function getEvent() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    }()),
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
              swiper.slideNext();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) { return true; }
          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) { return true; }
        }
        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      } else {
        // Freemode or scrollContainer:
        if (swiper.params.loop) {
          swiper.loopFix();
        }
        var position = swiper.getTranslate() + (delta * params.sensitivity);
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = Utils.nextTick(function () {
            swiper.slideToClosest();
          }, 300);
        }
        // Emit event
        swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          lastScrollTime: Utils.now(),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', function (e) {
          e.preventDefault();
          if (swiper.isEnd && !swiper.params.loop) { return; }
          swiper.slideNext();
        });
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', function (e) {
          e.preventDefault();
          if (swiper.isBeginning && !swiper.params.loop) { return; }
          swiper.slidePrev();
        });
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click');
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click');
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          if ($nextEl) { $nextEl.toggleClass(swiper.params.navigation.hiddenClass); }
          if ($prevEl) { $prevEl.toggleClass(swiper.params.navigation.hiddenClass); }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            $firstDisplayedBullet
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev"))
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev-prev"));
            $lastDisplayedBullet
              .next()
              .addClass(((params.bulletActiveClass) + "-next"))
              .next()
              .addClass(((params.bulletActiveClass) + "-next-next"));
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        } else {
          $dragEl.transform(("translateX(" + newPos + "px)"));
        }
        $dragEl[0].style.width = newSize + "px";
      } else {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        } else {
          $dragEl.transform(("translateY(" + newPos + "px)"));
        }
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbarHide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;

      var pointerPosition;
      if (swiper.isHorizontal()) {
        pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
      } else {
        pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
      }
      var positionRatio;
      positionRatio = ((pointerPosition) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEvents = swiper.touchEvents;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        if (Support.touch) {
          target.addEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
          target.addEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
          target.addEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.addEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
          doc.addEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
          doc.addEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
        }
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEvents = swiper.touchEvents;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        if (Support.touch) {
          target.removeEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
          target.removeEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
          target.removeEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.removeEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
          doc.removeEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
          doc.removeEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
        }
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        swiper.zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');
        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;

        zoom.scale = 1;
        zoom.currentScale = 1;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };
      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }

        if (thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

})));

/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
/*! Gecko-Picture - v1.0
 * https://github.com/scottjehl/picturefill/tree/3.0/src/plugins/gecko-picture
 * Firefox's early picture implementation (prior to FF41) is static and does
 * not react to viewport changes. This tiny module fixes this.
 */
(function(window) {
	/*jshint eqnull:true */
	var ua = navigator.userAgent;

	if ( window.HTMLPictureElement && ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 < 45) ) {
		addEventListener("resize", (function() {
			var timer;

			var dummySrc = document.createElement("source");

			var fixRespimg = function(img) {
				var source, sizes;
				var picture = img.parentNode;

				if (picture.nodeName.toUpperCase() === "PICTURE") {
					source = dummySrc.cloneNode();

					picture.insertBefore(source, picture.firstElementChild);
					setTimeout(function() {
						picture.removeChild(source);
					});
				} else if (!img._pfLastSize || img.offsetWidth > img._pfLastSize) {
					img._pfLastSize = img.offsetWidth;
					sizes = img.sizes;
					img.sizes += ",100vw";
					setTimeout(function() {
						img.sizes = sizes;
					});
				}
			};

			var findPictureImgs = function() {
				var i;
				var imgs = document.querySelectorAll("picture > img, img[srcset][sizes]");
				for (i = 0; i < imgs.length; i++) {
					fixRespimg(imgs[i]);
				}
			};
			var onResize = function() {
				clearTimeout(timer);
				timer = setTimeout(findPictureImgs, 99);
			};
			var mq = window.matchMedia && matchMedia("(orientation: landscape)");
			var init = function() {
				onResize();

				if (mq && mq.addListener) {
					mq.addListener(onResize);
				}
			};

			dummySrc.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

			if (/^[c|i]|d$/.test(document.readyState || "")) {
				init();
			} else {
				document.addEventListener("DOMContentLoaded", init);
			}

			return onResize;
		})());
	}
})(window);

/*! Picturefill - v3.0.2
 * http://scottjehl.github.io/picturefill
 * Copyright (c) 2015 https://github.com/scottjehl/picturefill/blob/master/Authors.txt;
 *  License: MIT
 */

(function( window, document, undefined ) {
	// Enable strict mode
	"use strict";

	// HTML shim|v it for old IE (IE9 will still need the HTML video tag workaround)
	document.createElement( "picture" );

	var warn, eminpx, alwaysCheckWDescriptor, evalId;
	// local object for method references and testing exposure
	var pf = {};
	var isSupportTestReady = false;
	var noop = function() {};
	var image = document.createElement( "img" );
	var getImgAttr = image.getAttribute;
	var setImgAttr = image.setAttribute;
	var removeImgAttr = image.removeAttribute;
	var docElem = document.documentElement;
	var types = {};
	var cfg = {
		//resource selection:
		algorithm: ""
	};
	var srcAttr = "data-pfsrc";
	var srcsetAttr = srcAttr + "set";
	// ua sniffing is done for undetectable img loading features,
	// to do some non crucial perf optimizations
	var ua = navigator.userAgent;
	var supportAbort = (/rident/).test(ua) || ((/ecko/).test(ua) && ua.match(/rv\:(\d+)/) && RegExp.$1 > 35 );
	var curSrcProp = "currentSrc";
	var regWDesc = /\s+\+?\d+(e\d+)?w/;
	var regSize = /(\([^)]+\))?\s*(.+)/;
	var setOptions = window.picturefillCFG;
	/**
	 * Shortcut property for https://w3c.github.io/webappsec/specs/mixedcontent/#restricts-mixed-content ( for easy overriding in tests )
	 */
	// baseStyle also used by getEmValue (i.e.: width: 1em is important)
	var baseStyle = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)";
	var fsCss = "font-size:100%!important;";
	var isVwDirty = true;

	var cssCache = {};
	var sizeLengthCache = {};
	var DPR = window.devicePixelRatio;
	var units = {
		px: 1,
		"in": 96
	};
	var anchor = document.createElement( "a" );
	/**
	 * alreadyRun flag used for setOptions. is it true setOptions will reevaluate
	 * @type {boolean}
	 */
	var alreadyRun = false;

	// Reusable, non-"g" Regexes

	// (Don't use \s, to avoid matching non-breaking space.)
	var regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
	    regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
	    regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
	    regexTrailingCommas = /[,]+$/,
	    regexNonNegativeInteger = /^\d+$/,

	    // ( Positive or negative or unsigned integers or decimals, without or without exponents.
	    // Must include at least one digit.
	    // According to spec tests any decimal point must be followed by a digit.
	    // No leading plus sign is allowed.)
	    // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	    regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/;

	var on = function(obj, evt, fn, capture) {
		if ( obj.addEventListener ) {
			obj.addEventListener(evt, fn, capture || false);
		} else if ( obj.attachEvent ) {
			obj.attachEvent( "on" + evt, fn);
		}
	};

	/**
	 * simple memoize function:
	 */

	var memoize = function(fn) {
		var cache = {};
		return function(input) {
			if ( !(input in cache) ) {
				cache[ input ] = fn(input);
			}
			return cache[ input ];
		};
	};

	// UTILITY FUNCTIONS

	// Manual is faster than RegEx
	// http://jsperf.com/whitespace-character/5
	function isSpace(c) {
		return (c === "\u0020" || // space
		        c === "\u0009" || // horizontal tab
		        c === "\u000A" || // new line
		        c === "\u000C" || // form feed
		        c === "\u000D");  // carriage return
	}

	/**
	 * gets a mediaquery and returns a boolean or gets a css length and returns a number
	 * @param css mediaqueries or css length
	 * @returns {boolean|number}
	 *
	 * based on: https://gist.github.com/jonathantneal/db4f77009b155f083738
	 */
	var evalCSS = (function() {

		var regLength = /^([\d\.]+)(em|vw|px)$/;
		var replace = function() {
			var args = arguments, index = 0, string = args[0];
			while (++index in args) {
				string = string.replace(args[index], args[++index]);
			}
			return string;
		};

		var buildStr = memoize(function(css) {

			return "return " + replace((css || "").toLowerCase(),
				// interpret `and`
				/\band\b/g, "&&",

				// interpret `,`
				/,/g, "||",

				// interpret `min-` as >=
				/min-([a-z-\s]+):/g, "e.$1>=",

				// interpret `max-` as <=
				/max-([a-z-\s]+):/g, "e.$1<=",

				//calc value
				/calc([^)]+)/g, "($1)",

				// interpret css values
				/(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)",
				//make eval less evil
				/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/ig, ""
			) + ";";
		});

		return function(css, length) {
			var parsedLength;
			if (!(css in cssCache)) {
				cssCache[css] = false;
				if (length && (parsedLength = css.match( regLength ))) {
					cssCache[css] = parsedLength[ 1 ] * units[parsedLength[ 2 ]];
				} else {
					/*jshint evil:true */
					try{
						cssCache[css] = new Function("e", buildStr(css))(units);
					} catch(e) {}
					/*jshint evil:false */
				}
			}
			return cssCache[css];
		};
	})();

	var setResolution = function( candidate, sizesattr ) {
		if ( candidate.w ) { // h = means height: || descriptor.type === 'h' do not handle yet...
			candidate.cWidth = pf.calcListLength( sizesattr || "100vw" );
			candidate.res = candidate.w / candidate.cWidth ;
		} else {
			candidate.res = candidate.d;
		}
		return candidate;
	};

	/**
	 *
	 * @param opt
	 */
	var picturefill = function( opt ) {

		if (!isSupportTestReady) {return;}

		var elements, i, plen;

		var options = opt || {};

		if ( options.elements && options.elements.nodeType === 1 ) {
			if ( options.elements.nodeName.toUpperCase() === "IMG" ) {
				options.elements =  [ options.elements ];
			} else {
				options.context = options.elements;
				options.elements =  null;
			}
		}

		elements = options.elements || pf.qsa( (options.context || document), ( options.reevaluate || options.reselect ) ? pf.sel : pf.selShort );

		if ( (plen = elements.length) ) {

			pf.setupRun( options );
			alreadyRun = true;

			// Loop through all elements
			for ( i = 0; i < plen; i++ ) {
				pf.fillImg(elements[ i ], options);
			}

			pf.teardownRun( options );
		}
	};

	/**
	 * outputs a warning for the developer
	 * @param {message}
	 * @type {Function}
	 */
	warn = ( window.console && console.warn ) ?
		function( message ) {
			console.warn( message );
		} :
		noop
	;

	if ( !(curSrcProp in image) ) {
		curSrcProp = "src";
	}

	// Add support for standard mime types.
	types[ "image/jpeg" ] = true;
	types[ "image/gif" ] = true;
	types[ "image/png" ] = true;

	function detectTypeSupport( type, typeUri ) {
		// based on Modernizr's lossless img-webp test
		// note: asynchronous
		var image = new window.Image();
		image.onerror = function() {
			types[ type ] = false;
			picturefill();
		};
		image.onload = function() {
			types[ type ] = image.width === 1;
			picturefill();
		};
		image.src = typeUri;
		return "pending";
	}

	// test svg support
	types[ "image/svg+xml" ] = document.implementation.hasFeature( "http://www.w3.org/TR/SVG11/feature#Image", "1.1" );

	/**
	 * updates the internal vW property with the current viewport width in px
	 */
	function updateMetrics() {

		isVwDirty = false;
		DPR = window.devicePixelRatio;
		cssCache = {};
		sizeLengthCache = {};

		pf.DPR = DPR || 1;

		units.width = Math.max(window.innerWidth || 0, docElem.clientWidth);
		units.height = Math.max(window.innerHeight || 0, docElem.clientHeight);

		units.vw = units.width / 100;
		units.vh = units.height / 100;

		evalId = [ units.height, units.width, DPR ].join("-");

		units.em = pf.getEmValue();
		units.rem = units.em;
	}

	function chooseLowRes( lowerValue, higherValue, dprValue, isCached ) {
		var bonusFactor, tooMuch, bonus, meanDensity;

		//experimental
		if (cfg.algorithm === "saveData" ){
			if ( lowerValue > 2.7 ) {
				meanDensity = dprValue + 1;
			} else {
				tooMuch = higherValue - dprValue;
				bonusFactor = Math.pow(lowerValue - 0.6, 1.5);

				bonus = tooMuch * bonusFactor;

				if (isCached) {
					bonus += 0.1 * bonusFactor;
				}

				meanDensity = lowerValue + bonus;
			}
		} else {
			meanDensity = (dprValue > 1) ?
				Math.sqrt(lowerValue * higherValue) :
				lowerValue;
		}

		return meanDensity > dprValue;
	}

	function applyBestCandidate( img ) {
		var srcSetCandidates;
		var matchingSet = pf.getSet( img );
		var evaluated = false;
		if ( matchingSet !== "pending" ) {
			evaluated = evalId;
			if ( matchingSet ) {
				srcSetCandidates = pf.setRes( matchingSet );
				pf.applySetCandidate( srcSetCandidates, img );
			}
		}
		img[ pf.ns ].evaled = evaluated;
	}

	function ascendingSort( a, b ) {
		return a.res - b.res;
	}

	function setSrcToCur( img, src, set ) {
		var candidate;
		if ( !set && src ) {
			set = img[ pf.ns ].sets;
			set = set && set[set.length - 1];
		}

		candidate = getCandidateForSrc(src, set);

		if ( candidate ) {
			src = pf.makeUrl(src);
			img[ pf.ns ].curSrc = src;
			img[ pf.ns ].curCan = candidate;

			if ( !candidate.res ) {
				setResolution( candidate, candidate.set.sizes );
			}
		}
		return candidate;
	}

	function getCandidateForSrc( src, set ) {
		var i, candidate, candidates;
		if ( src && set ) {
			candidates = pf.parseSet( set );
			src = pf.makeUrl(src);
			for ( i = 0; i < candidates.length; i++ ) {
				if ( src === pf.makeUrl(candidates[ i ].url) ) {
					candidate = candidates[ i ];
					break;
				}
			}
		}
		return candidate;
	}

	function getAllSourceElements( picture, candidates ) {
		var i, len, source, srcset;

		// SPEC mismatch intended for size and perf:
		// actually only source elements preceding the img should be used
		// also note: don't use qsa here, because IE8 sometimes doesn't like source as the key part in a selector
		var sources = picture.getElementsByTagName( "source" );

		for ( i = 0, len = sources.length; i < len; i++ ) {
			source = sources[ i ];
			source[ pf.ns ] = true;
			srcset = source.getAttribute( "srcset" );

			// if source does not have a srcset attribute, skip
			if ( srcset ) {
				candidates.push( {
					srcset: srcset,
					media: source.getAttribute( "media" ),
					type: source.getAttribute( "type" ),
					sizes: source.getAttribute( "sizes" )
				} );
			}
		}
	}

	/**
	 * Srcset Parser
	 * By Alex Bell |  MIT License
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_, set:_(????)}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 */

	// 1. Let input be the value passed to this algorithm.
	// (TO-DO : Explain what "set" argument is here. Maybe choose a more
	// descriptive & more searchable name.  Since passing the "set" in really has
	// nothing to do with parsing proper, I would prefer this assignment eventually
	// go in an external fn.)
	function parseSrcset(input, set) {

		function collectCharacters(regEx) {
			var chars,
			    match = regEx.exec(input.substring(pos));
			if (match) {
				chars = match[ 0 ];
				pos += chars.length;
				return chars;
			}
		}

		var inputLength = input.length,
		    url,
		    descriptors,
		    currentDescriptor,
		    state,
		    c,

		    // 2. Let position be a pointer into input, initially pointing at the start
		    //    of the string.
		    pos = 0,

		    // 3. Let candidates be an initially empty source set.
		    candidates = [];

		/**
		* Adds descriptor properties to a candidate, pushes to the candidates array
		* @return undefined
		*/
		// (Declared outside of the while loop so that it's only created once.
		// (This fn is defined before it is used, in order to pass JSHINT.
		// Unfortunately this breaks the sequencing of the spec comments. :/ )
		function parseDescriptors() {

			// 9. Descriptor parser: Let error be no.
			var pError = false,

			// 10. Let width be absent.
			// 11. Let density be absent.
			// 12. Let future-compat-h be absent. (We're implementing it now as h)
			    w, d, h, i,
			    candidate = {},
			    desc, lastChar, value, intVal, floatVal;

			// 13. For each descriptor in descriptors, run the appropriate set of steps
			// from the following list:
			for (i = 0 ; i < descriptors.length; i++) {
				desc = descriptors[ i ];

				lastChar = desc[ desc.length - 1 ];
				value = desc.substring(0, desc.length - 1);
				intVal = parseInt(value, 10);
				floatVal = parseFloat(value);

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0077 LATIN SMALL LETTER W character
				if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

					// If width and density are not both absent, then let error be yes.
					if (w || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes.
					// Otherwise, let width be the result.
					if (intVal === 0) {pError = true;} else {w = intVal;}

				// If the descriptor consists of a valid floating-point number followed by
				// a U+0078 LATIN SMALL LETTER X character
				} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

					// If width, density and future-compat-h are not all absent, then let error
					// be yes.
					if (w || d || h) {pError = true;}

					// Apply the rules for parsing floating-point number values to the descriptor.
					// If the result is less than zero, let error be yes. Otherwise, let density
					// be the result.
					if (floatVal < 0) {pError = true;} else {d = floatVal;}

				// If the descriptor consists of a valid non-negative integer followed by
				// a U+0068 LATIN SMALL LETTER H character
				} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

					// If height and density are not both absent, then let error be yes.
					if (h || d) {pError = true;}

					// Apply the rules for parsing non-negative integers to the descriptor.
					// If the result is zero, let error be yes. Otherwise, let future-compat-h
					// be the result.
					if (intVal === 0) {pError = true;} else {h = intVal;}

				// Anything else, Let error be yes.
				} else {pError = true;}
			} // (close step 13 for loop)

			// 15. If error is still no, then append a new image source to candidates whose
			// URL is url, associated with a width width if not absent and a pixel
			// density density if not absent. Otherwise, there is a parse error.
			if (!pError) {
				candidate.url = url;

				if (w) { candidate.w = w;}
				if (d) { candidate.d = d;}
				if (h) { candidate.h = h;}
				if (!h && !d && !w) {candidate.d = 1;}
				if (candidate.d === 1) {set.has1x = true;}
				candidate.set = set;

				candidates.push(candidate);
			}
		} // (close parseDescriptors fn)

		/**
		* Tokenizes descriptor properties prior to parsing
		* Returns undefined.
		* (Again, this fn is defined before it is used, in order to pass JSHINT.
		* Unfortunately this breaks the logical sequencing of the spec comments. :/ )
		*/
		function tokenize() {

			// 8.1. Descriptor tokeniser: Skip whitespace
			collectCharacters(regexLeadingSpaces);

			// 8.2. Let current descriptor be the empty string.
			currentDescriptor = "";

			// 8.3. Let state be in descriptor.
			state = "in descriptor";

			while (true) {

				// 8.4. Let c be the character at position.
				c = input.charAt(pos);

				//  Do the following depending on the value of state.
				//  For the purpose of this step, "EOF" is a special character representing
				//  that position is past the end of input.

				// In descriptor
				if (state === "in descriptor") {
					// Do the following, depending on the value of c:

				  // Space character
				  // If current descriptor is not empty, append current descriptor to
				  // descriptors and let current descriptor be the empty string.
				  // Set state to after descriptor.
					if (isSpace(c)) {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
							currentDescriptor = "";
							state = "after descriptor";
						}

					// U+002C COMMA (,)
					// Advance position to the next character in input. If current descriptor
					// is not empty, append current descriptor to descriptors. Jump to the step
					// labeled descriptor parser.
					} else if (c === ",") {
						pos += 1;
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// U+0028 LEFT PARENTHESIS (()
					// Append c to current descriptor. Set state to in parens.
					} else if (c === "\u0028") {
						currentDescriptor = currentDescriptor + c;
						state = "in parens";

					// EOF
					// If current descriptor is not empty, append current descriptor to
					// descriptors. Jump to the step labeled descriptor parser.
					} else if (c === "") {
						if (currentDescriptor) {
							descriptors.push(currentDescriptor);
						}
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}
				// (end "in descriptor"

				// In parens
				} else if (state === "in parens") {

					// U+0029 RIGHT PARENTHESIS ())
					// Append c to current descriptor. Set state to in descriptor.
					if (c === ")") {
						currentDescriptor = currentDescriptor + c;
						state = "in descriptor";

					// EOF
					// Append current descriptor to descriptors. Jump to the step labeled
					// descriptor parser.
					} else if (c === "") {
						descriptors.push(currentDescriptor);
						parseDescriptors();
						return;

					// Anything else
					// Append c to current descriptor.
					} else {
						currentDescriptor = currentDescriptor + c;
					}

				// After descriptor
				} else if (state === "after descriptor") {

					// Do the following, depending on the value of c:
					// Space character: Stay in this state.
					if (isSpace(c)) {

					// EOF: Jump to the step labeled descriptor parser.
					} else if (c === "") {
						parseDescriptors();
						return;

					// Anything else
					// Set state to in descriptor. Set position to the previous character in input.
					} else {
						state = "in descriptor";
						pos -= 1;

					}
				}

				// Advance position to the next character in input.
				pos += 1;

			// Repeat this step.
			} // (close while true loop)
		}

		// 4. Splitting loop: Collect a sequence of characters that are space
		//    characters or U+002C COMMA characters. If any U+002C COMMA characters
		//    were collected, that is a parse error.
		while (true) {
			collectCharacters(regexLeadingCommasOrSpaces);

			// 5. If position is past the end of input, return candidates and abort these steps.
			if (pos >= inputLength) {
				return candidates; // (we're done, this is the sole return path)
			}

			// 6. Collect a sequence of characters that are not space characters,
			//    and let that be url.
			url = collectCharacters(regexLeadingNotSpaces);

			// 7. Let descriptors be a new empty list.
			descriptors = [];

			// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
			//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
			//         more than one character, that is a parse error.
			if (url.slice(-1) === ",") {
				url = url.replace(regexTrailingCommas, "");
				// (Jump ahead to step 9 to skip tokenization and just push the candidate).
				parseDescriptors();

			//	Otherwise, follow these substeps:
			} else {
				tokenize();
			} // (close else of step 8)

		// 16. Return to the step labeled splitting loop.
		} // (Close of big while loop.)
	}

	/*
	 * Sizes Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * Non-strict but accurate and lightweight JS Parser for the string value <img sizes="here">
	 *
	 * Reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-sizes-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 *
	 * Grammar is:
	 * <source-size-list> = <source-size># [ , <source-size-value> ]? | <source-size-value>
	 * <source-size> = <media-condition> <source-size-value>
	 * <source-size-value> = <length>
	 * http://www.w3.org/html/wg/drafts/html/master/embedded-content.html#attr-img-sizes
	 *
	 * E.g. "(max-width: 30em) 100vw, (max-width: 50em) 70vw, 100vw"
	 * or "(min-width: 30em), calc(30vw - 15px)" or just "30vw"
	 *
	 * Returns the first valid <css-length> with a media condition that evaluates to true,
	 * or "100vw" if all valid media conditions evaluate to false.
	 *
	 */

	function parseSizes(strValue) {

		// (Percentage CSS lengths are not allowed in this case, to avoid confusion:
		// https://html.spec.whatwg.org/multipage/embedded-content.html#valid-source-size-list
		// CSS allows a single optional plus or minus sign:
		// http://www.w3.org/TR/CSS2/syndata.html#numbers
		// CSS is ASCII case-insensitive:
		// http://www.w3.org/TR/CSS2/syndata.html#characters )
		// Spec allows exponential notation for <number> type:
		// http://dev.w3.org/csswg/css-values/#numbers
		var regexCssLengthWithUnits = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i;

		// (This is a quick and lenient test. Because of optional unlimited-depth internal
		// grouping parens and strict spacing rules, this could get very complicated.)
		var regexCssCalc = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;

		var i;
		var unparsedSizesList;
		var unparsedSizesListLength;
		var unparsedSize;
		var lastComponentValue;
		var size;

		// UTILITY FUNCTIONS

		//  (Toy CSS parser. The goals here are:
		//  1) expansive test coverage without the weight of a full CSS parser.
		//  2) Avoiding regex wherever convenient.
		//  Quick tests: http://jsfiddle.net/gtntL4gr/3/
		//  Returns an array of arrays.)
		function parseComponentValues(str) {
			var chrctr;
			var component = "";
			var componentArray = [];
			var listArray = [];
			var parenDepth = 0;
			var pos = 0;
			var inComment = false;

			function pushComponent() {
				if (component) {
					componentArray.push(component);
					component = "";
				}
			}

			function pushComponentArray() {
				if (componentArray[0]) {
					listArray.push(componentArray);
					componentArray = [];
				}
			}

			// (Loop forwards from the beginning of the string.)
			while (true) {
				chrctr = str.charAt(pos);

				if (chrctr === "") { // ( End of string reached.)
					pushComponent();
					pushComponentArray();
					return listArray;
				} else if (inComment) {
					if ((chrctr === "*") && (str[pos + 1] === "/")) { // (At end of a comment.)
						inComment = false;
						pos += 2;
						pushComponent();
						continue;
					} else {
						pos += 1; // (Skip all characters inside comments.)
						continue;
					}
				} else if (isSpace(chrctr)) {
					// (If previous character in loop was also a space, or if
					// at the beginning of the string, do not add space char to
					// component.)
					if ( (str.charAt(pos - 1) && isSpace( str.charAt(pos - 1) ) ) || !component ) {
						pos += 1;
						continue;
					} else if (parenDepth === 0) {
						pushComponent();
						pos +=1;
						continue;
					} else {
						// (Replace any space character with a plain space for legibility.)
						chrctr = " ";
					}
				} else if (chrctr === "(") {
					parenDepth += 1;
				} else if (chrctr === ")") {
					parenDepth -= 1;
				} else if (chrctr === ",") {
					pushComponent();
					pushComponentArray();
					pos += 1;
					continue;
				} else if ( (chrctr === "/") && (str.charAt(pos + 1) === "*") ) {
					inComment = true;
					pos += 2;
					continue;
				}

				component = component + chrctr;
				pos += 1;
			}
		}

		function isValidNonNegativeSourceSizeValue(s) {
			if (regexCssLengthWithUnits.test(s) && (parseFloat(s) >= 0)) {return true;}
			if (regexCssCalc.test(s)) {return true;}
			// ( http://www.w3.org/TR/CSS2/syndata.html#numbers says:
			// "-0 is equivalent to 0 and is not a negative number." which means that
			// unitless zero and unitless negative zero must be accepted as special cases.)
			if ((s === "0") || (s === "-0") || (s === "+0")) {return true;}
			return false;
		}

		// When asked to parse a sizes attribute from an element, parse a
		// comma-separated list of component values from the value of the element's
		// sizes attribute (or the empty string, if the attribute is absent), and let
		// unparsed sizes list be the result.
		// http://dev.w3.org/csswg/css-syntax/#parse-comma-separated-list-of-component-values

		unparsedSizesList = parseComponentValues(strValue);
		unparsedSizesListLength = unparsedSizesList.length;

		// For each unparsed size in unparsed sizes list:
		for (i = 0; i < unparsedSizesListLength; i++) {
			unparsedSize = unparsedSizesList[i];

			// 1. Remove all consecutive <whitespace-token>s from the end of unparsed size.
			// ( parseComponentValues() already omits spaces outside of parens. )

			// If unparsed size is now empty, that is a parse error; continue to the next
			// iteration of this algorithm.
			// ( parseComponentValues() won't push an empty array. )

			// 2. If the last component value in unparsed size is a valid non-negative
			// <source-size-value>, let size be its value and remove the component value
			// from unparsed size. Any CSS function other than the calc() function is
			// invalid. Otherwise, there is a parse error; continue to the next iteration
			// of this algorithm.
			// http://dev.w3.org/csswg/css-syntax/#parse-component-value
			lastComponentValue = unparsedSize[unparsedSize.length - 1];

			if (isValidNonNegativeSourceSizeValue(lastComponentValue)) {
				size = lastComponentValue;
				unparsedSize.pop();
			} else {
				continue;
			}

			// 3. Remove all consecutive <whitespace-token>s from the end of unparsed
			// size. If unparsed size is now empty, return size and exit this algorithm.
			// If this was not the last item in unparsed sizes list, that is a parse error.
			if (unparsedSize.length === 0) {
				return size;
			}

			// 4. Parse the remaining component values in unparsed size as a
			// <media-condition>. If it does not parse correctly, or it does parse
			// correctly but the <media-condition> evaluates to false, continue to the
			// next iteration of this algorithm.
			// (Parsing all possible compound media conditions in JS is heavy, complicated,
			// and the payoff is unclear. Is there ever an situation where the
			// media condition parses incorrectly but still somehow evaluates to true?
			// Can we just rely on the browser/polyfill to do it?)
			unparsedSize = unparsedSize.join(" ");
			if (!(pf.matchesMedia( unparsedSize ) ) ) {
				continue;
			}

			// 5. Return size and exit this algorithm.
			return size;
		}

		// If the above algorithm exhausts unparsed sizes list without returning a
		// size value, return 100vw.
		return "100vw";
	}

	// namespace
	pf.ns = ("pf" + new Date().getTime()).substr(0, 9);

	// srcset support test
	pf.supSrcset = "srcset" in image;
	pf.supSizes = "sizes" in image;
	pf.supPicture = !!window.HTMLPictureElement;

	// UC browser does claim to support srcset and picture, but not sizes,
	// this extended test reveals the browser does support nothing
	if (pf.supSrcset && pf.supPicture && !pf.supSizes) {
		(function(image2) {
			image.srcset = "data:,a";
			image2.src = "data:,a";
			pf.supSrcset = image.complete === image2.complete;
			pf.supPicture = pf.supSrcset && pf.supPicture;
		})(document.createElement("img"));
	}

	// Safari9 has basic support for sizes, but does't expose the `sizes` idl attribute
	if (pf.supSrcset && !pf.supSizes) {

		(function() {
			var width2 = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==";
			var width1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
			var img = document.createElement("img");
			var test = function() {
				var width = img.width;

				if (width === 2) {
					pf.supSizes = true;
				}

				alwaysCheckWDescriptor = pf.supSrcset && !pf.supSizes;

				isSupportTestReady = true;
				// force async
				setTimeout(picturefill);
			};

			img.onload = test;
			img.onerror = test;
			img.setAttribute("sizes", "9px");

			img.srcset = width1 + " 1w," + width2 + " 9w";
			img.src = width1;
		})();

	} else {
		isSupportTestReady = true;
	}

	// using pf.qsa instead of dom traversing does scale much better,
	// especially on sites mixing responsive and non-responsive images
	pf.selShort = "picture>img,img[srcset]";
	pf.sel = pf.selShort;
	pf.cfg = cfg;

	/**
	 * Shortcut property for `devicePixelRatio` ( for easy overriding in tests )
	 */
	pf.DPR = (DPR  || 1 );
	pf.u = units;

	// container of supported mime types that one might need to qualify before using
	pf.types =  types;

	pf.setSize = noop;

	/**
	 * Gets a string and returns the absolute URL
	 * @param src
	 * @returns {String} absolute URL
	 */

	pf.makeUrl = memoize(function(src) {
		anchor.href = src;
		return anchor.href;
	});

	/**
	 * Gets a DOM element or document and a selctor and returns the found matches
	 * Can be extended with jQuery/Sizzle for IE7 support
	 * @param context
	 * @param sel
	 * @returns {NodeList|Array}
	 */
	pf.qsa = function(context, sel) {
		return ( "querySelector" in context ) ? context.querySelectorAll(sel) : [];
	};

	/**
	 * Shortcut method for matchMedia ( for easy overriding in tests )
	 * wether native or pf.mMQ is used will be decided lazy on first call
	 * @returns {boolean}
	 */
	pf.matchesMedia = function() {
		if ( window.matchMedia && (matchMedia( "(min-width: 0.1em)" ) || {}).matches ) {
			pf.matchesMedia = function( media ) {
				return !media || ( matchMedia( media ).matches );
			};
		} else {
			pf.matchesMedia = pf.mMQ;
		}

		return pf.matchesMedia.apply( this, arguments );
	};

	/**
	 * A simplified matchMedia implementation for IE8 and IE9
	 * handles only min-width/max-width with px or em values
	 * @param media
	 * @returns {boolean}
	 */
	pf.mMQ = function( media ) {
		return media ? evalCSS(media) : true;
	};

	/**
	 * Returns the calculated length in css pixel from the given sourceSizeValue
	 * http://dev.w3.org/csswg/css-values-3/#length-value
	 * intended Spec mismatches:
	 * * Does not check for invalid use of CSS functions
	 * * Does handle a computed length of 0 the same as a negative and therefore invalid value
	 * @param sourceSizeValue
	 * @returns {Number}
	 */
	pf.calcLength = function( sourceSizeValue ) {

		var value = evalCSS(sourceSizeValue, true) || false;
		if (value < 0) {
			value = false;
		}

		return value;
	};

	/**
	 * Takes a type string and checks if its supported
	 */

	pf.supportsType = function( type ) {
		return ( type ) ? types[ type ] : true;
	};

	/**
	 * Parses a sourceSize into mediaCondition (media) and sourceSizeValue (length)
	 * @param sourceSizeStr
	 * @returns {*}
	 */
	pf.parseSize = memoize(function( sourceSizeStr ) {
		var match = ( sourceSizeStr || "" ).match(regSize);
		return {
			media: match && match[1],
			length: match && match[2]
		};
	});

	pf.parseSet = function( set ) {
		if ( !set.cands ) {
			set.cands = parseSrcset(set.srcset, set);
		}
		return set.cands;
	};

	/**
	 * returns 1em in css px for html/body default size
	 * function taken from respondjs
	 * @returns {*|number}
	 */
	pf.getEmValue = function() {
		var body;
		if ( !eminpx && (body = document.body) ) {
			var div = document.createElement( "div" ),
				originalHTMLCSS = docElem.style.cssText,
				originalBodyCSS = body.style.cssText;

			div.style.cssText = baseStyle;

			// 1em in a media query is the value of the default font size of the browser
			// reset docElem and body to ensure the correct value is returned
			docElem.style.cssText = fsCss;
			body.style.cssText = fsCss;

			body.appendChild( div );
			eminpx = div.offsetWidth;
			body.removeChild( div );

			//also update eminpx before returning
			eminpx = parseFloat( eminpx, 10 );

			// restore the original values
			docElem.style.cssText = originalHTMLCSS;
			body.style.cssText = originalBodyCSS;

		}
		return eminpx || 16;
	};

	/**
	 * Takes a string of sizes and returns the width in pixels as a number
	 */
	pf.calcListLength = function( sourceSizeListStr ) {
		// Split up source size list, ie ( max-width: 30em ) 100%, ( max-width: 50em ) 50%, 33%
		//
		//                           or (min-width:30em) calc(30% - 15px)
		if ( !(sourceSizeListStr in sizeLengthCache) || cfg.uT ) {
			var winningLength = pf.calcLength( parseSizes( sourceSizeListStr ) );

			sizeLengthCache[ sourceSizeListStr ] = !winningLength ? units.width : winningLength;
		}

		return sizeLengthCache[ sourceSizeListStr ];
	};

	/**
	 * Takes a candidate object with a srcset property in the form of url/
	 * ex. "images/pic-medium.png 1x, images/pic-medium-2x.png 2x" or
	 *     "images/pic-medium.png 400w, images/pic-medium-2x.png 800w" or
	 *     "images/pic-small.png"
	 * Get an array of image candidates in the form of
	 *      {url: "/foo/bar.png", resolution: 1}
	 * where resolution is http://dev.w3.org/csswg/css-values-3/#resolution-value
	 * If sizes is specified, res is calculated
	 */
	pf.setRes = function( set ) {
		var candidates;
		if ( set ) {

			candidates = pf.parseSet( set );

			for ( var i = 0, len = candidates.length; i < len; i++ ) {
				setResolution( candidates[ i ], set.sizes );
			}
		}
		return candidates;
	};

	pf.setRes.res = setResolution;

	pf.applySetCandidate = function( candidates, img ) {
		if ( !candidates.length ) {return;}
		var candidate,
			i,
			j,
			length,
			bestCandidate,
			curSrc,
			curCan,
			candidateSrc,
			abortCurSrc;

		var imageData = img[ pf.ns ];
		var dpr = pf.DPR;

		curSrc = imageData.curSrc || img[curSrcProp];

		curCan = imageData.curCan || setSrcToCur(img, curSrc, candidates[0].set);

		// if we have a current source, we might either become lazy or give this source some advantage
		if ( curCan && curCan.set === candidates[ 0 ].set ) {

			// if browser can abort image request and the image has a higher pixel density than needed
			// and this image isn't downloaded yet, we skip next part and try to save bandwidth
			abortCurSrc = (supportAbort && !img.complete && curCan.res - 0.1 > dpr);

			if ( !abortCurSrc ) {
				curCan.cached = true;

				// if current candidate is "best", "better" or "okay",
				// set it to bestCandidate
				if ( curCan.res >= dpr ) {
					bestCandidate = curCan;
				}
			}
		}

		if ( !bestCandidate ) {

			candidates.sort( ascendingSort );

			length = candidates.length;
			bestCandidate = candidates[ length - 1 ];

			for ( i = 0; i < length; i++ ) {
				candidate = candidates[ i ];
				if ( candidate.res >= dpr ) {
					j = i - 1;

					// we have found the perfect candidate,
					// but let's improve this a little bit with some assumptions ;-)
					if (candidates[ j ] &&
						(abortCurSrc || curSrc !== pf.makeUrl( candidate.url )) &&
						chooseLowRes(candidates[ j ].res, candidate.res, dpr, candidates[ j ].cached)) {

						bestCandidate = candidates[ j ];

					} else {
						bestCandidate = candidate;
					}
					break;
				}
			}
		}

		if ( bestCandidate ) {

			candidateSrc = pf.makeUrl( bestCandidate.url );

			imageData.curSrc = candidateSrc;
			imageData.curCan = bestCandidate;

			if ( candidateSrc !== curSrc ) {
				pf.setSrc( img, bestCandidate );
			}
			pf.setSize( img );
		}
	};

	pf.setSrc = function( img, bestCandidate ) {
		var origWidth;
		img.src = bestCandidate.url;

		// although this is a specific Safari issue, we don't want to take too much different code paths
		if ( bestCandidate.set.type === "image/svg+xml" ) {
			origWidth = img.style.width;
			img.style.width = (img.offsetWidth + 1) + "px";

			// next line only should trigger a repaint
			// if... is only done to trick dead code removal
			if ( img.offsetWidth + 1 ) {
				img.style.width = origWidth;
			}
		}
	};

	pf.getSet = function( img ) {
		var i, set, supportsType;
		var match = false;
		var sets = img [ pf.ns ].sets;

		for ( i = 0; i < sets.length && !match; i++ ) {
			set = sets[i];

			if ( !set.srcset || !pf.matchesMedia( set.media ) || !(supportsType = pf.supportsType( set.type )) ) {
				continue;
			}

			if ( supportsType === "pending" ) {
				set = supportsType;
			}

			match = set;
			break;
		}

		return match;
	};

	pf.parseSets = function( element, parent, options ) {
		var srcsetAttribute, imageSet, isWDescripor, srcsetParsed;

		var hasPicture = parent && parent.nodeName.toUpperCase() === "PICTURE";
		var imageData = element[ pf.ns ];

		if ( imageData.src === undefined || options.src ) {
			imageData.src = getImgAttr.call( element, "src" );
			if ( imageData.src ) {
				setImgAttr.call( element, srcAttr, imageData.src );
			} else {
				removeImgAttr.call( element, srcAttr );
			}
		}

		if ( imageData.srcset === undefined || options.srcset || !pf.supSrcset || element.srcset ) {
			srcsetAttribute = getImgAttr.call( element, "srcset" );
			imageData.srcset = srcsetAttribute;
			srcsetParsed = true;
		}

		imageData.sets = [];

		if ( hasPicture ) {
			imageData.pic = true;
			getAllSourceElements( parent, imageData.sets );
		}

		if ( imageData.srcset ) {
			imageSet = {
				srcset: imageData.srcset,
				sizes: getImgAttr.call( element, "sizes" )
			};

			imageData.sets.push( imageSet );

			isWDescripor = (alwaysCheckWDescriptor || imageData.src) && regWDesc.test(imageData.srcset || "");

			// add normal src as candidate, if source has no w descriptor
			if ( !isWDescripor && imageData.src && !getCandidateForSrc(imageData.src, imageSet) && !imageSet.has1x ) {
				imageSet.srcset += ", " + imageData.src;
				imageSet.cands.push({
					url: imageData.src,
					d: 1,
					set: imageSet
				});
			}

		} else if ( imageData.src ) {
			imageData.sets.push( {
				srcset: imageData.src,
				sizes: null
			} );
		}

		imageData.curCan = null;
		imageData.curSrc = undefined;

		// if img has picture or the srcset was removed or has a srcset and does not support srcset at all
		// or has a w descriptor (and does not support sizes) set support to false to evaluate
		imageData.supported = !( hasPicture || ( imageSet && !pf.supSrcset ) || (isWDescripor && !pf.supSizes) );

		if ( srcsetParsed && pf.supSrcset && !imageData.supported ) {
			if ( srcsetAttribute ) {
				setImgAttr.call( element, srcsetAttr, srcsetAttribute );
				element.srcset = "";
			} else {
				removeImgAttr.call( element, srcsetAttr );
			}
		}

		if (imageData.supported && !imageData.srcset && ((!imageData.src && element.src) ||  element.src !== pf.makeUrl(imageData.src))) {
			if (imageData.src === null) {
				element.removeAttribute("src");
			} else {
				element.src = imageData.src;
			}
		}

		imageData.parsed = true;
	};

	pf.fillImg = function(element, options) {
		var imageData;
		var extreme = options.reselect || options.reevaluate;

		// expando for caching data on the img
		if ( !element[ pf.ns ] ) {
			element[ pf.ns ] = {};
		}

		imageData = element[ pf.ns ];

		// if the element has already been evaluated, skip it
		// unless `options.reevaluate` is set to true ( this, for example,
		// is set to true when running `picturefill` on `resize` ).
		if ( !extreme && imageData.evaled === evalId ) {
			return;
		}

		if ( !imageData.parsed || options.reevaluate ) {
			pf.parseSets( element, element.parentNode, options );
		}

		if ( !imageData.supported ) {
			applyBestCandidate( element );
		} else {
			imageData.evaled = evalId;
		}
	};

	pf.setupRun = function() {
		if ( !alreadyRun || isVwDirty || (DPR !== window.devicePixelRatio) ) {
			updateMetrics();
		}
	};

	// If picture is supported, well, that's awesome.
	if ( pf.supPicture ) {
		picturefill = noop;
		pf.fillImg = noop;
	} else {

		 // Set up picture polyfill by polling the document
		(function() {
			var isDomReady;
			var regReady = window.attachEvent ? /d$|^c/ : /d$|^c|^i/;

			var run = function() {
				var readyState = document.readyState || "";

				timerId = setTimeout(run, readyState === "loading" ? 200 :  999);
				if ( document.body ) {
					pf.fillImgs();
					isDomReady = isDomReady || regReady.test(readyState);
					if ( isDomReady ) {
						clearTimeout( timerId );
					}

				}
			};

			var timerId = setTimeout(run, document.body ? 9 : 99);

			// Also attach picturefill on resize and readystatechange
			// http://modernjavascript.blogspot.com/2013/08/building-better-debounce.html
			var debounce = function(func, wait) {
				var timeout, timestamp;
				var later = function() {
					var last = (new Date()) - timestamp;

					if (last < wait) {
						timeout = setTimeout(later, wait - last);
					} else {
						timeout = null;
						func();
					}
				};

				return function() {
					timestamp = new Date();

					if (!timeout) {
						timeout = setTimeout(later, wait);
					}
				};
			};
			var lastClientWidth = docElem.clientHeight;
			var onResize = function() {
				isVwDirty = Math.max(window.innerWidth || 0, docElem.clientWidth) !== units.width || docElem.clientHeight !== lastClientWidth;
				lastClientWidth = docElem.clientHeight;
				if ( isVwDirty ) {
					pf.fillImgs();
				}
			};

			on( window, "resize", debounce(onResize, 99 ) );
			on( document, "readystatechange", run );
		})();
	}

	pf.picturefill = picturefill;
	//use this internally for easy monkey patching/performance testing
	pf.fillImgs = picturefill;
	pf.teardownRun = noop;

	/* expose methods for testing */
	picturefill._ = pf;

	window.picturefillCFG = {
		pf: pf,
		push: function(args) {
			var name = args.shift();
			if (typeof pf[name] === "function") {
				pf[name].apply(pf, args);
			} else {
				cfg[name] = args[0];
				if (alreadyRun) {
					pf.fillImgs( { reselect: true } );
				}
			}
		}
	};

	while (setOptions && setOptions.length) {
		window.picturefillCFG.push(setOptions.shift());
	}

	/* expose picturefill */
	window.picturefill = picturefill;

	/* expose picturefill */
	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// CommonJS, just export
		module.exports = picturefill;
	} else if ( typeof define === "function" && define.amd ) {
		// AMD support
		define( "picturefill", function() { return picturefill; } );
	}

	// IE8 evals this sync, so it must be the last thing we do
	if ( !pf.supPicture ) {
		types[ "image/webp" ] = detectTypeSupport("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==" );
	}

} )( window, document );


// PARALLAC SCROLLING EFFECTS

window.addEventListener("scroll", function() {
    var scrolledHeight= window.pageYOffset;

    document.querySelectorAll(".parallax").forEach(function(el,index,array) {
        el.style.transform = "translate(0, " + -((scrolledHeight - el.offsetTop) / 3) + "px" + ")";
    });

    document.querySelectorAll(".parallax_2").forEach(function(el,index,array) {
        el.style.transform = "translate(0, " + ((scrolledHeight - el.offsetTop) / 3) + "px" + ")";
    });
});


// Swiper

var swiper = new Swiper('.swiper-container', {
  pagination: {
    el: '.swiper-pagination',
  },
  autoplay: {
    delay: 4000,
  },
});
